import {
  ArrowLeft,
  Edit,
  FileText,
  Bed,
  Bath,
  Car,
  Calendar,
  View,
} from "lucide-react";
import { Trash2, Plus, Edit2, Upload, ExternalLink, MapPin, DollarSign, X, Check, Save, User, UserPlus, ChevronRight, ChevronLeft, MessageSquare, AlertCircle, Clock, PauseCircle, Building2, Users2, Trash, Mail, Phone, Tag, Eye, CheckCircle2, XCircle, ChevronDown, Copy, Loader2, Lock, StickyNote, SlidersHorizontal, Send } from 'lucide-react';
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { Badge, Button, Card, CardContent, CardHeader, CardTitle, Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from "../ui";
import PropertyDocumentsPage from "./ViewDocuments";
import PropertyActivityLog from "../../features/properties/components/PropertyActivityLog";
import ComplianceTab from "../../features/compliance/components/ComplianceTab";
import ComplianceChecklistCard from "../../features/compliance/components/ComplianceChecklistCard";
import { isPriceReasonRequired, usePriceChangeReason } from "../../features/compliance/components/PriceChangeReasonModal";
import PublicMatchBadge from "../../features/properties/components/PublicMatchBadge";
import CampaignSwitch from "../../features/properties/components/CampaignSwitch";
import PropertyNotificationsTab from "./PropertyNotificationsTab";
import PriceReductionAlerts from "./PriceReductionAlerts";
import OpenHomesTab from "../../features/properties/components/OpenHomesTab";
import { useEffect, useState, useRef, useMemo } from "react";
import {
  getProperty, updateProperty, uploadPropertyDocuments,
  uploadStatementOfInfo, deletePropertyDocument,
  getPropertyNotes,
  createPropertyNote,
  updatePropertyNote,
  deletePropertyNote,
  patchProperty,
  getAgents,
  reorderPropertyImages,
  getProperties,
  deleteProperty,
  registerProperty,
  publishSoldToPortals,
  withdrawProperty,
  markPropertyLeased,
  createAppraisalReminders,
  draftArticle,
  markPropertyListed,
} from "../../api/agent";
import ManageGalleryDialog from "./ManageGalleryDialog";
import {
  getPropertyEnquiries,
  createPropertyEnquiry,
  getPropertyBidderRegistrations,
  getPropertyOffers,
  updateEnquiry,
  updateBidderRegistration,
  updateOffer,
  getPropertyVendorStatus,
  resendPropertyVendorInvite,
  sendPropertyClaimInvite,
  confirmMutualAcceptance,
  getPropertyBuyers,
  addPropertyBuyer,
  removePropertyBuyer,
  sendBuyerContractOfSale,
} from "../../api/propertyManagement";
import { getContacts, inviteContactToPortal, getLatestNotes, resolveContactIdentity, markContactCalled } from "../../api/contact";
import esignApi from "../../api/esign";
import { ignoreLead } from "../../api/lead";
import { useSelector } from "react-redux";
import LazyImage from "../common/LazyImage";
import toast from "react-hot-toast";
import DomainDescriptionCounter from "../common/DomainDescriptionCounter";
import { notifyDomainResult } from "../../utils/domainPublishToast";
import {
  SUPPORTED_UPLOAD_ACCEPT,
  splitSupportedUploads,
  rejectedUploadsMessage,
} from "../../utils/imageUploadGuard";
import { invalidateCache } from "../../lib/cache";
import ConfirmModal from "../common/ConfirmModal";
import PropertyWithdrawControls from "../common/PropertyWithdrawControls";
import MarkSoldModal from "../common/MarkSoldModal";
import { promptPublishSold } from "../common/publishSoldPrompt";
import { buildSaleDetailsPatch, contractDateOf, defaultSoldDate } from "../../features/properties/utils/saleDetails";
import MarkLeasedModal from "../common/MarkLeasedModal";
import PublishSoldToPortalsModal from "../common/PublishSoldToPortalsModal";
import { buildLeaseUpdateData } from "../common/leaseUpdate";
import PortalAttributionPicker from "../common/PortalAttributionPicker";
import AddOwnerModal from "./modals/AddOwnerModal";
import AddPurchaserModal from "./modals/AddPurchaserModal";
import AddBuyerModal from "./modals/AddBuyerModal";
import EditAttendeeModal from "./modals/EditAttendeeModal";
import EditBuyerModal from "./modals/EditBuyerModal";
import AddEnquiryModal from "./modals/AddEnquiryModal";
import DuplicatePropertyModal from "./modals/DuplicatePropertyModal";
import { addAdditionalOwner, deleteAdditionalOwner } from "../../api/publicApi";
import { getInspections, sendContractOfSale } from "../../api/inspection";
import CalledButton from "./CalledButton";
import FindBuyersForProperty, { MessageMatchesModal } from "../../features/analytics/components/FindBuyersForProperty";
import FindRentersForProperty from "../../features/analytics/components/FindRentersForProperty";
import { fetchRenterMatchCount } from "../../features/analytics/api/analyticsApi";
import AppraisalReminderSeries from "../../features/leads/components/AppraisalReminderSeries";
import ContactNotesButton from "../../features/contacts/components/ContactNotesButton";
import ContactLink from "../../features/contacts/components/ContactLink";
import ContactGeneralInfoCard from "../../features/contacts/components/ContactGeneralInfoCard";
import BuyerPreferencesModal from "../../features/contacts/components/BuyerPreferencesModal";
import RentingPreferencesModal from "../../features/contacts/components/RentingPreferencesModal";
import { offerStatusPillClasses, offerStatusLabel } from "../../features/offers/utils/offerStatusStyles";
import { calculateBond } from "../../features/properties/utils/rentBond";
import LeadPreviewModal from "../leads/LeadPreviewModal";
import SendToVendorModal from "../../features/offers/components/SendToVendorModal";
import SendToBuyerModal from "../../features/offers/components/SendToBuyerModal";
import CounterToBuyerModal from "../../features/offers/components/CounterToBuyerModal";
import OfferTimelineModal from "../../features/offers/components/OfferTimelineModal";
import PropertyAnalyticsTimeline from "./PropertyAnalyticsTimeline";
import PropertyCampaignDashboard from "./analytics/PropertyCampaignDashboard";
import ShareLinkCard from "./ShareLinkCard";
import {
  formatMelbourneDatePart,
  formatMelbourneTimePart,
  formatMelbourneDateTime,
  melbourneWallTimeToUtcISOString,
  datetimeLocalToUtcISOString,
} from "../../utils/melbourneTime";
import { hasAdminAccess } from "../../utils/roleAccess";
import AgentNotesPanel from "../notes/AgentNotesPanel";
import { ownerCommsParams } from "../notes/commsTimeline";
import { fetchCommunicationTimeline } from "../../features/communications/api/communicationsApi";

// Helpers

// Normalise the purchaser(s) off a property payload into an array of
// { id, name, email, contact }. Prefers the one-to-many `purchasers` list;
// falls back to the legacy single purchaser_* fields for older records.
const derivePurchasers = (data) => {
  if (!data) return [];
  if (Array.isArray(data.purchasers) && data.purchasers.length) {
    return data.purchasers.map((p) => ({
      id: p.id ?? null,
      name: p.name || "",
      email: p.email || "",
      contact: p.contact || p.phone || "",
    }));
  }
  const legacy = data.purchaser || {};
  const name = legacy.name || data.purchaser_name || "";
  const email = legacy.email || data.purchaser_email || "";
  const contact = legacy.contact || data.purchaser_contact || "";
  if (name || email || contact) {
    return [{ id: null, name, email, contact }];
  }
  return [];
};

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num.toLocaleString(undefined, { style: "currency", currency: "AUD" });
};

const formatPrice = (price) => {
  if (!price) return null;
  const num = Number(price);
  if (isNaN(num)) return price;
  return `$${Math.round(num).toLocaleString()}`;
};

// Get price type label from price_display
const getPriceTypeLabel = (priceDisplay) => {
  const labels = {
    'exact': 'Asking Price',
    'range': 'Price Range',
    'contact': 'Contact Agent',
    'auction': 'Guided Price'
  };
  return labels[priceDisplay] || 'Asking Price';
};

// Format price display with type label
const formatPriceDisplay = (property) => {
  if (!property) return 'N/A';

  const priceDisplay = property.price_display || 'exact';
  const priceTypeLabel = getPriceTypeLabel(priceDisplay);

  // Always use the actual price value, not price_display_text
  // Get price value (check both price and price_from)
  const priceValue = property.price || property.price_from;

  // Price Range: Show "Price Range: value-value"
  if (priceDisplay === 'range') {
    const priceTo = property.price_to;
    if (priceValue && priceTo && Number(priceTo) !== Number(priceValue)) {
      return `${priceTypeLabel}: ${formatPrice(priceValue)} – ${formatPrice(priceTo)}`;
    } else if (priceValue) {
      return `${priceTypeLabel}: ${formatPrice(priceValue)}`;
    }
    return `${priceTypeLabel}`;
  }

  // Contact Agent: Show only "Contact Agent" (no value)
  if (priceDisplay === 'contact') {
    return `${priceTypeLabel}`;
  }

  // Auction: Show "Guided Price: value" if price exists
  if (priceDisplay === 'auction') {
    if (priceValue) {
      return `${priceTypeLabel}: ${formatPrice(priceValue)}`;
    }
    return `${priceTypeLabel}`;
  }

  // Asking Price (exact): Show "Asking Price: value"
  if (priceDisplay === 'exact') {
    if (priceValue) {
      return `${priceTypeLabel}: ${formatPrice(priceValue)}`;
    }
    return `${priceTypeLabel}: Contact Agent`;
  }

  // Fallback
  if (!priceValue) {
    return `${priceTypeLabel}: Contact Agent`;
  }

  return `${priceTypeLabel}: ${formatPrice(priceValue)}`;
};

const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString();
  } catch (e) {
    return iso;
  }
};

// Auction date read/write always uses Melbourne time explicitly (see
// src/utils/melbourneTime.js) - new Date(iso).getHours()/.toLocaleString()
// render in whichever timezone the VIEWER's computer happens to be set to,
// showing (and, on save, silently re-interpreting) the wrong wall-clock time
// for anyone not literally on Melbourne time. Confirmed live, 2026-08-14:
// 8/118 Miller Street's auction showed 12:30pm in the CRM and 2:30pm on
// realestate.com.au for the exact same stored instant - REA's own conversion
// (always explicitly Melbourne) was the correct one.
const formatLocalDatePart = formatMelbourneDatePart;
const formatLocalTimePart = formatMelbourneTimePart;
const formatAuctionDateTime = formatMelbourneDateTime;

export default function PropertyDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const { requestReason: requestPriceReason, reasonModal: priceReasonModal } = usePriceChangeReason();
  // Editing or deleting a purchaser's details is restricted to admins (+ devs).
  const isAdmin = hasAdminAccess(user);
  const [property, setProperty] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const _initialParams = new URLSearchParams(location.search);
  const _rawInitialTab = _initialParams.get('tab') || 'property';
  const _initialTab = _rawInitialTab === 'offers' ? 'enquiries' : _rawInitialTab;
  // `?tab=offers` is a legacy shortcut for the offers sub-tab; `?subtab=` is the
  // general form used when returning from a contact profile so the user lands
  // back on the exact sub-tab they left.
  const _rawSubTab = _initialParams.get('subtab');
  const _validSubTabs = ['enquiries', 'attendees', 'buyers', 'offers'];
  const _initialEnquiriesSubTab = _rawInitialTab === 'offers'
    ? 'offers'
    : (_validSubTabs.includes(_rawSubTab) ? _rawSubTab : 'enquiries');
  const [activeTab, setActiveTab] = useState(_initialTab);
  const [renterMatchCount, setRenterMatchCount] = useState(null);
  // Per-property matching-renter counts for the lease-listing badge.
  useEffect(() => {
    let cancelled = false;
    const id = property?.id;
    if (!id || property?.transaction_type !== 'lease') {
      setRenterMatchCount(null);
      return;
    }
    (async () => {
      try {
        const c = await fetchRenterMatchCount(id);
        if (!cancelled) setRenterMatchCount(c);
      } catch (e) {
        if (!cancelled) setRenterMatchCount(null);
      }
    })();
    return () => { cancelled = true; };
  }, [property?.id, property?.transaction_type]);
  const [owners, setOwners] = useState([]);
  const [purchasers, setPurchasers] = useState([]);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState('');
  // The call-back series being stacked up next to that note, and a key that is
  // bumped after a save so the series re-reads what is now booked.
  const [noteReminders, setNoteReminders] = useState([]);
  const [noteReminderKey, setNoteReminderKey] = useState(0);
  const [isEditingInfo, setIsEditingInfo] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [descriptionEdit, setDescriptionEdit] = useState('');
  const [editForm, setEditForm] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [agents, setAgents] = useState([]);
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [isMarkingSold, setIsMarkingSold] = useState(false);
  const [isMarkingListed, setIsMarkingListed] = useState(false);
  const [isSendingClaim, setIsSendingClaim] = useState(false);
  const [showSoldModal, setShowSoldModal] = useState(false);
  const [showPublishSoldModal, setShowPublishSoldModal] = useState(false);
  // "Edit Sale Details" on a sold property: same dialog, saves without
  // toggling the sold state.
  const [showEditSaleModal, setShowEditSaleModal] = useState(false);
  const [isSavingSale, setIsSavingSale] = useState(false);
  const [isMarkingUnderContract, setIsMarkingUnderContract] = useState(false);
  const [showUnderContractModal, setShowUnderContractModal] = useState(false);
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [showPurchaserModal, setShowPurchaserModal] = useState(false);
  const [editingPurchaser, setEditingPurchaser] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [isDuplicating, setIsDuplicating] = useState(false);

  // ----- Visibility checkboxes -----
  // Each tick fires a full property save, and that save can legitimately take
  // several seconds (the realestate.com.au row really does push to REA and wait
  // on it). The boxes were purely server-driven — `checked` came straight from
  // `property` and only moved once the request came back — so a click rendered
  // as nothing at all, then the tick appeared many seconds later or not at all
  // if the request timed out. That reads as "the boxes won't let me tick them,
  // sometimes they work then just stop" (agent report, 2026-08-14).
  // Tick locally first, reconcile with the server after, revert if it failed.
  const [visibilitySaving, setVisibilitySaving] = useState({});
  // A pending REA publish awaiting the confirmation dialog (CG: nothing should
  // reach realestate.com.au without a warning popping up first).
  const [reaPublishConfirm, setReaPublishConfirm] = useState(null);

  const toggleVisibilityFlag = async (field, nextValue, options = {}) => {
    const { fields, onSaved, successMessage, failureMessage = 'Failed to update visibility', __reaConfirmed } = options;
    // A second click while the first is still in flight would race two saves of
    // the same field against each other; the box already shows the new state.
    // (The checkbox is also disabled for this same window - see isVisibilityBusy
    // below - this guard is just defense in depth against a click landing before
    // that re-render lands.)
    if (isVisibilityBusy(field)) return;
    const changes = fields || { [field]: nextValue };
    // Warn before anything is published to realestate.com.au — only when
    // turning it ON, and only until confirmed. Covers both the individual REA
    // checkbox and "tick all" (which flips published_on_rea too). Cancelling
    // leaves the box exactly as it was, because we return before the optimistic
    // state update below.
    if (changes.published_on_rea === true && !property?.published_on_rea && !__reaConfirmed) {
      setReaPublishConfirm({ field, nextValue, options });
      return;
    }
    // Snapshot what we're about to overwrite, so a failed save can put the
    // boxes back exactly as the agent found them.
    const previous = {};
    Object.keys(changes).forEach(key => { previous[key] = property?.[key]; });
    setProperty(prev => ({ ...prev, ...changes }));
    setVisibilitySaving(prev => ({ ...prev, [field]: true }));
    try {
      const res = await patchProperty(property.id, changes);
      if (onSaved) {
        await onSaved(res);
      } else if (successMessage) {
        toast.success(successMessage(nextValue));
      }
    } catch (err) {
      console.error('Update failed:', err);
      setProperty(prev => ({ ...prev, ...previous }));
      toast.error(failureMessage);
    } finally {
      setVisibilitySaving(prev => ({ ...prev, [field]: false }));
    }
  };

  // Small "Saving…" marker so a slow portal push is visibly in progress rather
  // than looking like a dead checkbox.
  const VisibilitySavingPill = ({ field }) => (
    visibilitySaving[field] ? (
      <span className="text-[9px] px-2 py-0.5 rounded-full font-bold bg-gray-100 text-[#6B7280] whitespace-nowrap animate-pulse">
        Saving…
      </span>
    ) : null
  );

  // The checkbox itself must go disabled while its save is in flight — a save
  // (especially the realestate.com.au row, which really does push to REA and
  // wait on it) can take 15-20+ seconds. Without this the box just looked
  // unresponsive to a click landing mid-save, and clicking again did nothing
  // (silently ignored to avoid racing two saves of the same field), which
  // read as "I have to click it 4-5 times to get it to work" (agent report,
  // 2026-08-13). "tick all" shares its four fields with the individual
  // checkboxes below it, so either one being busy must disable the other.
  const isVisibilityBusy = (field) => {
    if (visibilitySaving[field]) return true;
    if (field === 'tick_all') {
      return !!(visibilitySaving.internal_marketing || visibilitySaving.published_on_rea
        || visibilitySaving.published_on_domain || visibilitySaving.published_on_collings);
    }
    if (['internal_marketing', 'published_on_rea', 'published_on_domain', 'published_on_collings'].includes(field)) {
      return !!visibilitySaving.tick_all;
    }
    return false;
  };

  // Buyer Portal Interactions State
  const [enquiries, setEnquiries] = useState([]);
  const [propertyNotes, setPropertyNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [ownerComms, setOwnerComms] = useState([]);
  const [bidderRegistrations, setBidderRegistrations] = useState([]);
  const [offers, setOffers] = useState([]);
  const [inspectionAttendees, setInspectionAttendees] = useState([]);
  // Group attendees by the scheduled inspection date they checked in to, so the
  // register shows a date header (page break) per Open For Inspection and makes
  // re-attendance across dates obvious. Newest inspection first.
  const groupedInspectionAttendees = useMemo(() => {
    const groups = new Map();
    inspectionAttendees.forEach((att) => {
      const m = att.inspection_date ? moment(att.inspection_date) : null;
      const valid = m && m.isValid();
      const key = valid ? m.format('YYYY-MM-DD') : 'unknown';
      if (!groups.has(key)) {
        groups.set(key, {
          key,
          label: valid ? m.format('dddd D MMM YYYY') : 'Date not recorded',
          sortValue: valid ? m.valueOf() : -Infinity,
          attendees: [],
        });
      }
      groups.get(key).attendees.push(att);
    });
    return Array.from(groups.values()).sort((a, b) => b.sortValue - a.sortValue);
  }, [inspectionAttendees]);
  const [sendingContractAttendeeId, setSendingContractAttendeeId] = useState(null);
  const [invitingAttendeeId, setInvitingAttendeeId] = useState(null);
  // The rich server-side composer (shared with Find Buyers / Communications) for
  // the Enquiries, Buyers & Attendees tabs.
  // { context: 'enquiries'|'buyers'|'attendees', channel: 'email'|'sms' }.
  const [richComposer, setRichComposer] = useState(null);
  const [editingAttendee, setEditingAttendee] = useState(null);
  const [enquiriesSubTab, setEnquiriesSubTab] = useState(_initialEnquiriesSubTab);

  // Buying-preferences editor: identity of the person whose preferences the agent
  // is editing (across Enquiries / Attendees / Buyers rows). Null = modal closed.
  const [prefsPerson, setPrefsPerson] = useState(null);

  // Most recent CRM note per person, keyed by contact id and by email, so every
  // Buyers / Attendees / Enquiries row can show its last note stamped with who
  // left it and when (fetched in one batch call — see the effect below).
  const [latestNotesById, setLatestNotesById] = useState({});
  const [latestNotesByEmail, setLatestNotesByEmail] = useState({});

  // "Buyers" sub-tab — agent-curated buyers manually attached to this listing.
  const [propertyBuyers, setPropertyBuyers] = useState([]);
  const [showAddBuyerModal, setShowAddBuyerModal] = useState(false);
  const [editingBuyer, setEditingBuyer] = useState(null);
  const [removingBuyerLinkId, setRemovingBuyerLinkId] = useState(null);
  const [sendingContractBuyerLinkId, setSendingContractBuyerLinkId] = useState(null);
  const [invitingBuyerLinkId, setInvitingBuyerLinkId] = useState(null);
  const [sendingOfferLinkId, setSendingOfferLinkId] = useState(null);
  // The row whose Called button is mid-log (buyer.link_id / att.id / enq.id).
  const [callingId, setCallingId] = useState(null);
  const [invitingEnquiryId, setInvitingEnquiryId] = useState(null);
  const [sendingContractEnquiryId, setSendingContractEnquiryId] = useState(null);
  const [interactionsLoading, setInteractionsLoading] = useState(false);
  const [editingEnquiry, setEditingEnquiry] = useState(null);
  const [showAddEnquiryModal, setShowAddEnquiryModal] = useState(false);
  const [viewingOffer, setViewingOffer] = useState(null);
  const [isUpdatingOffer, setIsUpdatingOffer] = useState(false);
  /** Offer flow — same as CollingsPropertyDetailPage (explicit send + finalize) */
  const [sendingToVendor, setSendingToVendor] = useState(null);
  const [sendingToBuyer, setSendingToBuyer] = useState(null);
  const [counteringToBuyer, setCounteringToBuyer] = useState(null);
  const [vendorStatus, setVendorStatus] = useState(null);
  const [resendingVendorInvite, setResendingVendorInvite] = useState(false);
  const [finalizingOffer, setFinalizingOffer] = useState(null);
  const [finalizing, setFinalizing] = useState(false);
  const [timelineOffer, setTimelineOffer] = useState(null);
  // "Decline Offer" straight off the Offers tab — id of the offer being declined
  const [decliningOfferId, setDecliningOfferId] = useState(null);
  const [enquiryEditMessage, setEnquiryEditMessage] = useState('');
  const [enquiryEditAgentNotes, setEnquiryEditAgentNotes] = useState('');
  const [isUpdatingEnquiry, setIsUpdatingEnquiry] = useState(false);


  // Property Price Statement upload
  const [soiUploading, setSoiUploading] = useState(false);
  const soiFileInputRef = useRef(null);

  // Second agent: selection and "Make Secondary on Listing?" (co_agent only when ticked)
  const [secondAgentId, setSecondAgentId] = useState('');
  const [makeSecondaryAgentOnListing, setMakeSecondaryAgentOnListing] = useState(false);

  // Sync second-agent state when property loads
  useEffect(() => {
    if (property) {
      const coId = property?.co_agent?.id ?? property?.co_agent ?? '';
      setSecondAgentId(coId ? String(coId) : '');
      setMakeSecondaryAgentOnListing(!!coId);
    }
  }, [property?.id, property?.co_agent]);

  // Fetch agents for dropdowns
  useEffect(() => {
    const fetchAgentsList = async () => {
      setAgentsLoading(true);
      try {
        const res = await getAgents({ page_size: 100 });
        const agentsData = res?.data?.results || res?.data || [];
        setAgents(agentsData);
      } catch (error) {
        console.error("Failed to fetch agents:", error);
      } finally {
        setAgentsLoading(false);
      }
    };
    fetchAgentsList();
  }, []);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await getProperty(params.id);
        if (!isMounted) return;
        const data = res?.data || null;
        if (data) {
          setProperty(data);

          // Enhanced notes handling - handled by separate fetch now
          /*
          if (data.internal_notes) {
            setNewNote(data.internal_notes);
          }
          */

          // Build owners list: primary owner + additional owners
          {
            const allOwners = [];
            const primaryOwner = data.owner && (data.owner.name || data.owner.contact || data.owner.email)
              ? data.owner
              : (data.owner_name || data.owner_email || data.owner_contact)
                ? { name: data.owner_name, email: data.owner_email, contact: data.owner_contact }
                : null;
            if (primaryOwner) {
              allOwners.push({ ...primaryOwner, isPrimary: true });
            }
            (data.additional_owners || []).forEach(ao => allOwners.push({ ...ao, isPrimary: false }));
            setOwners(allOwners);
          }

          setPurchasers(derivePurchasers(data));
        }

        // Fetch Notes
        fetchPropertyNotes();

        setError(null);
      } catch (err) {
        if (!isMounted) return;
        setError(err?.response?.data?.detail || "Failed to load property");
      } finally {
        if (!isMounted) return;
        setIsLoading(false);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, [params.id]);

  // Access control: the Enquiries / Attendees / Offers tab and its buyer data
  // are visible to the listing's primary agent, secondary agent, third
  // (tertiary "access only") agent, or an admin. Every other agent and PA
  // accounts are blocked. The backend enforces the same rule; this just keeps
  // the tab from rendering for users who would only get a 403.
  const canViewBuyerData = (() => {
    if (!user) return false;
    if (hasAdminAccess(user)) return true;
    if (!property) return false;
    const agentId = property.agent?.id ?? property.agent_id ?? property.agent;
    const coAgentId = property.co_agent?.id ?? property.co_agent_id ?? property.co_agent;
    const tertiaryId = property.tertiary_agent?.id ?? property.tertiary_agent_id ?? property.tertiary_agent;
    return user.id === agentId || user.id === coAgentId || user.id === tertiaryId;
  })();

  // Full (edit) access: admin/pa, or this listing's primary / secondary /
  // tertiary agent. Everyone else (an agent opening a listing that isn't theirs)
  // gets a locked, read-only view — they can browse the Property and Photos tabs
  // but cannot edit anything, and the remaining tabs are locked. The backend is
  // the source of truth via `viewer_has_full_access`; we fall back to computing
  // it locally so the lock still applies if that flag is ever absent.
  const hasFullAccess = (() => {
    if (!user || !property) return false;
    if (typeof property.viewer_has_full_access === 'boolean') {
      return property.viewer_has_full_access;
    }
    if (hasAdminAccess(user) || user.role === 'pa') return true;
    const agentId = property.agent?.id ?? property.agent_id ?? property.agent;
    const coAgentId = property.co_agent?.id ?? property.co_agent_id ?? property.co_agent;
    const tertiaryId = property.tertiary_agent?.id ?? property.tertiary_agent_id ?? property.tertiary_agent;
    return user.id === agentId || user.id === coAgentId || user.id === tertiaryId;
  })();

  // In the locked read-only view, only these tabs are openable; the rest show a
  // lock icon and can't be opened.
  const READONLY_VISIBLE_TABS = ['property', 'photos'];
  const isReadOnly = !!property && !hasFullAccess;
  const isTabLocked = (tabId) => isReadOnly && !READONLY_VISIBLE_TABS.includes(tabId);
  // The tab whose content actually renders. A read-only viewer can never render a
  // locked tab's content (covers a ?tab=owner deep link before the reset effect runs).
  const visibleTab = isTabLocked(activeTab) ? 'property' : activeTab;

  // Where a contact profile opened from the buyer/enquiry lists should send its
  // Back arrow: this property's exact enquiries sub-tab, not the generic
  // /contacts list (Monday 13056279356).
  const contactReturnTo = `/properties/${params.id}?tab=enquiries&subtab=${enquiriesSubTab}`;
  const contactReturnLabel = property?.address || property?.title || 'Property';

  // If a non-permitted user deep-links to ?tab=enquiries, send them to the
  // Property tab once the listing (and therefore access) is known.
  useEffect(() => {
    if (property && !canViewBuyerData && activeTab === 'enquiries') {
      setActiveTab('property');
    }
  }, [property, canViewBuyerData, activeTab]);

  // Keep a read-only viewer out of any locked tab (covers ?tab= deep links).
  useEffect(() => {
    if (property && isTabLocked(activeTab)) {
      setActiveTab('property');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [property, isReadOnly, activeTab]);

  useEffect(() => {
    const fetchInteractions = async () => {
      if (!params.id || !canViewBuyerData) return;
      setInteractionsLoading(true);
      try {
        const [enquiriesRes, registrationsRes, offersRes, inspectionsRes, buyersRes] = await Promise.allSettled([
          getPropertyEnquiries(params.id),
          getPropertyBidderRegistrations(params.id),
          getPropertyOffers(params.id),
          getInspections({ property: params.id }),
          getPropertyBuyers(params.id),
        ]);

        if (buyersRes.status === 'fulfilled') {
          setPropertyBuyers(buyersRes.value?.data?.results || []);
        }

        if (offersRes.status === 'fulfilled') {
          const rawOffers = offersRes.value?.data?.results || [];
          const seen = new Set();
          const deduplicated = rawOffers.filter(offer => {
            const email = (offer.buyer_email || offer.email || '').toLowerCase().trim();
            const msg = (offer.message || offer.message_to_agent || '').trim();

            // Logic match: extract logical reference number from message if it's a summary
            let trueRef = offer.reference_number;
            const refMatch = msg.match(/OFF-\d{4}-\d{5}/);
            if (refMatch) trueRef = refMatch[0];

            const key = `${email}|${trueRef}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });
          setOffers(deduplicated);
        }

        try {
          const vsRes = await getPropertyVendorStatus(params.id);
          setVendorStatus(vsRes?.data || null);
        } catch {
          setVendorStatus(null);
        }

        if (enquiriesRes.status === 'fulfilled') {
          const rawEnquiries = enquiriesRes.value?.data?.results || [];
          const seen = new Set();
          const deduplicated = rawEnquiries.filter(enq => {
            const email = (enq.email || '').toLowerCase().trim();
            // Clean/normalize common portal message prefixes for enquiries too
            let msg = (enq.message || '').trim();
            if (msg.startsWith('[Buyer Portal') && msg.includes(']\n\n')) {
              msg = msg.split(']\n\n')[1]?.trim() || '';
            }
            if (msg.toLowerCase() === 'no message' || msg.toLowerCase() === 'no message.') msg = '';

            const key = `${email}|${msg}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });
          setEnquiries(deduplicated);
        }
        if (registrationsRes.status === 'fulfilled') {
          setBidderRegistrations(registrationsRes.value?.data?.results || []);
        }
        if (inspectionsRes.status === 'fulfilled') {
          const rawInspections = inspectionsRes.value?.data?.results || inspectionsRes.value?.data || [];
          const flat = [];
          rawInspections.forEach((insp) => {
            // Dedup per-inspection only, so a buyer who re-attends on a later
            // Open For Inspection still shows under each date they checked in.
            const seen = new Set();
            (insp.attendees || []).forEach((att) => {
              const key = `${(att.email || '').toLowerCase().trim()}|${(att.phone || '').trim()}|${(att.name || '').trim().toLowerCase()}`;
              if (seen.has(key)) return;
              seen.add(key);
              flat.push({
                ...att,
                inspection_id: insp.id,
                inspection_date: insp.scheduled_date,
                inspection_status: insp.status,
              });
            });
          });
          setInspectionAttendees(flat);
        }
      } catch (error) {
        console.error("Failed to fetch property interactions:", error);
      } finally {
        setInteractionsLoading(false);
      }
    };
    fetchInteractions();
  }, [params.id, canViewBuyerData]);

  // Once the interaction lists are loaded, batch-fetch the most recent note for
  // every person across the Buyers / Attendees / Enquiries tabs so each row can
  // show its last note (who + when) without an N+1 of per-row calls.
  useEffect(() => {
    if (!canViewBuyerData) return;
    const ids = new Set();
    const emails = new Set();
    propertyBuyers.forEach((b) => {
      if (b.contact_id) ids.add(b.contact_id);
      if (b.email) emails.add(b.email);
    });
    inspectionAttendees.forEach((a) => {
      if (a.contact) ids.add(a.contact);
      if (a.email) emails.add(a.email);
    });
    enquiries.forEach((e) => {
      if (e.email) emails.add(e.email);
    });
    if (ids.size === 0 && emails.size === 0) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await getLatestNotes({ contactIds: [...ids], emails: [...emails] });
        if (cancelled) return;
        setLatestNotesById(res?.data?.by_contact_id || {});
        // Normalise email keys to lowercase so lookups are case-insensitive.
        const byEmail = {};
        Object.entries(res?.data?.by_email || {}).forEach(([k, v]) => {
          byEmail[(k || '').toLowerCase()] = v;
        });
        setLatestNotesByEmail(byEmail);
      } catch (err) {
        // Non-critical — the cards still render, just without the last-note line.
        console.error('Failed to fetch latest notes', err);
      }
    })();
    return () => { cancelled = true; };
  }, [canViewBuyerData, propertyBuyers, inspectionAttendees, enquiries]);

  // Resolve a row (buyer/attendee/enquiry) to its most recent note, preferring a
  // contact-id match and falling back to email.
  const getLatestNoteFor = (row) => {
    if (!row) return null;
    const byId = row.contact_id != null ? latestNotesById[String(row.contact_id)] : null;
    if (byId) return byId;
    const contactKey = row.contact != null ? latestNotesById[String(row.contact)] : null;
    if (contactKey) return contactKey;
    const email = (row.email || '').toLowerCase().trim();
    return email ? (latestNotesByEmail[email] || null) : null;
  };

  // Merge a just-added note into the local maps so it appears on the row
  // instantly (the ContactNotesButton hands us {id, text, author, created_at}).
  const applyLatestNote = (row, note) => {
    if (!note) return;
    if (row?.contact_id != null) {
      setLatestNotesById((prev) => ({ ...prev, [String(row.contact_id)]: note }));
    } else if (row?.contact != null) {
      setLatestNotesById((prev) => ({ ...prev, [String(row.contact)]: note }));
    }
    const email = (row?.email || '').toLowerCase().trim();
    if (email) {
      setLatestNotesByEmail((prev) => ({ ...prev, [email]: note }));
    }
  };

  // The "last note" line shown inline on Buyers / Attendees / Enquiries rows:
  // the most recent note text, stamped with the agent who left it and the date
  // & time — so the whole team can see who last spoke to this person and when.
  const renderLastContactNote = (row) => {
    const note = getLatestNoteFor(row);
    if (!note?.text) return null;
    const stamp = [
      note.author,
      note.created_at
        ? new Date(note.created_at).toLocaleString('en-AU', {
            day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
          })
        : null,
    ].filter(Boolean).join(' · ');
    return (
      <div className="mt-2 flex items-start gap-2 rounded-lg bg-amber-50 border border-amber-100 px-3 py-2">
        <StickyNote className="w-3.5 h-3.5 text-amber-500 mt-0.5 flex-shrink-0" />
        <div className="min-w-0">
          <p className="text-[10px] font-black text-amber-600 uppercase tracking-widest mb-0.5">Last note</p>
          <p className="text-sm text-amber-900 whitespace-pre-wrap break-words">{note.text}</p>
          {stamp && (
            <p className="text-[11px] font-semibold text-amber-700/80 mt-1">{stamp}</p>
          )}
        </div>
      </div>
    );
  };

  // Small pill shown on attendee/buyer cards once a Contract of Sale has been
  // emailed to that person, so the agent can see at a glance who's already
  // received one. Green when the buyer has opened it, teal when just sent.
  const renderContractSentBadge = (row) => {
    const count = row?.contract_sent_count || 0;
    if (count < 1) return null;
    const opened = !!row.contract_opened_at;
    const sentStamp = row.contract_last_sent_at
      ? moment(row.contract_last_sent_at).format('D MMM YYYY, h:mm a')
      : null;
    const label = opened
      ? 'Contract opened'
      : `Contract sent${count > 1 ? ` ×${count}` : ''}`;
    const title = [
      sentStamp ? `Last sent ${sentStamp}` : 'Contract sent',
      count > 1 ? `${count} sends` : null,
      opened ? `Opened ${moment(row.contract_opened_at).format('D MMM YYYY, h:mm a')}` : null,
    ].filter(Boolean).join(' · ');
    return (
      <span
        title={title}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold ${
          opened ? 'bg-emerald-100 text-emerald-700' : 'bg-[#55C5D0]/15 text-[#3a99a3]'
        }`}
      >
        <CheckCircle2 size={12} /> {label}
      </span>
    );
  };

  // True once a buyer-portal sign-up link has already reached this person (or
  // they already have an account) — used to swap the "Send Portal Sign Up
  // Link" button for a "Sign-up Link Sent" state so the same link isn't
  // emailed to a buyer twice.
  const portalInviteAlreadySent = (row) =>
    !!(row?.has_portal_account || row?.portal_invite_sent_recently);

  // First name only, so the send-link button/badge can name whose invite it
  // is without overflowing the button row.
  const firstNameOf = (name) => (name || '').trim().split(/\s+/)[0] || 'buyer';

  const renderPortalInviteSentBadge = (row) => (
    <span
      title={`A buyer-portal sign-up link has already been sent to ${row?.name || 'this person'}`}
      className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-emerald-600 px-3 py-2"
    >
      <Check size={14} /> Link Sent to {firstNameOf(row?.name)}
    </span>
  );


  // ----- "Buyers" sub-tab handlers -----
  const refreshPropertyBuyers = async () => {
    try {
      const res = await getPropertyBuyers(params.id);
      setPropertyBuyers(res?.data?.results || []);
    } catch (e) {
      console.error("Failed to refresh property buyers:", e);
    }
  };

  const handleRemoveBuyer = async (buyer) => {
    if (!window.confirm(`Remove ${buyer.name || 'this buyer'} from this property's buyer list?`)) return;
    setRemovingBuyerLinkId(buyer.link_id);
    try {
      await removePropertyBuyer(params.id, buyer.link_id);
      setPropertyBuyers((prev) => prev.filter((b) => b.link_id !== buyer.link_id));
      toast.success("Buyer removed from this property.");
    } catch (e) {
      console.error("Failed to remove buyer:", e);
      toast.error("Could not remove buyer.");
    } finally {
      setRemovingBuyerLinkId(null);
    }
  };

  // Email a property-Buyers-tab buyer the Contract of Sale. Unlike attendees,
  // these buyers aren't tied to an inspection, so this hits a property-scoped
  // endpoint keyed by the buyer's link id.
  const handleSendContractToBuyer = async (buyer) => {
    if (!buyer?.email) {
      toast.error("This buyer has no email on file to send the contract to.");
      return;
    }
    if (!window.confirm(`Send the Contract of Sale to ${buyer.name || buyer.email}?`)) return;
    setSendingContractBuyerLinkId(buyer.link_id);
    try {
      await sendBuyerContractOfSale(params.id, buyer.link_id);
      toast.success(`Contract of Sale sent to ${buyer.name || buyer.email}.`);
      // Reflect the send immediately (badge + "Resend Contract" label).
      const nowIso = new Date().toISOString();
      setPropertyBuyers((prev) =>
        prev.map((b) =>
          b.link_id === buyer.link_id
            ? {
                ...b,
                contract_sent_count: (b.contract_sent_count || 0) + 1,
                contract_last_sent_at: nowIso,
              }
            : b,
        ),
      );
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to send the contract.");
    } finally {
      setSendingContractBuyerLinkId(null);
    }
  };

  // Email a bare enquiry the Contract of Sale (#12973373820). An enquiry has no
  // buyer link or inspection to key a contract send off (unlike Attendees /
  // Buyers), so attach them to this property as a buyer first, then send via the
  // buyer-contract path. Sending someone a Contract of Sale makes them a
  // prospective buyer for this listing, so the promotion is intended and matches
  // CG's ask that the three tabs carry the same actions.
  const handleSendContractToEnquiry = async (enq) => {
    if (!enq?.email) {
      toast.error("This enquiry has no email on file to send the contract to.");
      return;
    }
    const who = enq.name || enq.full_name || enq.email;
    if (!window.confirm(`Send the Contract of Sale to ${who}? This also adds them to this property's Buyers.`)) return;
    setSendingContractEnquiryId(enq.id);
    try {
      const res = await addPropertyBuyer(params.id, {
        name: who,
        email: enq.email,
        phone: enq.phone || enq.contact || '',
      });
      const linkId = res?.data?.link_id || res?.data?.id;
      if (!linkId) throw new Error('Could not attach this enquiry as a buyer.');
      await sendBuyerContractOfSale(params.id, linkId);
      toast.success(`Contract of Sale sent to ${who}.`);
      const nowIso = new Date().toISOString();
      setEnquiries((prev) =>
        prev.map((e) =>
          e.id === enq.id
            ? { ...e, contract_sent_count: (e.contract_sent_count || 0) + 1, contract_last_sent_at: nowIso }
            : e,
        ),
      );
    } catch (err) {
      toast.error(err?.response?.data?.detail || err?.response?.data?.error || "Failed to send the contract.");
    } finally {
      setSendingContractEnquiryId(null);
    }
  };

  // Email a property-Buyers-tab buyer a portal sign-up link. They already carry a
  // CRM contact id, so this calls the invite-to-portal endpoint directly.
  const handleSendPortalSignupToBuyer = async (buyer) => {
    if (!buyer?.email) {
      toast.error("This buyer has no email on file to send a portal sign-up link to.");
      return;
    }
    if (!window.confirm(`Send a buyer-portal sign-up link to ${buyer.name || buyer.email}?`)) return;
    setInvitingBuyerLinkId(buyer.link_id);
    try {
      await inviteContactToPortal(buyer.contact_id);
      toast.success(`Portal sign-up link sent to ${buyer.name || buyer.email}.`);
      // Reflect the send immediately so the button flips to "Sign-up Link
      // Sent" without waiting for a refetch.
      setPropertyBuyers((prev) =>
        prev.map((b) =>
          b.link_id === buyer.link_id ? { ...b, portal_invite_sent_recently: true } : b,
        ),
      );
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to send the portal sign-up link.");
    } finally {
      setInvitingBuyerLinkId(null);
    }
  };

  // Email a property-Buyers-tab buyer the offer link they use to submit an offer
  // on this property (CRM-2026, Christian). Hits the same buyer_portal offer-invite
  // endpoint the eSign "Send offer link to buyer" flow uses, so it feeds the same
  // Offers / Pipeline.
  const handleSendOfferLinkToBuyer = async (buyer) => {
    if (!buyer?.email) {
      toast.error("This buyer has no email on file to send an offer link to.");
      return;
    }
    if (!window.confirm(`Send an offer link to ${buyer.name || buyer.email}?`)) return;
    setSendingOfferLinkId(buyer.link_id);
    try {
      await esignApi.sendOfferInvite(params.id, {
        name: buyer.name || "",
        email: buyer.email,
        message: "",
      });
      toast.success(`Offer link sent to ${buyer.name || buyer.email}.`);
    } catch (err) {
      toast.error(err?.response?.data?.error || err?.response?.data?.detail || "Failed to send the offer link.");
    } finally {
      setSendingOfferLinkId(null);
    }
  };

  // Generic "Send Offer Link" for any person on the property (buyer / attendee /
  // enquiry). Emails the offer-submission link (same endpoint the eSign flow
  // uses) so the offer feeds the same Offers / Pipeline. Christian asked for the
  // same buttons on all three tabs (#12973373820). busyId keys the row's
  // sending state (buyer.link_id / att.id / enq.id).
  const sendOfferLinkTo = async (person, busyId) => {
    const email = person?.email;
    const name = person?.name || person?.full_name || "";
    if (!email) {
      toast.error("This person has no email on file to send an offer link to.");
      return;
    }
    if (!window.confirm(`Send an offer link to ${name || email}?`)) return;
    setSendingOfferLinkId(busyId);
    try {
      await esignApi.sendOfferInvite(params.id, { name, email, message: "" });
      toast.success(`Offer link sent to ${name || email}.`);
    } catch (err) {
      toast.error(err?.response?.data?.error || err?.response?.data?.detail || "Failed to send the offer link.");
    } finally {
      setSendingOfferLinkId(null);
    }
  };

  // Log a call on a Buyers / Attendees / Enquiries row. "Contacted" on these
  // tabs is the latest note, so the backend writes the chosen outcome as a note
  // AND stamps the contact + the buyer timeline (a call is real data, not only a
  // note), optionally setting a call-back reminder. The row's Last-note box and
  // the button's "Called {ago}" state update on the spot — no refetch. The person
  // is named by the RECORD clicked (attendeeId / enquiryId / buyerLinkId); the
  // backend resolves the contact and checks access from it.
  // busyId keys the row's calling state (buyer.link_id / att.id / enq.id).
  const markCalled = async (
    row,
    ids = {},
    busyId,
    { outcome = 'Called', remindInDays = null } = {},
  ) => {
    if (callingId != null) return;
    setCallingId(busyId);
    try {
      const res = await markContactCalled({ ...ids, outcome, remindInDays });
      const n = res?.data?.note || {};
      applyLatestNote(row, {
        id: n.id,
        text: n.text || outcome,
        author: n.author_name,
        created_at: n.created_at || new Date().toISOString(),
        last_contacted: res?.data?.last_contacted || n.created_at || new Date().toISOString(),
      });
      toast.success(remindInDays ? "Call logged and reminder set." : "Call logged.");
    } catch (err) {
      // 409 = Do Not Call: show the backend's own explanation.
      toast.error(err?.response?.data?.detail || "Couldn't log the call. Please try again.");
    } finally {
      setCallingId(null);
    }
  };

  // Email a general enquiry a buyer-portal sign-up link. Resolves the CRM
  // contact by the enquiry's email (enquiry rows don't always carry a
  // contact_id), mirroring the attendee flow.
  const handleSendPortalSignupToEnquiry = async (enq) => {
    const email = enq?.email;
    const label = enq?.name || enq?.full_name || email;
    if (!email) {
      toast.error("This enquiry has no email on file to send a portal sign-up link to.");
      return;
    }
    if (!window.confirm(`Send a buyer-portal sign-up link to ${label}?`)) return;
    setInvitingEnquiryId(enq.id);
    try {
      let contactId = enq.contact_id || enq.contact;
      if (!contactId) {
        const res = await getContacts({ search: email });
        const contacts = res.data?.results || res.data || [];
        contactId = contacts[0]?.id;
      }
      if (!contactId) {
        toast.error("No CRM contact found for this enquiry. Add them to Contacts first.");
        return;
      }
      await inviteContactToPortal(contactId);
      toast.success(`Portal sign-up link sent to ${label}.`);
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to send the portal sign-up link.");
    } finally {
      setInvitingEnquiryId(null);
    }
  };

  // Email this single attendee the property's Contract of Sale. Reuses the same
  // BE endpoint as the open-home session screen, scoped to one attendee.
  const handleSendContractToAttendee = async (att) => {
    if (!att?.email) {
      toast.error("This buyer has no email on file to send the contract to.");
      return;
    }
    if (!att.inspection_id) {
      toast.error("Could not determine the inspection for this buyer.");
      return;
    }
    if (
      !window.confirm(`Send the Contract of Sale to ${att.name || att.email}?`)
    )
      return;
    setSendingContractAttendeeId(att.id);
    try {
      const res = await sendContractOfSale(att.inspection_id, {
        attendee_ids: [att.id],
      });
      if ((res.data?.sent?.length || 0) > 0) {
        toast.success(`Contract of Sale sent to ${att.name || att.email}.`);
        // Reflect the send immediately so the "Contract sent" badge appears and
        // the button flips to "Resend Contract" without waiting for a refetch.
        const nowIso = new Date().toISOString();
        setInspectionAttendees((prev) =>
          prev.map((a) =>
            a.id === att.id
              ? {
                  ...a,
                  contract_sent_count: (a.contract_sent_count || 0) + 1,
                  contract_last_sent_at: nowIso,
                }
              : a,
          ),
        );
      } else if ((res.data?.skipped?.length || 0) > 0) {
        toast.error("This buyer has no email on file.");
      } else {
        toast.error("Contract could not be sent.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to send the contract.");
    } finally {
      setSendingContractAttendeeId(null);
    }
  };

  // Resolve the CRM contact id for an inspection attendee. Check-ins match-or-
  // create a Contact, so most attendees carry `contact`; fall back to an email
  // lookup for legacy rows that were never linked.
  const resolveAttendeeContactId = async (att) => {
    if (att?.contact) return att.contact;
    if (!att?.email) return null;
    const res = await getContacts({ search: att.email });
    const contacts = res.data?.results || res.data || [];
    return contacts[0]?.id || null;
  };

  // Open the linked CRM contact profile for an attendee (clickable name).
  const handleViewAttendeeContact = async (att) => {
    try {
      const contactId = await resolveAttendeeContactId(att);
      if (contactId) {
        // Carry the origin so the profile's Back arrow returns to this
        // attendees sub-tab, not the generic /contacts list (Monday 13056279356).
        navigate(`/contacts/${contactId}`, {
          state: { returnTo: contactReturnTo, returnLabel: contactReturnLabel },
        });
      } else {
        toast.error(
          "No CRM contact found for this attendee. Please search manually in the Contacts section.",
        );
      }
    } catch (err) {
      console.error("Failed to open contact for attendee", err);
      toast.error("Could not open the contact for this attendee.");
    }
  };

  // Email this attendee a buyer-portal sign-up link (welcome / "create my
  // account" email). Reuses the contact invite-to-portal endpoint.
  const handleSendPortalSignupToAttendee = async (att) => {
    if (!att?.email) {
      toast.error("This attendee has no email on file to send a portal sign-up link to.");
      return;
    }
    if (
      !window.confirm(`Send a buyer-portal sign-up link to ${att.name || att.email}?`)
    )
      return;
    setInvitingAttendeeId(att.id);
    try {
      const contactId = await resolveAttendeeContactId(att);
      if (!contactId) {
        toast.error(
          "No CRM contact found for this attendee. Add them to Contacts first.",
        );
        return;
      }
      await inviteContactToPortal(contactId);
      toast.success(`Portal sign-up link sent to ${att.name || att.email}.`);
      // Reflect the send immediately so the button flips to "Sign-up Link
      // Sent" without waiting for a refetch.
      setInspectionAttendees((prev) =>
        prev.map((a) =>
          a.id === att.id ? { ...a, portal_invite_sent_recently: true } : a,
        ),
      );
    } catch (err) {
      toast.error(
        err?.response?.data?.error || "Failed to send the portal sign-up link.",
      );
    } finally {
      setInvitingAttendeeId(null);
    }
  };

  // Recipients for the shared composer (Enquiries, Buyers & Attendees tabs),
  // mapped to { id, name, phone, email, contact_id }. contact_id drives consent
  // (opt-out/do-not-contact) and the merge tags server-side.
  const enquiryRecipients = enquiries.map((e) => ({
    id: e.id,
    name: e.name || e.full_name || '',
    phone: e.phone || e.contact || '',
    email: e.email || '',
    contact_id: e.contact_id,
  }));
  const buyerRecipients = propertyBuyers.map((b) => ({
    id: b.link_id,
    name: b.name || '',
    phone: b.phone || '',
    email: b.email || '',
    contact_id: b.contact_id,
  }));

  // Attendees (open-home register) mapped for the shared composer, same shape as
  // enquiry/buyer recipients. Attendees store the contact id on `contact`.
  const attendeeRecipients = inspectionAttendees.map((a) => ({
    id: a.id,
    name: a.name || '',
    phone: a.phone || '',
    email: a.email || '',
    contact_id: a.contact,
  }));

  // Shape the tab's recipients for the shared composer. contact_id drives both
  // consent (opt-out/do-not-contact) and the merge tags server-side; source/
  // ref_id are omitted because these people have no saved-search record, so the
  // preferences link is hidden for them (Off-Market invite still works).
  // Dedupe so someone who enquired more than once isn't emailed/texted twice
  // (the server sends one message per row).
  const toComposerRecipients = (rows) => {
    const seen = new Set();
    const out = [];
    rows.forEach((r) => {
      const key = r.contact_id != null
        ? `c:${r.contact_id}`
        : `x:${(r.email || '').trim().toLowerCase()}|${(r.phone || '').trim()}`;
      if (key === 'x:|' || seen.has(key)) return;
      seen.add(key);
      out.push({
        contact_id: r.contact_id ?? null,
        buyer_id: null,
        email: r.email || '',
        phone: r.phone || '',
        name: r.name || '',
      });
    });
    return out;
  };

  const richComposerRecipients =
    richComposer?.context === 'buyers'
      ? toComposerRecipients(buyerRecipients)
      : richComposer?.context === 'attendees'
        ? toComposerRecipients(attendeeRecipients)
        : toComposerRecipients(enquiryRecipients);
  const richComposerNoun =
    richComposer?.context === 'buyers' || richComposer?.context === 'attendees'
      ? (property?.transaction_type === 'lease' ? 'renter' : 'buyer')
      : 'enquirer';

  const handleEditInfo = () => {
    setEditForm({
      price: property.price || "",
      price_to: property.price_to != null && property.price_to !== "" ? String(property.price_to) : "",
      price_display: property.price_display || "exact",
      price_display_text: property.price_display_text || "",
      weekly_rent: property.weekly_rent != null && property.weekly_rent !== "" ? String(property.weekly_rent) : "",
      bond: property.bond != null && property.bond !== "" ? String(property.bond) : "",
      property_type: property.property_type || "residential",
      property_class: property.property_class || "House",
      transaction_type: property.transaction_type || "sale",
      status: property.status?.name || property.status || "On Market Listing",
      method_of_sale: property.method_of_sale || "Private Sale",
      auction_date: property.auction_date ? formatLocalDatePart(property.auction_date) : "",
      auction_time: property.auction_date ? formatLocalTimePart(property.auction_date) : "",
      parking_type: property.parking_type || "",
      parking_spaces: property.parking_spaces || 0,
      parkings: property.parkings || 0,
      car_ports: property.car_ports || 0,
      open_spaces: property.open_spaces || 0,
      beds: property.beds || 0,
      baths: property.baths || 0,
      floor_area: property.floor_area || 0,
      land_size: property.land_size || 0,
    });
    setIsEditingInfo(true);
  };

  const handleInputChange = (field, value) => {
    setEditForm(prev => {
      const next = { ...prev, [field]: value };
      if (field === 'bond') {
        // Keep bond numeric for the backend's DecimalField, even if typed as "$2,500".
        next.bond = String(value).replace(/[^\d]/g, "");
      } else if (field === 'weekly_rent' && prev.transaction_type === 'lease') {
        // Rental bond auto-tracks the weekly rent (Victorian calendar-month rule).
        // Agents can still type their own bond afterwards to override it.
        next.bond = calculateBond(value, prev.property_class).replace(/[^\d]/g, "");
      }
      return next;
    });
  };

  const handleSaveInfo = async () => {
    try {
      setIsUpdating(true);
      // Combine the separate date + time inputs into a single datetime for the
      // backend's auction_date DateTimeField; auction_time is a FE-only helper.
      const { auction_time, ...payload } = editForm;
      if (payload.method_of_sale === 'Auction' && payload.auction_date) {
        const time = auction_time || '00:00';
        const combinedIso = melbourneWallTimeToUtcISOString(payload.auction_date, time);
        if (combinedIso) {
          payload.auction_date = combinedIso;
        }
      }
      // Use patchProperty which properly converts object to FormData.
      // A live listing's price change needs a reason (compliance price
      // history): the backend says so, we ask, then resend with it.
      let saveRes;
      try {
        saveRes = await patchProperty(params.id, payload);
      } catch (err) {
        if (!isPriceReasonRequired(err)) throw err;
        const extra = await requestPriceReason();
        if (!extra) return;
        saveRes = await patchProperty(params.id, { ...payload, ...extra });
      }
      const res = await getProperty(params.id);
      setProperty(res.data);
      setIsEditingInfo(false);
      toast.success("Information updated");
      // The edit saved in the CRM, but if the listing is live on REA while its
      // Visibility box is unticked, the change won't reach realestate.com.au.
      // Surface that explicitly so a price edit isn't silently confusing (the
      // backend flags it via rea_sync.blocked) — CRM-2026-00048, 3/286 Oriel Rd.
      const reaSync = saveRes?.data?.rea_sync;
      if (reaSync?.blocked && reaSync?.message) {
        toast(reaSync.message, { icon: '⚠️', duration: 9000 });
      }
    } catch (err) {
      console.error("Update error:", err?.response?.data);
      toast.error(err?.response?.data?.detail || "Update failed");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleEditDescription = () => {
    setDescriptionEdit(property.description || '');
    setIsEditingDescription(true);
  };

  const handleSaveDescription = async () => {
    try {
      setIsUpdating(true);
      await updateProperty(params.id, { description: descriptionEdit });
      const res = await getProperty(params.id);
      setProperty(res.data);
      setIsEditingDescription(false);
      toast.success("Description updated");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Update failed");
    } finally {
      setIsUpdating(false);
    }
  };

  const fetchPropertyNotes = async () => {
    setNotesLoading(true);
    try {
      const res = await getPropertyNotes(params.id);
      setPropertyNotes(res.data?.results || res.data || []);
    } catch (err) {
      console.error("Failed to fetch notes", err);
    } finally {
      setNotesLoading(false);
    }
  };

  // The property owner's email/SMS history, shown in the Agent Notes feed
  // (CRM-2026-00102). Keyed off the owner's email via the comms timeline.
  useEffect(() => {
    const paramsForComms = ownerCommsParams(property);
    if (!paramsForComms) {
      setOwnerComms([]);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchCommunicationTimeline(paramsForComms);
        if (!cancelled) setOwnerComms(Array.isArray(data) ? data : data?.results || []);
      } catch (err) {
        if (!cancelled) setOwnerComms([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [property?.owner_email]);

  // The note and the call-back series it is about are saved together (Simon
  // Abbott, Monday 13036305197): he writes "touch base next week" in the note
  // box, so next week's call has to be bookable from the same screen and the
  // same button. Either half on its own is a valid save - a note with no
  // call-back, or a call-back added to a note already written yesterday.
  const handleSaveNote = async () => {
    const content = newNote.trim();
    if (!content && noteReminders.length === 0) return;

    setIsUpdating(true);
    try {
      if (content) {
        await createPropertyNote(params.id, { content });
      }

      // The reminders go up second and separately: a failure to book a
      // call-back must not throw away a note that already saved.
      let remindersBooked = 0;
      if (noteReminders.length > 0) {
        try {
          await createAppraisalReminders(
            params.id,
            noteReminders.map((entry) => ({
              date: entry.date.toISOString(),
              reason: entry.reason,
            })),
            content
          );
          remindersBooked = noteReminders.length;
          setNoteReminders([]);
          // Re-reads the "already booked" list with the new entries in it.
          setNoteReminderKey((k) => k + 1);
        } catch (reminderError) {
          console.error("Error booking the reminder series:", reminderError);
          toast.error(
            content
              ? "Note saved, but the reminders could not be booked"
              : "Failed to book the reminders"
          );
        }
      }

      if (content) {
        setNewNote("");
        toast.success(
          remindersBooked
            ? `Note added and ${remindersBooked} reminder${remindersBooked > 1 ? "s" : ""} booked`
            : "Note added successfully"
        );
        fetchPropertyNotes();
      } else if (remindersBooked) {
        toast.success(
          `${remindersBooked} reminder${remindersBooked > 1 ? "s" : ""} booked`
        );
      }
    } catch (error) {
      console.error("Error saving note:", error);
      toast.error("Failed to save note");
    } finally {
      setIsUpdating(false);
    }
  };

  const MAX_SOI_SIZE_MB = 2;
  const validateSOIFile = (file) => {
    if (!file) return null;
    const isPdf = (file.name || "").toLowerCase().endsWith(".pdf") || file.type === "application/pdf";
    if (!isPdf) {
      toast.error("Only PDF files are accepted for Property Price Statement.");
      return false;
    }
    if (file.size > MAX_SOI_SIZE_MB * 1024 * 1024) {
      toast.error(`File size must be ${MAX_SOI_SIZE_MB}MB or less.`);
      return false;
    }
    return true;
  };

  const handleSOIUpload = async (files) => {
    const fileList = Array.isArray(files) ? files : (files ? [files] : []);
    const file = fileList[0];
    if (!file || !validateSOIFile(file)) return;
    setSoiUploading(true);
    try {
      await uploadStatementOfInfo(params.id, [file]);
      const res = await getProperty(params.id);
      setProperty(res.data);
      toast.success("Property Price Statement uploaded successfully.");
      if (soiFileInputRef.current) soiFileInputRef.current.value = "";
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setSoiUploading(false);
    }
  };

  // Every PPS upload is kept (CRM ticket 13177542710): the newest upload is
  // the current statement and the older ones stay listed as previous
  // versions, so there is never a reason to Remove a document first.
  const sortedSoiDocs = (property?.documents || [])
    .filter((d) => d.category === "statement_of_info_docs")
    .slice()
    .sort((a, b) => new Date(b.uploaded_at || 0) - new Date(a.uploaded_at || 0));

  const handleReplaceSOI = () => soiFileInputRef.current?.click();

  const handleRemoveSOI = async () => {
    const soiDoc = sortedSoiDocs[0];
    if (!soiDoc) return;
    if (!window.confirm("Remove this Property Price Statement? You can upload a new one anytime.")) return;
    try {
      await deletePropertyDocument(soiDoc.id);
      const res = await getProperty(params.id);
      setProperty(res.data);
      toast.success("Property Price Statement removed.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to remove document");
    }
  };

  const handleDeleteNote = async (noteId) => {
    if (!window.confirm("Are you sure you want to delete this note?")) return;
    try {
      await deletePropertyNote(noteId);
      toast.success("Note deleted");
      fetchPropertyNotes();
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete note");
    }
  };

  const handleUpdateEnquiry = async (formData) => {
    if (!editingEnquiry) return;
    setIsUpdatingEnquiry(true);
    try {
      const res = await updateEnquiry(editingEnquiry.id, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        agent_notes: formData.agent_notes,
        status: formData.status,
        property: formData.propertyId
      });

      const updatedEnq = res.data?.enquiry || {
        ...editingEnquiry,
        ...formData,
        type_display: editingEnquiry.type_display
      };

      setEnquiries(prev => prev.map(e => e.id === editingEnquiry.id ? updatedEnq : e));
      toast.success("Enquiry updated successfully");
      setEditingEnquiry(null);
    } catch (err) {
      toast.error("Failed to update enquiry");
    } finally {
      setIsUpdatingEnquiry(false);
    }
  };

  // Decline an offer from the Offers tab. Same behaviour as Decline Offer in the
  // Buyer Portal Offers pop-up: the offer stays here as the permanent record,
  // marked Declined, and drops out of the Buyer Portal Offers holding list.
  const handleDeclineOffer = async (offer) => {
    if (!offer?.id) return;
    setDecliningOfferId(offer.id);
    try {
      const res = await updateOffer(offer.id, { status: 'REJECTED' });
      const data = res?.data || {};
      setOffers(prev => prev.map(x => x.id === offer.id ? { ...x, ...data } : x));
      // Ignore, not delete: the lead leaves the Buyer Portal Offers holding
      // list, the buyer stays in the CRM and the offer stays on this tab.
      if (offer.lead_id) {
        try {
          await ignoreLead(offer.lead_id, { reason: 'offer_declined' });
          invalidateCache.leads();
        } catch (e) {
          /* holding list is best-effort — the decline itself already saved */
        }
      }
      toast.success("Offer declined. It stays here marked Declined.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to decline offer.");
    } finally {
      setDecliningOfferId(null);
    }
  };

  // "Fill Out Contract" — hand the buyer's details to the eSign contract flow.
  // The offer itself travels in navigation state so its figures (price, deposit,
  // settlement, conditions) prefill the contract (CG, 16 Aug 2026).
  const openContractForOffer = (offer) => {
    const qs = new URLSearchParams({
      newFlow: 'contract',
      propertyId: String(params.id),
      buyerName: offer?.buyer_name || '',
      buyerEmail: offer?.buyer_email || '',
    });
    navigate(`/esign/agreements?${qs.toString()}`, { state: { offer: offer || null } });
  };

  const handleAddEnquiry = async (formData) => {
    try {
      const res = await createPropertyEnquiry(property.id, formData);
      setEnquiries(prev => [res.data, ...prev]);
      toast.success("Enquiry added.");
      setShowAddEnquiryModal(false);
    } catch (err) {
      toast.error(err?.response?.data?.error || "Could not add the enquiry.");
    }
  };

  // Owner tab: expand an owner's General Information inline instead of
  // navigating away to their Contact profile (CG, 2026-08-06, Monday
  // 12709346275: "I want the agent to be able to stay in the property
  // profile, its all just unified").
  const [expandedOwnerIdx, setExpandedOwnerIdx] = useState(null);
  const [expandedOwnerContactId, setExpandedOwnerContactId] = useState(null);
  const [resolvingOwnerIdx, setResolvingOwnerIdx] = useState(null);

  const handleToggleOwnerExpand = async (owner, idx) => {
    if (expandedOwnerIdx === idx) {
      setExpandedOwnerIdx(null);
      setExpandedOwnerContactId(null);
      return;
    }
    const ownerEmail = owner.email?.trim() || '';
    const ownerPhone = owner.contact || owner.phone;
    if (!ownerEmail && !ownerPhone && !owner.name) {
      toast.error("Not enough details on file to open this owner's contact profile.");
      return;
    }
    setResolvingOwnerIdx(idx);
    try {
      const res = await resolveContactIdentity({ email: ownerEmail, name: owner.name, phone: ownerPhone });
      const contactId = res?.data?.contact_id;
      if (!contactId) {
        toast.error("Couldn't open this owner's contact profile.");
        return;
      }
      setExpandedOwnerContactId(contactId);
      setExpandedOwnerIdx(idx);
    } catch {
      toast.error("Couldn't open this owner's contact profile.");
    } finally {
      setResolvingOwnerIdx(null);
    }
  };

  const refreshOwnersFromData = (data) => {
    const allOwners = [];
    const primaryOwner = data.owner && (data.owner.name || data.owner.contact || data.owner.email)
      ? data.owner
      : (data.owner_name || data.owner_email || data.owner_contact)
        ? { name: data.owner_name, email: data.owner_email, contact: data.owner_contact }
        : null;
    if (primaryOwner) allOwners.push({ ...primaryOwner, isPrimary: true });
    (data.additional_owners || []).forEach(ao => allOwners.push({ ...ao, isPrimary: false }));
    setOwners(allOwners);
  };

  const handleSaveOwner = async (data) => {
    try {
      setIsUpdating(true);
      const hasPrimaryOwner = owners.some(o => o.isPrimary);

      if (!hasPrimaryOwner) {
        await patchProperty(params.id, {
          owner_name: data.owner_name,
          owner_preferred_name: data.preferred_name || "",
          contact: data.contact,
          email: data.email
        });
      } else {
        await addAdditionalOwner(params.id, {
          name: data.owner_name,
          preferred_name: data.preferred_name || "",
          contact: data.contact,
          email: data.email
        });
      }

      const res = await getProperty(params.id);
      setProperty(res.data);
      refreshOwnersFromData(res.data);
      toast.success("Owner added successfully");
      setShowOwnerModal(false);
    } catch (error) {
      console.error("Failed to save owner:", error);
      toast.error("Failed to add owner");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDeleteOwner = async (owner) => {
    if (!window.confirm(`Remove ${owner.name} from this property?`)) return;
    try {
      setIsUpdating(true);
      if (owner.isPrimary) {
        await patchProperty(params.id, { owner_name: '', contact: '', email: '' });
      } else {
        await deleteAdditionalOwner(params.id, owner.id);
      }
      const res = await getProperty(params.id);
      setProperty(res.data);
      refreshOwnersFromData(res.data);
      toast.success("Owner removed");
    } catch (error) {
      console.error("Failed to remove owner:", error);
      toast.error("Failed to remove owner");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleSavePurchaser = async (data) => {
    const isEditing = Boolean(editingPurchaser);
    try {
      setIsUpdating(true);
      const newRow = {
        name: (data.purchaser_name || "").trim(),
        email: (data.purchaser_email || "").trim(),
        contact: (data.purchaser_contact || "").trim(),
      };
      // Build the full list off current state; replace the edited row (by index)
      // or append a new one. Send the whole list so the backend rebuilds the
      // one-to-many PropertyPurchaser records.
      const base = purchasers.map((p) => ({
        name: p.name || "",
        email: p.email || "",
        contact: p.contact || p.phone || "",
      }));
      let nextList;
      if (isEditing && Number.isInteger(editingPurchaser.index)) {
        nextList = base.map((p, i) => (i === editingPurchaser.index ? newRow : p));
      } else {
        nextList = [...base, newRow];
      }
      await patchProperty(params.id, { purchasers: JSON.stringify(nextList) });
      const res = await getProperty(params.id);
      setProperty(res.data);
      setPurchasers(derivePurchasers(res.data));

      toast.success(isEditing ? "Purchaser updated successfully" : "Purchaser added successfully");
      setShowPurchaserModal(false);
      setEditingPurchaser(null);
    } catch (error) {
      console.error("Failed to save purchaser:", error);
      toast.error(isEditing ? "Failed to update purchaser" : "Failed to add purchaser");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleEditPurchaser = (purchaser, index) => {
    setEditingPurchaser({
      index,
      purchaser_name: purchaser.name || "",
      purchaser_email: purchaser.email || "",
      purchaser_contact: purchaser.contact || purchaser.phone || "",
    });
    setShowPurchaserModal(true);
  };

  const handleDeletePurchaser = async (index) => {
    if (!window.confirm("Delete this purchaser's details? This cannot be undone.")) return;
    try {
      setIsUpdating(true);
      const nextList = purchasers
        .filter((_, i) => i !== index)
        .map((p) => ({
          name: p.name || "",
          email: p.email || "",
          contact: p.contact || p.phone || "",
        }));
      await patchProperty(params.id, { purchasers: JSON.stringify(nextList) });
      const res = await getProperty(params.id);
      setProperty(res.data);
      setPurchasers(derivePurchasers(res.data));

      toast.success("Purchaser deleted");
    } catch (error) {
      console.error("Failed to delete purchaser:", error);
      toast.error("Failed to delete purchaser");
    } finally {
      setIsUpdating(false);
    }
  };


  const handlePropertyWithdraw = async (reason, reasonNote) => {
    await withdrawProperty(params.id, reason, reasonNote);
    toast.success('Property withdrawn successfully');
    const res = await getProperty(params.id);
    setProperty(res.data);
  };

  const handlePropertyRelist = async () => {
    await patchProperty(params.id, { is_withdrawn: false });
    toast.success('Property relisted successfully');
    const res = await getProperty(params.id);
    setProperty(res.data);
  };

  const handleToggleSold = async (soldDetails = null) => {
    setIsMarkingSold(true);
    // Check both is_sold field and status field
    const isCurrentlySold = property?.is_sold || property?.status === 'Sold' || property?.status?.name === 'Sold';
    const isLeaseProperty = property?.transaction_type === 'lease';
    // Lease completion ("Set As Leased") comes through the tenancy modal and carries
    // a leaseAmount. We reuse the is_sold flag as the completion marker and map the
    // tenancy details onto existing columns (no rental-specific schema needed):
    //   Lease Amount -> weekly_rent, Letting Fee -> fixed commission,
    //   Tenancy Start -> sold_date, Tenancy End -> settlement_date.
    const leaseDetails =
      soldDetails && soldDetails.leaseAmount !== undefined ? soldDetails : null;
    try {
      const updateData = { is_sold: !isCurrentlySold };

      if (!isCurrentlySold && leaseDetails) {
        // Map the tenancy modal onto existing columns (see buildLeaseUpdateData).
        await patchProperty(params.id, buildLeaseUpdateData(leaseDetails));
        // Also capture the outcome in the dedicated structured fields (kept
        // separate from the advertised rent) for renter/leasing analytics.
        // Best-effort: the tenancy PATCH above is the source of truth for display.
        try {
          await markPropertyLeased(params.id, {
            achieved_rent: leaseDetails.leaseAmount,
            lease_commencement_date: leaseDetails.tenancyStart || null,
          });
        } catch (leaseErr) {
          console.error('mark-leased structured capture failed (non-blocking):', leaseErr);
        }
        toast.success('Property marked as leased successfully');
        invalidateCache.properties();
        const res = await getProperty(params.id);
        setProperty(res.data);
        setPurchasers(derivePurchasers(res.data));
        setShowSoldModal(false);
        return;
      }
      // When marking as sold, include the captured sale price + portal suppression
      // flag, the sold date (shown online + leaderboard dating fallback), the
      // settlement date, and the agent commission split (co-agent + primary %).
      // Portal attribution is set afterwards via the DOMA category picker.
      if (!isCurrentlySold && soldDetails && typeof soldDetails.soldPrice === 'number') {
        Object.assign(updateData, buildSaleDetailsPatch(soldDetails, { withPurchasers: true }));
      } else if (!isCurrentlySold && !property?.sold_date) {
        // Fallback when no sale details were captured (e.g. programmatic toggle).
        updateData.sold_date = new Date().toISOString().split('T')[0];
      }
      await patchProperty(params.id, updateData);
      toast.success(
        isLeaseProperty
          ? (isCurrentlySold ? 'Property marked as unleased successfully' : 'Property marked as leased successfully')
          : (isCurrentlySold ? 'Property marked as unsold successfully' : 'Property marked as sold successfully'));
      // Invalidate listing cache so My Listings reflects the new sold status immediately
      invalidateCache.properties();
      // Refresh property data
      const res = await getProperty(params.id);
      setProperty(res.data);
      setPurchasers(derivePurchasers(res.data));
      setShowSoldModal(false);
    } catch (err) {
      toast.error('Failed to update sold status');
      console.error('Sold toggle error:', err);
    } finally {
      setIsMarkingSold(false);
    }
  };

  // Correct the details of a sale that is already recorded (wrong sold date,
  // price, split or buyer) without marking the property unsold first. The
  // backend treats is_sold=true on a sold property as a correction and updates
  // the existing commission in place. Portals are not re-published here; the
  // toast offers that step.
  const handleSaveSaleDetails = async (soldDetails) => {
    setIsSavingSale(true);
    try {
      await patchProperty(params.id, buildSaleDetailsPatch(soldDetails, { withPurchasers: true }));
      invalidateCache.properties();
      const res = await getProperty(params.id);
      setProperty(res.data);
      setPurchasers(derivePurchasers(res.data));
      setShowEditSaleModal(false);
      promptPublishSold(() => setShowPublishSoldModal(true));
    } catch (err) {
      toast.error('Failed to save sale details');
      console.error('Save sale details error:', err);
    } finally {
      setIsSavingSale(false);
    }
  };

  // Email the new buyer a link to claim this (sold) property into their portal
  // My Property Portfolio. For portal sales the backend already sent this
  // automatically; this button covers off-portal sales and re-sends. When we
  // don't have the buyer on file, prompt the agent for their email.
  const handleSendClaimInvite = async () => {
    const payload = {};
    const knownEmail = property?.purchaser_email || '';
    const email = window.prompt(
      "Email address to send the property-claim link to (leave blank to use the buyer from the accepted offer):",
      knownEmail,
    );
    // prompt returns null on Cancel — abort silently.
    if (email === null) return;
    if (email.trim()) payload.email = email.trim();

    setIsSendingClaim(true);
    try {
      const res = await sendPropertyClaimInvite(params.id, payload);
      toast.success(res?.data?.detail || 'Claim invite sent to the buyer.');
    } catch (err) {
      toast.error(
        err?.response?.data?.detail
        || 'Could not send the claim invite. Add the buyer\'s email and try again.',
      );
    } finally {
      setIsSendingClaim(false);
    }
  };

  const handleToggleUnderContract = async () => {
    setIsMarkingUnderContract(true);
    const isCurrentlyUnderContract = !!property?.is_under_contract;
    try {
      await patchProperty(params.id, { is_under_contract: !isCurrentlyUnderContract });
      const ucLabel = property?.transaction_type === 'lease' ? 'Under Application' : 'Under Contract';
      toast.success(isCurrentlyUnderContract
        ? `Property removed from ${ucLabel}`
        : `Property marked as ${ucLabel}`);
      invalidateCache.properties();
      const res = await getProperty(params.id);
      setProperty(res.data);
      setShowUnderContractModal(false);
    } catch (err) {
      toast.error('Failed to update Under Contract status');
      console.error('Under Contract toggle error:', err);
    } finally {
      setIsMarkingUnderContract(false);
    }
  };

  // Picking a category is the single action: it tags the sale as sold-through-portal
  // AND records the category in one request.
  const handlePortalCategorySelect = async (categoryKey) => {
    await patchProperty(params.id, {
      sold_through_collings_portal: true,
      portal_attribution_category: categoryKey,
    });
    const res = await getProperty(params.id);
    setProperty(res.data);
    toast.success('Marked as sold through the Collings portal');
  };

  const handlePortalAttributionClear = async () => {
    await patchProperty(params.id, {
      sold_through_collings_portal: false,
      portal_attribution_category: '',
    });
    const res = await getProperty(params.id);
    setProperty(res.data);
    toast.success('Removed Collings portal attribution');
  };

  // The green "Listed" button: mark an appraisal as Listed (won, awaiting portal
  // upload). It drops out of Appraisal and into the Listed tile in My Listings.
  // Christian Gravias, Monday 13225851756.
  const handleMarkListed = async () => {
    setIsMarkingListed(true);
    try {
      await markPropertyListed(params.id);
      const res = await getProperty(params.id);
      if (res?.data) setProperty(res.data);
      toast.success("Marked as Listed — now in My Listings, awaiting portal upload.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not mark this as Listed.");
    } finally {
      setIsMarkingListed(false);
    }
  };

  const isPropertySold =
    property?.is_sold ||
    property?.status === 'Sold' ||
    property?.status?.name === 'Sold';

  // The property's current status name, lower-cased, for the Listed stage.
  const statusNameLower = (property?.status?.name || property?.status || '').toString().trim().toLowerCase();
  const isAppraisalStatus = statusNameLower === 'appraisal';
  const isListedStatus = statusNameLower === 'listed';

  // Rental listings use lease terminology instead of sale terminology:
  // "Under Contract" -> "Under Application", "Mark as Sold" -> "Mark as Leased".
  const isLease = property?.transaction_type === 'lease';

  // What the Mark-as-Sold / Edit Sale Details dialog starts from.
  const saleModalProps = {
    address: property?.address,
    initialSoldPrice: property?.sold_price,
    initialSuppress: property?.suppress_sold_price,
    agents,
    primaryAgentId: property?.agent?.id ?? property?.agent_id ?? "",
    primaryAgentName: property?.agent?.name ?? "",
    listingCoAgent: property?.co_agent ?? null,
    initialSoldDate: property?.sold_date ?? "",
    defaultSoldDate: defaultSoldDate(property),
    contractDate: contractDateOf(property),
    reaSoldLocked: Boolean(property?.rea_sold_locked),
    initialSettlementDate: property?.settlement_date ?? "",
    // Prefer whoever the recorded commission actually splits with, so
    // reopening the modal shows the real split, not the marketing co-agent.
    initialCoAgentId:
      property?.commission_co_agent?.id ??
      property?.co_agent?.id ??
      property?.co_agent ??
      "",
    initialSplitPercentage: property?.commission_split_percentage ?? "",
    initialNoCommissionCredit: property?.no_commission_credit ?? false,
    initialPurchasers: purchasers,
  };
  // Commercial listings publish to realcommercial.com.au (via the REA feed)
  // instead of the residential realestate.com.au feed.
  const isCommercial = ['commercial', 'business'].includes(
    String(property?.property_type || '').toLowerCase()
  ) || String(property?.property_class || '').toLowerCase() === 'commercial';
  // For a rental the completed state is "Leased" (we reuse the is_sold flag as the
  // completion marker, so isPropertySold doubles as "is leased" here).
  const isPropertyLeased = isLease && isPropertySold;

  const handleDeleteProperty = async () => {
    setIsDeleting(true);
    try {
      await deleteProperty(params.id);
      toast.success('Property permanently deleted');
      invalidateCache.properties();
      navigate(location.state?.from || '/properties');
    } catch (err) {
      toast.error('Failed to delete property');
      console.error('Delete property error:', err);
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  const handleDuplicateProperty = async (form) => {
    if (!property) return;
    try {
      setIsDuplicating(true);
      const loadingToast = toast.loading('Creating copy...');

      const fd = new FormData();
      const subNumber = form.sub_number || '';
      const streetNumber = form.street_number || '0';
      const street = form.street || property.street || '';
      const suburb = property.suburb || '';
      const state = property.state || '';
      const postcodeRaw = property.postcode || property.extra_info?.postcode || '';
      const postcodeDigits = String(postcodeRaw).replace(/\D/g, '').slice(0, 4);
      const postcode = postcodeDigits.length === 4 ? postcodeDigits : '0000';

      // Prefer the explicit choice from the duplicate modal; fall back to inferring
      // from the property class for older callers that didn't pass transaction_type.
      const isRentalClass = ['rental', 'holidayRental'].includes(form.property_class);
      const transactionType =
        form.transaction_type === 'sale' || form.transaction_type === 'lease'
          ? form.transaction_type
          : (isRentalClass ? 'lease' : 'sale');
      const weeklyRentRaw =
        form.weekly_rent !== undefined && form.weekly_rent !== null
          ? String(form.weekly_rent).replace(/[$,\s]/g, '')
          : '';

      const addressParts = [
        subNumber ? `${subNumber}/${streetNumber}` : streetNumber,
        street,
        suburb,
        state,
        postcode,
      ].filter(Boolean);
      const address = addressParts.join(' ').trim() || (property.address || 'Copy of property');
      const title = property.title || property.headline || address;
      const parkings =
        property.parkings ?? property.garages ?? property.parking_spaces ?? 0;
      const agentId =
        property.agent_id ?? property.agent?.id ?? property.agent ?? null;

      fd.append('title', title);
      fd.append('address', address);
      fd.append('sub_number', subNumber);
      fd.append('street_number', streetNumber);
      fd.append('street', street);
      fd.append('street_name', street);
      fd.append('suburb', suburb);
      fd.append('city', suburb);
      fd.append('state', state);
      fd.append('postcode', postcode);
      fd.append('postal_code', postcode);
      fd.append('headline', property.headline || property.title || title);
      fd.append('description', property.description || ' ');
      fd.append('price', property.price || 0);
      fd.append('bedrooms', property.bedrooms || 0);
      fd.append('beds', property.beds ?? property.bedrooms ?? 0);
      fd.append('bathrooms', property.bathrooms || 0);
      fd.append('baths', property.baths ?? property.bathrooms ?? 0);
      fd.append('garages', property.garages || 0);
      fd.append('parkings', parkings);
      fd.append('open_spaces', property.open_spaces || 0);
      fd.append('toilets', property.toilets || 0);
      fd.append('status', form.status);
      fd.append('property_type', form.property_class || 'residential');
      fd.append('property_class', form.property_class || 'residential');
      fd.append('transaction_type', transactionType);
      // Persist weekly rent for lease duplicates; clear it for sale duplicates so the
      // copy doesn't carry over rental pricing from the source.
      if (transactionType === 'lease') {
        if (weeklyRentRaw && !Number.isNaN(Number(weeklyRentRaw))) {
          fd.append('weekly_rent', Number(weeklyRentRaw).toFixed(2));
        } else if (property.weekly_rent != null && property.weekly_rent !== '') {
          fd.append('weekly_rent', String(property.weekly_rent));
        }
      } else {
        fd.append('weekly_rent', '');
      }
      fd.append('method_of_sale', property.method_of_sale || 'Private Sale');
      fd.append('owner_visibilty', property.owner_visibilty ? 'true' : 'false');
      if (agentId) {
        fd.append('agent', agentId);
        fd.append('agent_id', agentId);
      }

      // Commission fields are required for new properties — copy from source so the
      // duplicate satisfies validation. Fallback to percentage/0 if source has none.
      const commissionType = property.commission_type || 'percentage';
      fd.append('commission_type', commissionType);
      if (commissionType === 'percentage') {
        fd.append('commission_rate', property.commission_rate ?? 0);
      } else {
        fd.append('commission_amount', property.commission_amount ?? 0);
      }
      if (property.commission_gst) fd.append('commission_gst', property.commission_gst);

      if (form.copy_owners) {
        fd.append('owner_name', property.owner_name || property.owner?.name || '');
        fd.append('owner_preferred_name', property.owner?.preferred_name || '');
        fd.append('contact', property.contact || property.owner?.contact || '');
        fd.append('email', property.email || property.owner?.email || '');
        const additional = (property.additional_owners || []).map((o) => ({
          name: o.name || '',
          preferred_name: o.preferred_name || '',
          contact: o.contact || '',
          email: o.email || '',
        }));
        if (additional.length > 0) {
          fd.append('additional_owners', JSON.stringify(additional));
        }
      }

      const extraInfo = { ...(property.extra_info || {}) };
      let existingUrls = [];
      if (form.copy_photos) {
        existingUrls = (property.images || [])
          .map((img) => (typeof img === 'object' && img?.file ? img.file : img))
          .filter((u) => typeof u === 'string' && u.length > 0);
        if (existingUrls.length > 0) extraInfo.images = existingUrls;
      } else {
        delete extraInfo.images;
      }
      if (Object.keys(extraInfo).length > 0) {
        fd.append('extra_info', JSON.stringify(extraInfo));
      }

      // Tell the BE to fetch these URLs and create PropertyImage rows on the duplicate.
      // BE also treats this as a bypass for the "images required" check.
      if (existingUrls.length > 0) {
        fd.append('copy_image_urls', JSON.stringify(existingUrls.slice(0, 35)));
      }

      const res = await registerProperty(fd);
      const newId =
        res?.data?.id || res?.data?.property?.id || res?.data?.pk || null;

      invalidateCache.properties();
      toast.dismiss(loadingToast);
      toast.success('Property duplicated');
      setShowDuplicateModal(false);
      if (newId) {
        navigate(`/properties/${newId}`);
      }
    } catch (err) {
      console.error('Failed to duplicate property:', err);
      const detail =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        'Failed to duplicate property';
      toast.error(detail);
    } finally {
      setIsDuplicating(false);
    }
  };

  // Gallery Management
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [showAllImages, setShowAllImages] = useState(false);
  const [updatingGallery, setUpdatingGallery] = useState(false);
  // Full-size photo viewer (index into property.images). The tiles are
  // square crops, so without this there was no way to actually look at an
  // uploaded photo from the CRM - checking one meant opening the live
  // listing (uploader report, 28 Sep 2026).
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const fileInputRef = useRef(null);
  const uploadPhotosRef = useRef(null);
  const targetImageForReplacement = useRef(null);

  useEffect(() => {
    if (lightboxIndex === null) return undefined;
    const count = property?.images?.length || 0;
    const onKey = (e) => {
      if (e.key === "Escape") setLightboxIndex(null);
      else if (e.key === "ArrowRight" && count > 1)
        setLightboxIndex((i) => (i + 1) % count);
      else if (e.key === "ArrowLeft" && count > 1)
        setLightboxIndex((i) => (i - 1 + count) % count);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightboxIndex, property?.images?.length]);

  // Open the viewer for a tile in the Manage Gallery dialog, which may be
  // showing an unsaved reorder - resolve back to the saved list by URL.
  const openLightboxFor = (img) => {
    const target = (typeof img === "object" ? img?.file : img)?.split("?")[0];
    const idx = (property?.images || []).findIndex(
      (i) => ((typeof i === "object" ? i?.file : i) || "").split("?")[0] === target
    );
    if (idx >= 0) setLightboxIndex(idx);
  };


  const handleReplaceImage = (img) => {
    targetImageForReplacement.current = img;
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    {
      const { rejected } = splitSupportedUploads([file]);
      if (rejected.length) {
        toast.error(rejectedUploadsMessage(rejected));
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
    }

    if (!targetImageForReplacement.current) return;

    // Use full URL or ID depending on what's available.
    // The backend uses URL matching to find images to delete.
    const imageToDelete = typeof targetImageForReplacement.current === 'object'
      ? targetImageForReplacement.current.file
      : targetImageForReplacement.current;

    const formData = new FormData();
    formData.append("images", file);
    formData.append("delete_images", JSON.stringify([imageToDelete]));

    try {
      setUpdatingGallery(true);
      const loadingToast = toast.loading("Replacing image...");

      await updateProperty(params.id, formData);
      invalidateCache.publicProperties();

      const res = await getProperty(params.id);
      setProperty(res.data);

      toast.dismiss(loadingToast);
      toast.success("Image replaced successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to replace image");
    } finally {
      setUpdatingGallery(false);
      targetImageForReplacement.current = null;
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleDeleteImage = async (img) => {
    const imageToDelete = typeof img === 'object' ? img.file : img;
    const formData = new FormData();
    formData.append("delete_images", JSON.stringify([imageToDelete]));

    try {
      setUpdatingGallery(true);
      await updateProperty(params.id, formData);
      invalidateCache.publicProperties();

      // Optimistic update or refetch
      const res = await getProperty(params.id);
      setProperty(res.data);
      toast.success("Image removed");
    } catch (err) {
      console.error(err);
      toast.error("Failed to remove image");
    } finally {
      setUpdatingGallery(false);
    }
  };

  // Upload already-vetted files (the Manage Gallery dialog vets its own pick;
  // the page's Upload Photos input vets in handleAddImages below).
  const uploadImages = async (files) => {
    if (!files || files.length === 0) return;
    const formData = new FormData();
    files.forEach(file => formData.append("images", file));

    try {
      setUpdatingGallery(true);
      const loadingToast = toast.loading("Uploading images...");

      await updateProperty(params.id, formData);
      invalidateCache.publicProperties();

      const res = await getProperty(params.id);
      setProperty(res.data);

      toast.dismiss(loadingToast);
      toast.success("Images uploaded successfully");
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.detail || "Failed to upload images");
    } finally {
      setUpdatingGallery(false);
      if (uploadPhotosRef.current) uploadPhotosRef.current.value = "";
    }
  };

  const handleAddImages = async (e) => {
    const picked = Array.from(e.target.files);
    if (picked.length === 0) return;
    // Name any file the portals can't take BEFORE the upload starts - the
    // matching backend check would 400 the whole batch anyway.
    const { ok: files, rejected } = splitSupportedUploads(picked);
    if (rejected.length) toast.error(rejectedUploadsMessage(rejected));
    if (files.length === 0) {
      if (uploadPhotosRef.current) uploadPhotosRef.current.value = "";
      return;
    }
    await uploadImages(files);
  };

  // Mark / unmark an uploaded image as the floor plan. Floorplan-flagged
  // images leave the regular photo feed and go to REA's own Floorplan tab
  // (max 2, per REA), where plans render in a zoomable viewer instead of
  // being letterboxed and shrunk in the photo carousel - the "blurry plan
  // with black bars" report, 28 Sep 2026. Uses the property PUT's
  // floorplan_existing field, so the flag change re-syncs REA on its own.
  const handleToggleFloorplan = async (img) => {
    const urlOf = (i) => ((typeof i === "object" ? i?.file : i) || "").split("?")[0];
    const target = urlOf(img);
    if (!target) return;
    const flagged = (property?.images || [])
      .filter((i) => typeof i === "object" && i.is_floorplan)
      .map(urlOf);
    const isFlagged = flagged.includes(target);
    if (!isFlagged && flagged.length >= 2) {
      toast.error("REA allows at most 2 floor plan images - unmark one first.");
      return;
    }
    const next = isFlagged ? flagged.filter((u) => u !== target) : [...flagged, target];
    const formData = new FormData();
    formData.append("floorplan_existing", JSON.stringify(next));
    try {
      setUpdatingGallery(true);
      await updateProperty(params.id, formData);
      invalidateCache.publicProperties();
      const res = await getProperty(params.id);
      setProperty(res.data);
      toast.success(
        isFlagged
          ? "No longer marked as a floor plan."
          : "Marked as floor plan - it will appear under REA's Floorplan tab."
      );
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.detail || "Failed to update the floor plan flag");
    } finally {
      setUpdatingGallery(false);
    }
  };

  // Persist a new photo order from the Manage Gallery dialog (it autosaves;
  // see ManageGalleryDialog). Refetch so the page and the public portal read
  // the same order the backend settled on.
  const saveImageOrder = async (reorderedUrls) => {
    await reorderPropertyImages(params.id, reorderedUrls);
    invalidateCache.publicProperties();
    const res = await getProperty(params.id);
    setProperty(res.data);
  };

  const formatDescription = (description) => {
    if (!description) return ['No description available.'];
    let paragraphs = description.split(/\n\n+/);
    if (paragraphs.length === 1) {
      paragraphs = description.split(/\n/);
    }
    if (paragraphs.length === 1) {
      paragraphs = description.split(/\.\s+(?=[A-Z])/);
      paragraphs = paragraphs.map(p => p.trim() + (p.endsWith('.') ? '' : '.'));
    }
    return paragraphs.map(p => p.trim()).filter(p => p.length > 0);
  };

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center min-h-screen bg-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#55C5D0] mx-auto mb-4"></div>
          <p className="text-lg text-[#374151] font-medium">Loading property details...</p>
        </div>
      </div>
    );
  }

  if (error || !property) {
    return (
      <div className="flex-1 flex items-center justify-center bg-gray-50">
        <div className="text-center p-8 bg-white rounded-xl shadow-sm border border-gray-100 max-w-md">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-8 h-8 text-red-400" />
          </div>
          <h3 className="text-xl font-semibold text-[#374151] mb-2">{error || "Property Not Found"}</h3>
          <p className="text-[#374151] opacity-70 mb-6 font-medium">The property you're looking for doesn't exist or has been removed from our database.</p>
          <Link to="/properties">
            <Button className="w-full bg-[#55C5D0] hover:bg-[#4AADB7] text-white py-6 rounded-xl font-bold shadow-lg shadow-cyan-100 transition-all">
              Return to Listings
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  // "TypeForm Answers" tab — only rendered for properties created from the
  // hidden Block of Units vendor intake form (those carry appraisal_intake_data).
  const renderTypeformTab = () => {
    const data = property?.appraisal_intake_data || {};
    const m = data.metrics || {};
    const answers = data.answers || {};
    const block = answers.block || {};
    const units = answers.units || [];
    const docs = answers.documents || data.documents || [];
    const submittedAt = data.submittedAt;

    const fmtMoney = (v) =>
      v == null || v === "" ? "—" : "$" + Number(v).toLocaleString("en-AU", { maximumFractionDigits: 0 });
    const fmtPct = (v) => (v == null ? "N/A (no price)" : Number(v).toFixed(2) + "%");
    const fmtNum = (v) => (v == null || v === "" ? "—" : v);

    const metricCells = [
      { l: "Units", v: fmtNum(m.units) },
      { l: "Bedrooms (total)", v: fmtNum(m.bedrooms) },
      { l: "Car spaces (total)", v: fmtNum(m.carSpaces) },
      { l: "Tenanted", v: fmtNum(m.tenanted) },
      { l: "Vacant", v: fmtNum(m.vacant) },
      { l: "Owner occupied", v: fmtNum(m.ownerOccupied) },
      { l: "Rent / week", v: fmtMoney(m.rentPerWeek) },
      { l: "Gross rent p.a.", v: fmtMoney(m.grossRentPerAnnum) },
      { l: "Total outgoings p.a.", v: fmtMoney(m.totalOutgoings) },
      { l: "Net rent p.a.", v: fmtMoney(m.netRentPerAnnum) },
      { l: "Price (provided)", v: m.price == null ? "—" : fmtMoney(m.price) },
      { l: "Gross yield", v: fmtPct(m.grossYieldPct) },
      { l: "Net yield", v: fmtPct(m.netYieldPct) },
    ];

    const blockEntries = Object.entries(block)
      .map(([k, v]) => ({ k, question: (v && v.question) || k, answer: v && v.answer }))
      .filter((e) => e.answer != null && String(e.answer).trim() !== "");

    const unitLabels = {
      label: "Unit", beds: "Beds", baths: "Baths", size: "Size (sqm)", cars: "Car spaces",
      ownLaundry: "Own laundry", balcony: "Balcony / courtyard", status: "Status",
      rent: "Rent ($/wk)", leaseType: "Lease type", leaseEnd: "Lease end",
      bond: "Bond ($)", lastIncrease: "Last rent increase",
    };

    return (
      <div className="space-y-6 animate-in fade-in duration-500">
        <div className="bg-white border border-gray-100 p-6 rounded-xl">
          <div className="flex items-center justify-between flex-wrap gap-2">
            <h3 className="text-lg font-bold text-[#374151]">TypeForm Answers</h3>
            {submittedAt && (
              <span className="text-xs font-bold text-gray-400 uppercase tracking-wider">
                Submitted {new Date(submittedAt).toLocaleString("en-AU")}
              </span>
            )}
          </div>
          <p className="text-sm text-gray-500 mt-1">
            Submitted by the vendor through the Block of Units information form.
          </p>
        </div>

        {/* Key numbers */}
        <div className="bg-white border border-gray-100 p-6 rounded-xl">
          <h4 className="text-xs font-black uppercase tracking-[0.15em] text-[#374151] opacity-60 mb-4">
            Key Numbers
          </h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3">
            {metricCells.map((c) => (
              <div key={c.l} className="border border-gray-100 rounded-lg p-3 sm:p-4 bg-gray-50/50 min-w-0">
                <div className="text-lg sm:text-xl font-black text-[#374151] tabular-nums break-all">{c.v}</div>
                <div className="text-[11px] font-bold text-gray-500 uppercase tracking-wide mt-1">{c.l}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Units */}
        {units.length > 0 && (
          <div className="bg-white border border-gray-100 p-6 rounded-xl">
            <h4 className="text-xs font-black uppercase tracking-[0.15em] text-[#374151] opacity-60 mb-4">
              Units ({units.length})
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {units.map((u, i) => (
                <div key={i} className="border border-gray-100 rounded-lg p-4">
                  <div className="font-bold text-[#374151] mb-2">{u.label || "Unit " + (i + 1)}</div>
                  <dl className="space-y-1">
                    {Object.keys(unitLabels).map((key) => {
                      if (key === "label") return null;
                      const val = u[key];
                      if (val == null || String(val).trim() === "") return null;
                      return (
                        <div key={key} className="flex justify-between gap-4 text-sm">
                          <dt className="text-gray-500">{unitLabels[key]}</dt>
                          <dd className="text-[#374151] font-medium text-right">{String(val)}</dd>
                        </div>
                      );
                    })}
                  </dl>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* All answers */}
        <div className="bg-white border border-gray-100 p-6 rounded-xl">
          <h4 className="text-xs font-black uppercase tracking-[0.15em] text-[#374151] opacity-60 mb-4">
            All Answers
          </h4>
          {blockEntries.length === 0 ? (
            <p className="text-sm text-gray-400">No answers recorded.</p>
          ) : (
            <dl className="divide-y divide-gray-100">
              {blockEntries.map((e) => (
                <div key={e.k} className="py-3 grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-4">
                  <dt className="text-sm text-gray-500 sm:col-span-1">{e.question}</dt>
                  <dd className="text-sm text-[#374151] font-medium sm:col-span-2 whitespace-pre-wrap">
                    {String(e.answer)}
                  </dd>
                </div>
              ))}
            </dl>
          )}
        </div>

        {/* Documents the owner can provide */}
        {docs.length > 0 && (
          <div className="bg-white border border-gray-100 p-6 rounded-xl">
            <h4 className="text-xs font-black uppercase tracking-[0.15em] text-[#374151] opacity-60 mb-4">
              Documents The Owner Can Provide
            </h4>
            <ul className="space-y-2">
              {docs.map((d, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-[#374151]">
                  <span className="text-[#55C5D0] font-black">✓</span>
                  <span>{d}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  const renderPropertyTab = () => (
    <div className="space-y-6 animate-in fade-in duration-500">
      {/* Public share link surfaced at the top of the Property tab, directly
          under the action buttons (Monday 12667795949). Previously it sat in
          the right sidebar, so on mobile it stacked below the images/details. */}
      <ShareLinkCard property={property} />
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        <div className="xl:col-span-2 space-y-6">
          <div className="bg-white rounded-xl border border-gray-200 p-3 sm:p-6 shadow-sm">
            <div className="flex items-center justify-between mb-4 sm:mb-8">
              <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151]">Property Images</h3>
              {!isReadOnly && (
                <button
                  onClick={() => setIsGalleryOpen(true)}
                  className="px-5 py-2 bg-[#ECECEC] hover:bg-gray-200 text-[#374151] rounded-md text-[11px] font-bold transition-all"
                >
                  Edit Gallery
                </button>
              )}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4">
              {property?.images && property.images.length > 0 ? (
                property.images.map((img, idx) => (
                  <div
                    key={idx}
                    onClick={() => setLightboxIndex(idx)}
                    className={`group relative aspect-square bg-gray-100 rounded-lg sm:rounded-xl overflow-hidden cursor-pointer border-2 border-transparent hover:border-[#55C5D0] transition-all duration-300 ${
                      !showAllImages && idx >= 4 ? "hidden sm:block" : ""
                    }`}
                  >
                    <LazyImage
                      src={img?.file || img}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    {/* Hover Overlay */}
                    {!isReadOnly && (
                      <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleReplaceImage(img);
                          }}
                          className="w-10 h-10 bg-white/90 rounded-full flex items-center justify-center shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 hover:bg-white hover:text-[#55C5D0]"
                        >
                          <Edit className="w-5 h-5 text-[#55C5D0]" />
                        </button>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="col-span-3 aspect-[3/1] flex flex-col items-center justify-center bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
                  <Eye className="w-12 h-12 text-[#374151] opacity-20 mb-2" />
                  <p className="text-[#374151] opacity-50 font-medium">No images available for this property</p>
                </div>
              )}
            </div>

            {property?.images && property.images.length > 4 && (
              <button
                onClick={() => setShowAllImages(!showAllImages)}
                className="sm:hidden mt-3 w-full py-2 bg-[#ECECEC] hover:bg-gray-200 text-[#374151] rounded-md text-[11px] font-bold transition-all"
              >
                {showAllImages ? "Show less" : `Show all ${property.images.length} images`}
              </button>
            )}

            {/* Full-size photo viewer: click a tile (or the eye in Manage
                Gallery) to open, arrows to move, Esc / X / backdrop to close. */}
            {lightboxIndex !== null && property?.images?.[lightboxIndex] != null && (
              <div
                className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80"
                onClick={() => setLightboxIndex(null)}
              >
                <button
                  type="button"
                  aria-label="Close photo viewer"
                  className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition-colors"
                  onClick={() => setLightboxIndex(null)}
                >
                  <X className="w-6 h-6" />
                </button>
                <div className="absolute top-4 left-4 text-white/90 text-sm font-semibold bg-black/50 rounded-full px-3 py-1.5">
                  {lightboxIndex + 1} / {property.images.length}
                </div>
                {property.images.length > 1 && (
                  <>
                    <button
                      type="button"
                      aria-label="Previous photo"
                      className="absolute left-3 sm:left-6 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLightboxIndex(
                          (lightboxIndex - 1 + property.images.length) % property.images.length
                        );
                      }}
                    >
                      <ChevronLeft className="w-7 h-7" />
                    </button>
                    <button
                      type="button"
                      aria-label="Next photo"
                      className="absolute right-3 sm:right-6 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLightboxIndex((lightboxIndex + 1) % property.images.length);
                      }}
                    >
                      <ChevronRight className="w-7 h-7" />
                    </button>
                  </>
                )}
                <div
                  className="max-w-[90vw] max-h-[90vh] flex items-center justify-center"
                  onClick={(e) => e.stopPropagation()}
                >
                  <img
                    src={
                      property.images[lightboxIndex]?.file ||
                      property.images[lightboxIndex]
                    }
                    alt={`Property photo ${lightboxIndex + 1}`}
                    className="max-w-full max-h-[85vh] rounded-lg shadow-2xl object-contain"
                  />
                </div>
              </div>
            )}

            {/* Hidden File Input for Single Replacement */}
            <input
              type="file"
              ref={fileInputRef}
              className="hidden"
              accept={SUPPORTED_UPLOAD_ACCEPT}
              onChange={handleFileChange}
            />

            {/* Gallery Management Dialog (shared with the Collings and public
                property pages - see ManageGalleryDialog). */}
            <ManageGalleryDialog
              open={isGalleryOpen}
              onClose={() => setIsGalleryOpen(false)}
              images={property?.images || []}
              busy={updatingGallery}
              onReorder={saveImageOrder}
              onAddFiles={uploadImages}
              onDelete={handleDeleteImage}
              onToggleFloorplan={handleToggleFloorplan}
              onOpenLightbox={openLightboxFor}
            />
          </div>

          {/* Read-only viewers see this Visibility / agent block but cannot change it.
              `pointer-events-none` switches off every nested checkbox / select / button
              without restructuring the markup. The backend also rejects these writes
              for non-owners, so this is purely a UX lock. */}
          <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${isReadOnly ? 'pointer-events-none opacity-95' : ''}`}>
            <div className="space-y-6">
              {/* Visibility: only for On-Market Listing; Appraisal/Off-Market show different content */}
              {(() => {
                const statusName = property?.status?.name || property?.status || '';
                const isOnMarket = statusName === 'On Market Listing';
                const isAppraisal = statusName === 'Appraisal';
                const isOffMarket = statusName === 'Off Market Listing';
                if (isAppraisal) {
                  return (
                    <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
                      <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#111827] mb-4">Appraisal – Pipeline</h3>
                      <p className="text-[11px] text-[#374151] opacity-70 mb-4">No visibility options. Sorted in your pipeline by type and temperature.</p>
                      <div className="space-y-2 text-[11px] text-[#374151]">
                        <p><span className="font-medium">Type:</span> {property?.appraisal_market_type === 'on_market' ? 'On-Market' : property?.appraisal_market_type === 'off_market' ? 'Off-Market' : '—'}</p>
                        <p><span className="font-medium">Temperature:</span> {property?.appraisal_temperature ? String(property.appraisal_temperature).charAt(0).toUpperCase() + String(property.appraisal_temperature).slice(1) : '—'}</p>
                      </div>
                    </div>
                  );
                }
                if (isOffMarket) {
                  return (
                    <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
                      <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#111827] mb-8">Visibility (Off-Market)</h3>
                      <div className="space-y-4">
                        <div className="flex items-center justify-between group">
                          <div className="flex items-center space-x-3">
                            <input
                              type="checkbox"
                              checked={property?.published_on_website || false}
                              onChange={(e) => toggleVisibilityFlag('published_on_website', e.target.checked, {
                                successMessage: (on) => on ? 'Published to Collings Portal' : 'Unpublished from Collings Portal',
                              })}
                              disabled={!!visibilitySaving.published_on_website}
                              className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                            />
                            <span className="text-[11px] text-[#374151] font-medium whitespace-nowrap">Collings Portal</span>
                          </div>
                          <div className="flex items-center space-x-8">
                            <span className="text-[11px] text-[#374151] w-24 text-left opacity-70">Collings Portal only</span>
                            <div className="w-40 flex justify-start items-center space-x-2">
                              <VisibilitySavingPill field="published_on_website" />
                              {property?.published_on_website ? (
                                <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-green-100 text-green-600">
                                  <div className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" />
                                  Active
                                </span>
                              ) : (
                                <span className="text-[11px] text-[#374151] opacity-50">Inactive</span>
                              )}
                            </div>
                          </div>
                        </div>

                        {property?.published_on_website && (
                          <div className="pt-2 animate-in slide-in-from-top-1 duration-200">
                            <label className="block text-[11px] font-bold text-[#374151] mb-2">Launch Date & Time</label>
                            <input
                              type="datetime-local"
                              className="w-full text-[11px] border border-gray-100 rounded-lg px-3 py-2 outline-none focus:border-[#55C5D0] transition-all"
                              value={property?.listing_launch_at ? `${formatMelbourneDatePart(property.listing_launch_at)}T${formatMelbourneTimePart(property.listing_launch_at)}` : ''}
                              onChange={async (e) => {
                                const utc = datetimeLocalToUtcISOString(e.target.value);
                                try {
                                  await patchProperty(property.id, { listing_launch_at: utc });
                                  setProperty(prev => ({ ...prev, listing_launch_at: utc }));
                                  toast.success('Launch date updated');
                                } catch (err) {
                                  toast.error('Failed to update launch date');
                                }
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
                if (!isOnMarket) return null;
                // "View" links to each public surface: the buyer-portal preview on the
                // Collings Portal row (needs a minted share slug), and the collings.com.au
                // website page on the Collings.com.au row. The website page is keyed by
                // the CRM property id, so it is built automatically for EVERY property and
                // never depends on a share slug (which is why the old portal link on this
                // row was hidden when a slug had not been minted).
                const websiteUrl = property?.id
                  ? `https://www.collings.com.au/property-detail/?properties=${property.id}`
                  : null;
                // Buyer-portal preview page (portal.collings.com.au/p/<slug>) for the
                // Collings Portal row; only available once a share slug is minted.
                const shareSlug = property?.share_slug || property?.share_token;
                const portalUrl = shareSlug
                  ? `${process.env.REACT_APP_BUYER_PORTAL_URL || 'https://portal.collings.com.au'}/p/${shareSlug}`
                  : null;
                // The crawler stores listing ids as a prefixed link-key ("rea_id 12345");
                // strip the prefix for display so the number reads cleanly and fits its
                // column instead of overflowing into the portal label.
                const formatListingId = (raw) =>
                  raw ? (String(raw).replace(/^\s*(rea_id|domain_id|listing_id)\s*/i, '').trim() || String(raw)) : '';
                // REA / Real Commercial resolve a listing by the trailing numeric id;
                // the slug text is decorative (REA rewrites it to the canonical URL on
                // redirect), so a link built from the stored id lands on the live page.
                // Prefer REA's own public listing id (learned from the REA enquiry
                // feed) — that's the id in the realestate.com.au URL. Fall back to
                // rea_listing_id (the crawler link key) for crawler-imported listings.
                const reaId = formatListingId(property?.rea_portal_listing_id || property?.rea_listing_id);
                const slugify = (s) =>
                  String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
                const reaSlugTail = [slugify(property?.suburb), slugify(property?.state)].filter(Boolean).join('-') || 'listing';
                const reaUrl = reaId ? `https://www.realestate.com.au/property-${reaSlugTail}-${reaId}` : null;
                const realcommercialUrl = reaId ? `https://www.realcommercial.com.au/property-${reaSlugTail}-${reaId}` : null;
                return (
                  <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
                    <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#111827] mb-8">Visibility (On-Market)</h3>
                    <div className="space-y-4">
                      <div className="flex items-center space-x-3 mb-2">
                        <input
                          type="checkbox"
                          className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                          checked={property?.internal_marketing && (isCommercial ? property?.published_on_realcommercial : property?.published_on_rea) && property?.published_on_domain && property?.published_on_collings}
                          disabled={isVisibilityBusy('tick_all')}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            // Commercial listings toggle Real Commercial, not the
                            // residential REA feed.
                            const primaryPortal = isCommercial ? 'published_on_realcommercial' : 'published_on_rea';
                            return toggleVisibilityFlag('tick_all', checked, {
                            fields: {
                              internal_marketing: checked,
                              [primaryPortal]: checked,
                              published_on_domain: checked,
                              published_on_collings: checked,
                            },
                            // This one flips the primary portal, so the backend may
                            // revert it if the push is refused — take the saved
                            // state back from the server rather than assuming.
                            onSaved: async (res) => {
                              const reaSync = res?.data?.rea_sync;
                              const updated = await getProperty(property.id);
                              setProperty(prev => ({
                                ...prev,
                                [primaryPortal]: updated.data[primaryPortal],
                                rea_listing_id: updated.data.rea_listing_id,
                                published_on_domain: updated.data.published_on_domain,
                                domain_listing_id: updated.data.domain_listing_id,
                              }));
                              // REA can refuse an unfinalised listing (price/range,
                              // agent, photos) — the other portals still enabled, so
                              // say what's missing rather than a blanket success.
                              if (checked && reaSync?.blocked) {
                                toast.error(reaSync.message || 'Listing not ready for REA — other portals enabled.', { duration: 8000 });
                              } else {
                                toast.success(checked ? 'All portals enabled' : 'All portals disabled');
                              }
                              // Domain has its own outcome on the same save (refused /
                              // still processing / description trimmed to its cap).
                              const domainSync = res?.data?.domain_sync;
                              if (domainSync && (domainSync.blocked || domainSync.pending || domainSync.success === false || domainSync.warnings?.length)) {
                                notifyDomainResult(domainSync, checked);
                              }
                            },
                            });
                          }}
                        />
                        <span className="text-[11px] text-[#374151] opacity-50 font-medium">(tick all)</span>
                        <VisibilitySavingPill field="tick_all" />
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.internal_marketing || false}
                            onChange={(e) => toggleVisibilityFlag('internal_marketing', e.target.checked, {
                              successMessage: (on) => on ? 'Enabled Internal Marketing' : 'Disabled Internal Marketing',
                            })}
                            disabled={isVisibilityBusy('internal_marketing')}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">Internal Marketing</span>
                        </div>
                        <div className="flex items-center space-x-6 pl-6 sm:pl-0">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" />
                          <div className="sm:w-52 flex justify-start items-center space-x-2">
                            <VisibilitySavingPill field="internal_marketing" />
                            {property?.internal_marketing ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-green-100 text-green-600">
                                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" />
                                Active
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">Inactive</span>
                            )}
                          </div>                        </div>
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_website || false}
                            onChange={(e) => toggleVisibilityFlag('published_on_website', e.target.checked, {
                              successMessage: (on) => on ? 'Published to Collings Portal' : 'Unpublished from Collings Portal',
                            })}
                            disabled={isVisibilityBusy('published_on_website')}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">Collings Portal</span>
                        </div>
                        <div className="flex items-center space-x-6 pl-6 sm:pl-0">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" />
                          <div className="sm:w-52 flex justify-start items-center space-x-2">
                            <VisibilitySavingPill field="published_on_website" />
                            {property?.published_on_website ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-green-100 text-green-600">
                                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" />
                                Live on Collings Portal
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">Not published</span>
                            )}
                            {property?.published_on_website && portalUrl && (
                              <a
                                href={portalUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open the buyer-portal preview"
                                className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                              >
                                <ExternalLink className="w-3 h-3" />
                                View
                              </a>
                            )}
                          </div>                        </div>
                      </div>
                      {!isCommercial && (
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_rea || false}
                            onChange={(e) => {
                              const newValue = e.target.checked;
                              return toggleVisibilityFlag('published_on_rea', newValue, {
                                onSaved: async (res) => {
                                  // The backend actually pushes to REA now and reverts the
                                  // flag if that push fails — reflect what really happened
                                  // rather than assuming the checkbox's intent succeeded.
                                  const reaSync = res?.data?.rea_sync;
                                  const updated = await getProperty(property.id);
                                  setProperty(prev => ({ ...prev, published_on_rea: updated.data.published_on_rea, rea_listing_id: updated.data.rea_listing_id }));
                                  // REA processes uploads asynchronously — "pending" means it
                                  // hadn't finished within our check window, not that it failed.
                                  if (reaSync?.pending) {
                                    toast(reaSync.message || 'REA is still processing this — check back shortly.');
                                  } else if (reaSync?.blocked) {
                                    // Listing isn't finalised (price/range, agent, photos) —
                                    // the backend kept it OFF REA and said what's missing.
                                    toast.error(reaSync.message || 'This listing is not ready to publish to REA yet.', { duration: 8000 });
                                  } else if (reaSync && !reaSync.success) {
                                    toast.error(`Failed to ${reaSync.action === 'withdrawn' ? 'unpublish from' : 'publish to'} REA: ${reaSync.message}`);
                                  } else {
                                    toast.success(newValue ? 'Published to REA' : 'Unpublished from REA');
                                  }
                                },
                              });
                            }}
                            disabled={isVisibilityBusy('published_on_rea')}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">realestate.com.au</span>
                        </div>
                        <div className="flex items-center space-x-6 pl-6 sm:pl-0">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" title={property?.rea_portal_listing_id || property?.rea_listing_id || ''}>{reaId || '-'}</span>
                          <div className="sm:w-52 flex justify-start items-center space-x-2">
                            <VisibilitySavingPill field="published_on_rea" />
                            {property?.published_on_rea ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">
                                <div className="w-1.5 h-1.5 rounded-full bg-cyan-400 mr-1.5" />
                                Published
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">-</span>
                            )}
                            {property?.published_on_rea && reaUrl && (
                              <a
                                href={reaUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open the listing on realestate.com.au"
                                className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                              >
                                <ExternalLink className="w-3 h-3" />
                                View
                              </a>
                            )}
                          </div>                        </div>
                      </div>
                      )}
                      {isCommercial && (
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_realcommercial || false}
                            onChange={(e) => {
                              const newValue = e.target.checked;
                              return toggleVisibilityFlag('published_on_realcommercial', newValue, {
                                onSaved: async (res) => {
                                  const reaSync = res?.data?.rea_sync;
                                  const updated = await getProperty(property.id);
                                  setProperty(prev => ({ ...prev, published_on_realcommercial: updated.data.published_on_realcommercial, rea_listing_id: updated.data.rea_listing_id }));
                                  if (reaSync?.pending) {
                                    toast(reaSync.message || 'Real Commercial is still processing this — check back shortly.');
                                  } else if (reaSync?.blocked) {
                                    toast.error(reaSync.message || 'This listing is not ready to upload to Real Commercial yet.', { duration: 8000 });
                                  } else if (reaSync && !reaSync.success) {
                                    toast.error(`Failed to ${reaSync.action === 'withdrawn' ? 'withdraw from' : 'upload to'} Real Commercial: ${reaSync.message}`);
                                  } else {
                                    toast.success(newValue ? 'Uploaded to Real Commercial' : 'Withdrawn from Real Commercial');
                                  }
                                },
                              });
                            }}
                            disabled={isVisibilityBusy('published_on_realcommercial')}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">realcommercial.com.au</span>
                        </div>
                        <div className="flex items-center space-x-6 pl-6 sm:pl-0">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" title={property?.rea_portal_listing_id || property?.rea_listing_id || ''}>{reaId || '-'}</span>
                          <div className="sm:w-52 flex justify-start items-center space-x-2">
                            <VisibilitySavingPill field="published_on_realcommercial" />
                            {property?.published_on_realcommercial ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">
                                <div className="w-1.5 h-1.5 rounded-full bg-cyan-400 mr-1.5" />
                                Published
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">-</span>
                            )}
                            {property?.published_on_realcommercial && realcommercialUrl && (
                              <a
                                href={realcommercialUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open the listing on realcommercial.com.au"
                                className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                              >
                                <ExternalLink className="w-3 h-3" />
                                View
                              </a>
                            )}
                          </div>                        </div>
                      </div>
                      )}
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_domain || false}
                            onChange={(e) => toggleVisibilityFlag('published_on_domain', e.target.checked, {
                              // The backend now pushes to / withdraws from Domain on
                              // this toggle and reverts the flag if Domain refuses -
                              // read the outcome back instead of assuming success.
                              onSaved: async (res) => {
                                const domainSync = res?.data?.domain_sync;
                                if (domainSync && (domainSync.blocked || (domainSync.success === false && !domainSync.pending))) {
                                  const updated = await getProperty(property.id);
                                  setProperty(prev => ({
                                    ...prev,
                                    published_on_domain: updated.data.published_on_domain,
                                    domain_listing_id: updated.data.domain_listing_id,
                                  }));
                                }
                                notifyDomainResult(domainSync, e.target.checked);
                              },
                            })}
                            disabled={isVisibilityBusy('published_on_domain')}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">domain.com.au</span>
                        </div>
                        <div className="flex items-center space-x-6 pl-6 sm:pl-0">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" title={property?.domain_listing_id || ''}>{formatListingId(property?.domain_listing_id) || '-'}</span>
                          <div className="sm:w-52 flex justify-start items-center space-x-2">
                            <VisibilitySavingPill field="published_on_domain" />
                            {property?.published_on_domain ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">
                                <div className="w-1.5 h-1.5 rounded-full bg-cyan-400 mr-1.5" />
                                Published
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">-</span>
                            )}
                            {(() => {
                              {/* domain.com.au redirects a bare ad id to the full listing URL */}
                              const domainAdId = String(property?.domain_listing_id || '').replace(/\D/g, '');
                              return property?.published_on_domain && domainAdId ? (
                                <a
                                  href={isCommercial ? `https://www.commercialrealestate.com.au/property/${domainAdId}` : `https://www.domain.com.au/${domainAdId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Open the live Domain listing"
                                  className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                                >
                                  <ExternalLink className="w-3 h-3" />
                                  View
                                </a>
                              ) : null;
                            })()}
                          </div>                        </div>
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_collings || false}
                            onChange={(e) => toggleVisibilityFlag('published_on_collings', e.target.checked, {
                              successMessage: (on) => on ? 'Published to Collings.com.au' : 'Unpublished from Collings.com.au',
                            })}
                            disabled={isVisibilityBusy('published_on_collings')}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">Collings.com.au</span>
                        </div>
                        <div className="flex items-center space-x-6 pl-6 sm:pl-0">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" />
                          <div className="sm:w-52 flex justify-start items-center space-x-2">
                            <VisibilitySavingPill field="published_on_collings" />
                            {property?.published_on_collings ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">Published</span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">-</span>
                            )}
                            {property?.published_on_collings && websiteUrl && (
                              <a
                                href={websiteUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open the live listing on collings.com.au"
                                className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                              >
                                <ExternalLink className="w-3 h-3" />
                                View
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}

              {!isLease && (
                <ComplianceChecklistCard
                  propertyId={property?.id || params.id}
                  onOpenFull={() => setActiveTab('compliance')}
                />
              )}

              <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
                <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-2">Campaign Representatives</h3>
                <p className="text-[11px] text-[#374151] opacity-70 mb-10 font-medium leading-relaxed">Select which agents are displayed as the official contacts for this campaign.</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-[11px] text-[#374151] mb-2 font-medium">Primary Agent</label>
                    <div className="relative group">
                      <select
                        className="w-full text-xs font-medium border border-gray-100 rounded-lg px-4 py-3 appearance-none bg-white focus:border-[#55C5D0] focus:ring-1 focus:ring-[#55C5D0] transition-all cursor-pointer"
                        value={property?.agent?.id || ''}
                        onChange={async (e) => {
                          const agentId = e.target.value;
                          try {
                            await patchProperty(property.id, { agent: agentId });
                            const updatedAgent = agents.find(a => String(a.id) === String(agentId)) || null;
                            setProperty(prev => ({ ...prev, agent: updatedAgent }));
                            toast.success("Primary agent updated");
                          } catch (err) {
                            toast.error("Failed to update agent");
                          }
                        }}
                        disabled={agentsLoading}
                      >
                        <option value="">Select Agent</option>
                        {agents.map((agent) => {
                          const displayName = agent.name || `${agent.first_name || ''} ${agent.last_name || ''}`.trim() || agent.email || 'Unknown Agent';
                          return (
                            <option key={agent.id} value={agent.id}>
                              {displayName}
                            </option>
                          );
                        })}
                      </select>
                      <ChevronDown className="w-4 h-4 text-gray-300 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none group-hover:text-[#55C5D0]" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-[11px] text-[#374151] mb-2 font-medium">Secondary Agent (Optional)</label>
                    <div className="relative group">
                      <select
                        className="w-full text-xs font-medium border border-gray-100 rounded-lg px-4 py-3 appearance-none bg-white focus:border-[#55C5D0] focus:ring-1 focus:ring-[#55C5D0] transition-all cursor-pointer"
                        value={secondAgentId}
                        onChange={async (e) => {
                          const agentId = e.target.value;
                          setSecondAgentId(agentId || '');
                          setMakeSecondaryAgentOnListing(!!agentId);
                          const coAgentValue = agentId || '';
                          try {
                            await patchProperty(property.id, { co_agent: coAgentValue });
                            const updatedCoAgent = coAgentValue ? (agents.find(a => String(a.id) === String(coAgentValue)) || null) : null;
                            setProperty(prev => ({ ...prev, co_agent: updatedCoAgent }));
                            toast.success(coAgentValue ? "Secondary agent updated" : "Secondary agent removed");
                          } catch (err) {
                            toast.error("Failed to update agent");
                          }
                        }}
                        disabled={agentsLoading}
                      >
                        <option value="">None</option>
                        {agents.map((agent) => {
                          const displayName = agent.name || `${agent.first_name || ''} ${agent.last_name || ''}`.trim() || agent.email || 'Unknown Agent';
                          return (
                            <option key={agent.id} value={agent.id}>
                              {displayName}
                            </option>
                          );
                        })}
                      </select>
                      <ChevronDown className="w-4 h-4 text-gray-300 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none group-hover:text-[#55C5D0]" />
                    </div>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-2">
                      This agent will have access to the listing but will not be shown on marketing.
                    </p>
                    <label className="block text-[11px] text-[#374151] mb-2 font-medium">Third Agent (Optional)</label>
                    <div className="relative group max-w-md">
                      <select
                        className="w-full text-xs font-medium border border-gray-100 rounded-lg px-4 py-3 appearance-none bg-white focus:border-[#55C5D0] focus:ring-1 focus:ring-[#55C5D0] transition-all cursor-pointer"
                        value={property?.tertiary_agent?.id || ''}
                        onChange={async (e) => {
                          const agentId = e.target.value;
                          try {
                            await patchProperty(property.id, { tertiary_agent: agentId || '' });
                            const updatedTertiary = agentId ? (agents.find(a => String(a.id) === String(agentId)) || null) : null;
                            setProperty(prev => ({ ...prev, tertiary_agent: updatedTertiary }));
                            toast.success(agentId ? "Third agent updated" : "Third agent cleared");
                          } catch (err) {
                            toast.error("Failed to update agent");
                          }
                        }}
                        disabled={agentsLoading}
                      >
                        <option value="">None</option>
                        {agents.map((agent) => {
                          const displayName = agent.name || `${agent.first_name || ''} ${agent.last_name || ''}`.trim() || agent.email || 'Unknown Agent';
                          return (
                            <option key={agent.id} value={agent.id}>
                              {displayName}
                            </option>
                          );
                        })}
                      </select>
                      <ChevronDown className="w-4 h-4 text-gray-300 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none group-hover:text-[#55C5D0]" />
                    </div>
                  </div>
                </div>
                <p className="text-[10px] text-[#374151] opacity-60 mb-10 font-medium">Selected agents (Primary and, when ticked, Secondary) will appear on buyer-facing listings and enquiry forms.</p>

                {/* Selected primary agent full details (name, email, phone) - like buyer portal */}
                {(() => {
                  const primaryAgent = agents.find(a => a.id === property?.agent?.id) || property?.agent;
                  if (!primaryAgent) return null;
                  const displayName = primaryAgent.name || `${primaryAgent.first_name || ''} ${primaryAgent.last_name || ''}`.trim() || primaryAgent.email || 'Property Agent';
                  const phone = primaryAgent.phone || primaryAgent.mobile || primaryAgent.mobile_number || primaryAgent.phone_number;
                  return (
                    <div className="mt-6 p-4 sm:p-5 rounded-xl border border-gray-100 bg-gray-50/50">
                      <h3 className="text-[12.93px] font-sans font-medium text-[#374151] mb-3 sm:mb-4">Property Agent (Primary)</h3>
                      <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                        {primaryAgent.photo ? (
                          <img src={primaryAgent.photo} alt={displayName} className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-[#55C5D0]/20" />
                        ) : (
                          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#55C5D0]/10 flex items-center justify-center text-[#55C5D0] text-base sm:text-lg font-bold">
                            {displayName.charAt(0) || 'A'}
                          </div>
                        )}
                        <div>
                          <p className="text-[13px] sm:text-[14px] font-bold text-[#374151]">{displayName}</p>
                          {(primaryAgent.title || primaryAgent.role) && (
                            <p className="text-[11px] sm:text-[12px] text-[#6B7280]">{primaryAgent.title || primaryAgent.role}</p>
                          )}
                        </div>
                      </div>
                      <div className="space-y-2 sm:space-y-2.5">
                        {primaryAgent.email && (
                          <a href={`mailto:${primaryAgent.email}`} className="flex items-center gap-2 sm:gap-2.5 min-w-0 text-[#374151] hover:text-[#55C5D0] transition-colors group">
                            <div className="p-1.5 bg-white rounded-lg border border-gray-100 group-hover:border-[#55C5D0]/30 transition-colors shrink-0">
                              <Mail className="w-4 h-4 text-[#55C5D0]" />
                            </div>
                            <span className="text-[11px] sm:text-[12px] font-medium break-all">{primaryAgent.email}</span>
                          </a>
                        )}
                        {phone && (
                          <a href={`tel:${phone}`} className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group">
                            <div className="p-1.5 bg-white rounded-lg border border-gray-100 group-hover:border-[#55C5D0]/30 transition-colors">
                              <Phone className="w-4 h-4 text-[#55C5D0]" />
                            </div>
                            <span className="text-[11px] sm:text-[12px] font-medium">{phone}</span>
                          </a>
                        )}
                        {!primaryAgent.email && !phone && (
                          <p className="text-[11px] text-[#6B7280] font-medium">No contact details on file for this agent.</p>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Selected secondary agent full details when set */}
                {(() => {
                  const coAgentId = property?.co_agent?.id ?? property?.co_agent;
                  const secondaryAgent = typeof coAgentId !== 'undefined' && coAgentId
                    ? (agents.find(a => a.id === coAgentId) || property?.co_agent)
                    : null;
                  if (!secondaryAgent) return null;
                  const displayName = secondaryAgent.name || `${secondaryAgent.first_name || ''} ${secondaryAgent.last_name || ''}`.trim() || secondaryAgent.email || 'Secondary Agent';
                  const phone = secondaryAgent.phone || secondaryAgent.mobile || secondaryAgent.mobile_number || secondaryAgent.phone_number;
                  return (
                    <div className="mt-4 p-4 sm:p-5 rounded-xl border border-gray-100 bg-gray-50/50">
                      <h3 className="text-[12.93px] font-sans font-medium text-[#374151] mb-3 sm:mb-4">Property Agent (Secondary)</h3>
                      <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                        {secondaryAgent.photo ? (
                          <img src={secondaryAgent.photo} alt={displayName} className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-[#55C5D0]/20" />
                        ) : (
                          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#55C5D0]/10 flex items-center justify-center text-[#55C5D0] text-base sm:text-lg font-bold">
                            {displayName.charAt(0) || 'A'}
                          </div>
                        )}
                        <div>
                          <p className="text-[13px] sm:text-[14px] font-bold text-[#374151]">{displayName}</p>
                          {(secondaryAgent.title || secondaryAgent.role) && (
                            <p className="text-[11px] sm:text-[12px] text-[#6B7280]">{secondaryAgent.title || secondaryAgent.role}</p>
                          )}
                        </div>
                      </div>
                      <div className="space-y-2 sm:space-y-2.5">
                        {secondaryAgent.email && (
                          <a href={`mailto:${secondaryAgent.email}`} className="flex items-center gap-2 sm:gap-2.5 min-w-0 text-[#374151] hover:text-[#55C5D0] transition-colors group">
                            <div className="p-1.5 bg-white rounded-lg border border-gray-100 group-hover:border-[#55C5D0]/30 transition-colors shrink-0">
                              <Mail className="w-4 h-4 text-[#55C5D0]" />
                            </div>
                            <span className="text-[11px] sm:text-[12px] font-medium break-all">{secondaryAgent.email}</span>
                          </a>
                        )}
                        {phone && (
                          <a href={`tel:${phone}`} className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group">
                            <div className="p-1.5 bg-white rounded-lg border border-gray-100 group-hover:border-[#55C5D0]/30 transition-colors">
                              <Phone className="w-4 h-4 text-[#55C5D0]" />
                            </div>
                            <span className="text-[11px] sm:text-[12px] font-medium">{phone}</span>
                          </a>
                        )}
                        {!secondaryAgent.email && !phone && (
                          <p className="text-[11px] text-[#6B7280] font-medium">No contact details on file for this agent.</p>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Third agent (access only, not shown on marketing) */}
                {(() => {
                  const tertId = property?.tertiary_agent?.id ?? property?.tertiary_agent;
                  const tertiaryAgent = typeof tertId !== 'undefined' && tertId
                    ? (agents.find(a => a.id === tertId) || property?.tertiary_agent)
                    : null;
                  if (!tertiaryAgent) return null;
                  const displayName = tertiaryAgent.name || `${tertiaryAgent.first_name || ''} ${tertiaryAgent.last_name || ''}`.trim() || tertiaryAgent.email || 'Third Agent';
                  const phone = tertiaryAgent.phone || tertiaryAgent.mobile || tertiaryAgent.mobile_number || tertiaryAgent.phone_number;
                  return (
                    <div className="mt-4 p-4 sm:p-5 rounded-xl border border-gray-100 bg-amber-50/50">
                      <h3 className="text-[12.93px] font-sans font-medium text-[#374151] mb-1">Third Agent (access only, not on marketing)</h3>
                      <p className="text-[10px] text-amber-700 mb-3">This agent has access to the listing but is not shown on marketing.</p>
                      <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                        {tertiaryAgent.photo ? (
                          <img src={tertiaryAgent.photo} alt={displayName} className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-[#55C5D0]/20" />
                        ) : (
                          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#55C5D0]/10 flex items-center justify-center text-[#55C5D0] text-base sm:text-lg font-bold">
                            {displayName.charAt(0) || 'A'}
                          </div>
                        )}
                        <div>
                          <p className="text-[13px] sm:text-[14px] font-bold text-[#374151]">{displayName}</p>
                          {(tertiaryAgent.title || tertiaryAgent.role) && (
                            <p className="text-[11px] sm:text-[12px] text-[#6B7280]">{tertiaryAgent.title || tertiaryAgent.role}</p>
                          )}
                        </div>
                      </div>
                      <div className="space-y-2 sm:space-y-2.5">
                        {tertiaryAgent.email && (
                          <a href={`mailto:${tertiaryAgent.email}`} className="flex items-center gap-2 sm:gap-2.5 min-w-0 text-[#374151] hover:text-[#55C5D0] transition-colors group">
                            <Mail className="w-4 h-4 text-[#55C5D0] shrink-0" />
                            <span className="text-[11px] sm:text-[12px] font-medium break-all">{tertiaryAgent.email}</span>
                          </a>
                        )}
                        {phone && (
                          <a href={`tel:${phone}`} className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group">
                            <Phone className="w-4 h-4 text-[#55C5D0]" />
                            <span className="text-[11px] sm:text-[12px] font-medium">{phone}</span>
                          </a>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {!isReadOnly && (
                  <>
                    <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-4 mt-8">Internal Notes (Optional)</h3>
                    <div className="relative">
                      <textarea
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                        className="w-full text-[11px] border border-gray-100 rounded-xl p-4 min-h-[80px] bg-white hover:border-gray-200 focus:border-[#55C5D0] transition-all font-medium placeholder:text-[#374151]/50 placeholder:text-[11px] outline-none resize-y"
                        placeholder="Add internal notes about the Property Price Statement or campaign.."
                      />
                      <div className="absolute bottom-2 right-2">
                        <button
                          onClick={handleSaveNote}
                          disabled={isUpdating}
                          className="px-3 py-1 bg-[#55C5D0] text-white rounded-md text-[10px] font-bold shadow-sm hover:bg-[#4AADB7] transition-all disabled:opacity-50"
                        >
                          {isUpdating ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Property Price Statement is a sale-only compliance document; not applicable to rentals. */}
            {!isLease && (
            <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-6 md:p-8 shadow-sm flex flex-col w-full max-w-full">
              <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-2 tracking-tight">Property Price Statement</h3>
              <p className="text-[11px] text-[#374151] opacity-70 mb-6 sm:mb-10 font-medium leading-relaxed">Official Property Price Statement (PPS) for this property, used for compliance and buyer disclosure.</p>

              <div className="mb-8 sm:mb-12">
                <h4 className="text-[12px] font-bold text-[#374151] mb-4 sm:mb-6 font-sans">Property Price Statement (PDF)</h4>
                {(() => {
                  const soiDoc = sortedSoiDocs[0];
                  const previousSoi = sortedSoiDocs.slice(1);
                  if (soiDoc) {
                    return (
                      <div className="bg-[#F8F9FB] rounded-xl p-4 sm:p-6 md:p-8 border border-gray-100/50">
                        <div className="flex flex-col gap-4">
                          <div className="space-y-3 sm:space-y-4 min-w-0 flex-1 order-1">
                            <div>
                              <span className="text-[11px] text-[#374151] font-bold">Current Statement</span>
                            </div>
                            <div className="space-y-2">
                              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 text-[11px] min-w-0">
                                <span className="text-[#374151] font-bold flex-shrink-0">File:</span>
                                <span className="text-[#374151] opacity-60 font-medium break-words [overflow-wrap:anywhere]" title={soiDoc.name}>{soiDoc.name || 'Property_Price_Statement.pdf'}</span>
                              </div>
                              <div className="flex items-center space-x-2 text-[11px]">
                                <span className="text-[#374151] font-bold whitespace-nowrap">Last Updated:</span>
                                <span className="text-[#374151] opacity-60 font-medium whitespace-nowrap">{soiDoc.uploaded_at ? new Date(soiDoc.uploaded_at).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : 'N/A'}</span>
                              </div>
                              <div className="flex items-center space-x-2 text-[11px]">
                                <span className="text-[#374151] font-bold whitespace-nowrap">Uploaded by:</span>
                                <span className="text-[#55C5D0] font-medium underline underline-offset-2 break-words min-w-0 cursor-pointer">{property?.agent?.name || 'Agent'}</span>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-row flex-wrap gap-[clamp(0.25rem,1vw,0.5rem)] w-full flex-shrink-0 order-2">
                            <a href={soiDoc.file} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center flex-1 min-w-[clamp(80px,22vw,140px)] md:min-w-0 md:w-full py-[clamp(0.5rem,1.2vh,0.65rem)] px-[clamp(0.75rem,2vw,1rem)] bg-[#E8F5E9] text-[#2E7D32] rounded-lg text-[clamp(9px,2vw,11px)] font-bold tracking-tight border border-[#C8E6C9] hover:bg-[#C8E6C9] transition-all text-center whitespace-nowrap">
                              Download
                            </a>
                            {!isReadOnly && (
                              <>
                                <button type="button" onClick={handleReplaceSOI} disabled={soiUploading} className="inline-flex items-center justify-center flex-1 min-w-[clamp(70px,18vw,120px)] md:min-w-0 md:w-full py-[clamp(0.5rem,1.2vh,0.65rem)] px-[clamp(0.75rem,2vw,1rem)] bg-[#E3F2FD] text-[#1976D2] rounded-lg text-[clamp(9px,2vw,11px)] font-bold tracking-tight border border-[#BBDEFB] hover:bg-[#BBDEFB] transition-all disabled:opacity-50 whitespace-nowrap">
                                  Replace
                                </button>
                                <button type="button" onClick={handleRemoveSOI} disabled={soiUploading} className="inline-flex items-center justify-center flex-1 min-w-[clamp(70px,18vw,120px)] md:min-w-0 md:w-full py-[clamp(0.5rem,1.2vh,0.65rem)] px-[clamp(0.75rem,2vw,1rem)] bg-[#FFEBEE] text-[#D32F2F] rounded-lg text-[clamp(9px,2vw,11px)] font-bold tracking-tight border border-[#FFCDD2] hover:bg-[#FFCDD2] transition-all disabled:opacity-50 whitespace-nowrap">
                                  Remove
                                </button>
                              </>
                            )}
                          </div>
                          {previousSoi.length > 0 && (
                            <div className="w-full order-3 pt-3 mt-1 border-t border-gray-200/70 space-y-2">
                              <span className="text-[11px] text-[#374151] font-bold">Previous versions</span>
                              {previousSoi.map((doc) => (
                                <div key={doc.id} className="flex items-center justify-between gap-2 text-[11px] min-w-0">
                                  <span className="text-[#374151] opacity-60 font-medium break-words [overflow-wrap:anywhere] min-w-0" title={doc.name}>{doc.name || 'Property_Price_Statement.pdf'}</span>
                                  <span className="text-[#374151] opacity-50 whitespace-nowrap flex-shrink-0">{doc.uploaded_at ? new Date(doc.uploaded_at).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}</span>
                                  <a href={doc.file} target="_blank" rel="noopener noreferrer" className="text-[#55C5D0] font-bold whitespace-nowrap flex-shrink-0 hover:underline">Download</a>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div className="bg-[#F8F9FB] rounded-xl p-6 sm:p-8 border border-gray-100/50 text-center">
                        <p className="text-[11px] text-[#374151] opacity-60">No Property Price Statement uploaded yet.</p>
                      </div>
                    );
                  }
                })()}
                {!isReadOnly && (
                  <div className="mt-0 pt-3 pb-3 px-4 bg-[#F1F3F9] rounded-b-xl border-x border-b border-gray-100/50">
                    <p className="text-[10px] text-[#374151] opacity-70 font-medium text-center">Uploading a new file makes it the current Property Price Statement. Previous versions are kept in the list above.</p>
                  </div>
                )}
              </div>

              {!isReadOnly && (
              <div>
                <h4 className="text-[12px] font-bold text-[#374151] mb-4 sm:mb-6 font-sans">Upload New Property Price Statement</h4>
                <input
                  ref={soiFileInputRef}
                  type="file"
                  accept=".pdf,application/pdf"
                  className="hidden"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) handleSOIUpload([file]);
                  }}
                />
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() => !soiUploading && soiFileInputRef.current?.click()}
                  onKeyDown={(e) => e.key === "Enter" && !soiUploading && soiFileInputRef.current?.click()}
                  onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (soiUploading) return;
                    const file = e.dataTransfer?.files?.[0];
                    if (file) handleSOIUpload([file]);
                  }}
                  className="border border-dashed border-gray-200 rounded-2xl p-8 sm:p-12 md:p-16 flex flex-col items-center justify-center text-center hover:bg-gray-50 hover:border-[#55C5D0]/30 transition-all cursor-pointer group bg-white touch-manipulation disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  <div className="w-16 h-12 mb-6">
                    <svg viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full text-[#55C5D0]">
                      <path d="M48 16C46.5 16 45.1 16.3 43.8 16.9C42.2 10.6 36.6 6 30 6C23.4 6 17.8 10.6 16.2 16.9C14.9 16.3 13.5 16 12 16C5.4 16 0 21.4 0 28C0 34.6 5.4 40 12 40H48C54.6 40 60 34.6 60 28C60 21.4 54.6 16 48 16Z" fill="currentColor" />
                      <path d="M30 18L22 26H28V34H32V26H38L30 18Z" fill="white" />
                    </svg>
                  </div>
                  <div className="space-y-2">
                    {soiUploading ? (
                      <p className="text-[11.5px] font-medium text-[#374151]">Uploading...</p>
                    ) : (
                      <>
                        <p className="text-[11.5px] font-medium text-[#374151]">
                          <span className="font-extrabold">Drag & drop</span> Property Price Statement
                        </p>
                        <p className="text-[11.5px] text-[#374151] opacity-70 font-medium">
                          PDF here or <span className="font-extrabold">click</span> to upload
                        </p>
                        <p className="text-[10px] text-[#374151] opacity-40 font-medium pt-1">Accepted format: PDF - Max file size: 2MB</p>
                      </>
                    )}
                  </div>
                </div>
                <p className="text-[10px] text-[#374151] opacity-60 mt-8 font-medium leading-relaxed">This document is required before the property can be publicly shared.</p>
              </div>
              )}
            </div>
            )}
          </div>

          <div className="bg-white rounded-2xl border border-gray-100 p-5 sm:p-10 shadow-sm mt-6">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-6 sm:mb-10">
              <div className="flex items-center space-x-4">
                <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151]">About the Property</h3>
              </div>
              {isEditingDescription ? (
                <div className="flex space-x-2">
                  <button onClick={() => setIsEditingDescription(false)} className="px-5 py-2 bg-[#ECECEC] text-[#374151] rounded-xl text-xs font-black tracking-widest transition-all uppercase">Cancel</button>
                  <button onClick={handleSaveDescription} disabled={isUpdating} className="px-5 py-2 bg-[#55C5D0] text-white rounded-xl text-xs font-black tracking-widest transition-all uppercase disabled:opacity-50">
                    {isUpdating ? "Saving..." : "Save Description"}
                  </button>
                </div>
              ) : (
                !isReadOnly && <button onClick={handleEditDescription} className="px-5 py-2 bg-[#ECECEC] text-[#374151] rounded-xl text-xs font-black tracking-widest transition-all uppercase">Edit Description</button>
              )}
            </div>

            {isEditingDescription ? (
              <>
                <textarea
                  value={descriptionEdit}
                  onChange={(e) => setDescriptionEdit(e.target.value)}
                  className="w-full min-h-[400px] p-6 text-sm text-[#374151] font-medium border border-gray-100 rounded-xl focus:border-[#55C5D0] outline-none leading-relaxed placeholder:text-[#374151]/40"
                  placeholder="Write a compelling property description..."
                />
                <DomainDescriptionCounter text={descriptionEdit} />
              </>
            ) : (
              <div className="text-[#374151] text-[13px] leading-[1.8] font-medium space-y-8 max-w-full">
                {formatDescription(property.description).map((paragraph, index) => (
                  <p key={index} className="opacity-90">{paragraph}</p>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
            <div className="flex items-center justify-between mb-8">
              <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151]">Property Information</h3>
              {isEditingInfo ? (
                <div className="flex space-x-2">
                  <button onClick={() => setIsEditingInfo(false)} className="px-3 py-1 bg-[#ECECEC] text-[#374151] rounded-md text-[10px] font-bold transition-all">Cancel</button>
                  <button onClick={handleSaveInfo} disabled={isUpdating} className="px-3 py-1 bg-[#55C5D0] text-white rounded-md text-[10px] font-bold transition-all disabled:opacity-50">
                    {isUpdating ? "Saving..." : "Save"}
                  </button>
                </div>
              ) : (
                !isReadOnly && <button onClick={handleEditInfo} className="px-3 py-1 bg-[#ECECEC] text-[#374151] rounded-md text-[10px] font-bold transition-all">Edit</button>
              )}
            </div>

            {isEditingInfo ? (() => {
              const editIsLease = editForm.transaction_type === 'lease';
              return (
              <div className="space-y-4">
                {!editIsLease && (
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Price Type</span>
                  <select
                    value={editForm.price_display || 'exact'}
                    onChange={(e) => handleInputChange('price_display', e.target.value)}
                    className="w-32 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                  >
                    <option value="exact">Asking Price</option>
                    <option value="range">Price Range</option>
                    <option value="contact">Contact Agent</option>
                  </select>
                </div>
                )}

                {editIsLease ? null : editForm.price_display === 'range' ? (
                  <>
                    <div className="flex items-center justify-between">
                      <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Price From</span>
                      <input
                        type="text"
                        value={editForm.price}
                        onChange={(e) => handleInputChange('price', e.target.value)}
                        placeholder="$1,200,000"
                        className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Price To</span>
                      <input
                        type="text"
                        value={editForm.price_to ?? ""}
                        onChange={(e) => handleInputChange('price_to', e.target.value)}
                        placeholder="$1,350,000"
                        className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                      />
                    </div>
                  </>
                ) : editForm.price_display === 'contact' ? (
                  <div className="flex items-center justify-between">
                    <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                      Guided Price <span className="opacity-50">(Optional)</span>
                    </span>
                    <input
                      type="text"
                      value={editForm.price}
                      onChange={(e) => handleInputChange('price', e.target.value)}
                      placeholder="Optional"
                      className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                    />
                  </div>
                ) : (
                  <div className="flex items-center justify-between">
                    <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Asking Price</span>
                    <input
                      type="text"
                      value={editForm.price}
                      onChange={(e) => handleInputChange('price', e.target.value)}
                      className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                    />
                  </div>
                )}
                {!editIsLease && (
                <div className="space-y-1.5">
                  <span className="block font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                    Price Display Text <span className="opacity-50">(Optional)</span>
                  </span>
                  <input
                    type="text"
                    value={editForm.price_display_text ?? ""}
                    onChange={(e) => handleInputChange('price_display_text', e.target.value)}
                    placeholder='e.g. "Offers above $1,250,000"'
                    maxLength={255}
                    className="w-full text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                  />
                  <p className="text-[10px] text-[#374151] opacity-50 leading-snug">
                    Overrides the price display on the Collings Portal when set.
                  </p>
                </div>
                )}
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Weekly Rent</span>
                  <input
                    type="text"
                    value={editForm.weekly_rent ?? ""}
                    onChange={(e) => handleInputChange('weekly_rent', e.target.value)}
                    placeholder="Optional"
                    className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                  />
                </div>
                {editIsLease && (
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Bond</span>
                  <input
                    type="text"
                    value={editForm.bond ?? ""}
                    onChange={(e) => handleInputChange('bond', e.target.value)}
                    placeholder="Auto from rent"
                    className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                  />
                </div>
                )}
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Category</span>
                  <select
                    value={editForm.property_type}
                    onChange={(e) => handleInputChange('property_type', e.target.value)}
                    className="w-32 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                  >
                    <option value="residential">residential</option>
                    <option value="commercial">commercial</option>
                    <option value="land">land</option>
                    <option value="rural">rural</option>
                    <option value="business">business</option>
                  </select>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Class</span>
                  <select
                    value={editForm.property_class}
                    onChange={(e) => handleInputChange('property_class', e.target.value)}
                    className="w-40 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                  >
                    {/* Options mirror the Buyer Portal tab list (see AddPropertyPage "Portal Tab") */}
                    <option value="Apartment/Unit/Villa">Apartment/Unit/Villa</option>
                    <option value="House">House</option>
                    <option value="Townhouse">Townhouse</option>
                    <option value="Blocks of Units">Blocks of Units</option>
                    <option value="Land">Land</option>
                    <option value="House & Land Package">House & Land Package</option>
                    <option value="Off-the-Plan Apartment">Off-the-Plan Apartment</option>
                    <option value="Off-the-Plan Townhouse">Off-the-Plan Townhouse</option>
                    <option value="Commercial Property">Commercial Property</option>
                    {/* Fallback so a legacy property_class that isn't in the list above
                        (e.g. "Apartment", "House and Land", "Block of Units") still
                        displays rather than rendering as a blank selection. */}
                    {editForm.property_class &&
                      !['Apartment/Unit/Villa', 'House', 'Townhouse', 'Blocks of Units', 'Land', 'House & Land Package', 'Off-the-Plan Apartment', 'Off-the-Plan Townhouse', 'Commercial Property'].includes(editForm.property_class) && (
                        <option value={editForm.property_class}>{editForm.property_class}</option>
                      )}
                  </select>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Type</span>
                  <select
                    value={editForm.transaction_type}
                    onChange={(e) => handleInputChange('transaction_type', e.target.value)}
                    className="w-32 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                  >
                    <option value="all">All</option>
                    <option value="sale">For Sale</option>
                    <option value="lease">Lease</option>
                    <option value="both">Both</option>
                  </select>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Status</span>
                  <select
                    value={editForm.status}
                    onChange={(e) => handleInputChange('status', e.target.value)}
                    className="w-48 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                  >
                    <option value="All">All</option>
                    <option value="Prospect / Not Currently Listed">Prospect / Not Currently Listed</option>
                    <option value="Appraisal">Appraisal</option>
                    <option value="Listed">Listed</option>
                    <option value="On Market Listing">On Market Listing</option>
                    <option value="Off Market Listing">Off Market Listing</option>
                  </select>
                </div>
                {!editIsLease && (
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Method of Sale</span>
                  <select
                    value={editForm.method_of_sale}
                    onChange={(e) => handleInputChange('method_of_sale', e.target.value)}
                    className="w-36 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                  >
                    <option value="Private Sale">Private Sale</option>
                    <option value="Auction">Auction</option>
                  </select>
                </div>
                )}

                {!editIsLease && editForm.method_of_sale === 'Auction' && (
                  <>
                    <div className="flex items-center justify-between">
                      <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Auction Date</span>
                      <input
                        type="date"
                        value={editForm.auction_date}
                        onChange={(e) => handleInputChange('auction_date', e.target.value)}
                        className="w-36 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Auction Time</span>
                      <input
                        type="time"
                        value={editForm.auction_time}
                        onChange={(e) => handleInputChange('auction_time', e.target.value)}
                        className="w-36 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                      />
                    </div>
                  </>
                )}
                {[
                  { field: 'beds', label: 'Bedrooms' },
                  { field: 'baths', label: 'Bathrooms' },
                  { field: 'parkings', label: 'Garage' },
                  { field: 'car_ports', label: 'Carports' },
                  { field: 'open_spaces', label: 'Open parking' }
                ].map(({ field, label }) => (
                  <div key={field} className="flex items-center justify-between">
                    <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                      {label}
                    </span>
                    <div className="flex items-center space-x-1 border border-gray-100 rounded-md bg-gray-50 overflow-hidden">
                      <button onClick={() => handleInputChange(field, Math.max(0, (editForm[field] || 0) - 1))} className="px-2 py-1 hover:bg-gray-200 text-[#374151] font-bold">-</button>
                      <span className="w-8 text-center text-xs font-bold text-[#374151]">{editForm[field] || 0}</span>
                      <button onClick={() => handleInputChange(field, (editForm[field] || 0) + 1)} className="px-2 py-1 hover:bg-gray-200 text-[#374151] font-bold">+</button>
                    </div>
                  </div>
                ))}
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Floor Area (m²)</span>
                  <div className="relative">
                    <input
                      type="number"
                      value={editForm.floor_area}
                      onChange={(e) => handleInputChange('floor_area', e.target.value)}
                      className="w-20 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] pr-6 text-[#374151]"
                    />
                    <span className="absolute right-1.5 top-1/2 -translate-y-1/2 text-[9px] text-[#374151] opacity-60 font-bold">m²</span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Land Area (m²)</span>
                  <div className="relative">
                    <input
                      type="number"
                      value={editForm.land_size}
                      onChange={(e) => handleInputChange('land_size', e.target.value)}
                      className="w-20 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] pr-6 text-[#374151]"
                    />
                    <span className="absolute right-1.5 top-1/2 -translate-y-1/2 text-[9px] text-[#374151] opacity-60 font-bold">m²</span>
                  </div>
                </div>
              </div>
              );
            })() : (
              <div className="space-y-5">
                {[
                  // Price / Method of Sale don't apply to rentals — Weekly Rent covers it there.
                  ...(!isLease ? [{ label: "Price", value: formatPriceDisplay(property), isPrice: true }] : []),
                  ...(property?.price_display_text ? [{ label: "Price Display Text", value: property.price_display_text, isPriceText: true }] : []),
                  ...(property?.weekly_rent != null && property.weekly_rent !== '' ? [{ label: "Weekly Rent", value: formatPrice(property.weekly_rent), isPrice: true }] : []),
                  ...(isLease && property?.bond != null && property.bond !== '' ? [{ label: "Bond", value: formatPrice(property.bond), isPrice: true }] : []),
                  { label: "Class", value: property.property_class || 'House', isBadge: true },
                  { label: "Type", value: property.transaction_type === 'sale' ? 'For Sale' : (property.transaction_type === 'lease' ? 'Lease' : property.transaction_type || 'For Sale'), isBadge: true },
                  { label: "Status", value: property.status?.name || property.status || 'Active', isBadge: true },
                  ...(!isLease ? [{ label: "Method of Sale", value: property.method_of_sale || 'Private Sale', isMethodOfSale: true }] : []),
                  ...(property.method_of_sale === 'Auction' && property.auction_date ? [{ label: "Auction Date", value: formatAuctionDateTime(property.auction_date) }] : []),
                  { label: "Bedrooms", value: property.beds, isNumeric: true },
                  { label: "Bathrooms", value: property.baths, isNumeric: true },
                  { label: "Garage", value: property.parkings, isNumeric: true },
                  { label: "Carports", value: property.car_ports, isNumeric: true },
                  { label: "Open parking", value: property.open_spaces, isNumeric: true },
                  { label: "Floor Area", value: property.floor_area },
                  { label: "Land Area", value: property.land_size },
                  { label: "Year Built", value: property.year_built }
                ].filter(item => {
                  // Filter out items with 0, null, undefined, or empty string values (except Price which is handled specially if needed, but usually price 0 is valid? user said "nothing static")
                  // Actually user said "display only the info we are getting". If we get 0, do we display it?
                  // User said "check nothing on the property detail should display static".
                  // "Floor Area: 0" is what they complained about. So 0 should be hidden.
                  if (item.isPrice || item.isPriceText || item.isBadge || item.isMethodOfSale || item.isNumeric) return true;
                  return item.value && item.value !== '0' && item.value !== '0.00';
                }).map((item, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151] opacity-70">
                      {item.label}
                    </span>
                    {item.isBadge ? (
                      <Badge className="bg-[#55C5D0]/10 text-[#55C5D0] hover:bg-[#55C5D0]/20 border-0 uppercase text-[10px] font-bold tracking-wider px-2 py-0.5">
                        {item.value}
                      </Badge>
                    ) : item.isPrice ? (
                      <span className="font-sans font-bold text-[12.93px] leading-[18.75px] text-[#55C5D0]">
                        {item.value}
                      </span>
                    ) : item.isPriceText ? (
                      <span className="font-sans font-bold text-[11.5px] leading-[17.24px] text-[#374151] text-right max-w-[65%] break-words">
                        {item.value}
                      </span>
                    ) : (
                      <span className="font-sans font-bold text-[12.93px] leading-[18.75px] text-[#374151]">
                        {item.value}{item.label.includes("Area") ? "m²" : ""}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
            <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-8">Listing Details</h3>
            <div className="space-y-5">
              <div className="flex items-center justify-between">
                <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Listing ID</span>
                <span className="text-xs font-medium text-[#374151]">{params.id.slice(-8).toUpperCase()}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Created</span>
                <span className="text-xs font-medium text-[#374151]">{formatDate(property.created_at)}</span>
              </div>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">Status</span>
                <span className="text-[10px] px-3 py-1 bg-[#E1F5FE] text-[#039BE5] rounded-full font-bold">
                  {property?.status?.name || property?.status || 'Active'}
                </span>

                {/* Scheduled Badge - only shown if launch date is in the future */}
                {property?.listing_launch_at && new Date(property.listing_launch_at) > new Date() && (
                  <span className="inline-flex items-center px-2 py-0.5 bg-[#55C5D0] text-white text-[9px] font-black rounded uppercase tracking-[0.2em] leading-none shadow-lg sm:flex-shrink-0 max-w-full animate-pulse">
                    🕐 SCHEDULED: {formatMelbourneDateTime(property.listing_launch_at)}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
            <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-8">Location</h3>
            <div className="flex items-start space-x-3">
              <div className="mt-0.5">
                <MapPin className="w-4 h-4 text-[#374151] opacity-40" />
              </div>
              <div className="space-y-1">
                <p className="text-xs font-bold text-[#374151]">{property.address || "Address not available"}</p>
                <p className="text-[11px] text-[#374151] opacity-70 font-normal leading-relaxed">
                  {property.address && !property.address.includes(property.suburb)
                    ? `${property.address}, ${property.suburb || '', property.state || ''}, ${property.postal_code || ''}`.replace(/, ,/g, ',').replace(/^, /, '').replace(/, $/, '')
                    : property.address}
                </p>
              </div>
            </div>
            {property.address && (
              <div className="mt-6 rounded-[12px] overflow-hidden border border-gray-200 shadow-sm h-[260px]">
                <iframe
                  title="Property location map"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent((property.address || "") + " Australia")}`}
                />
              </div>
            )}
          </div>
        </div>
      </div >
    </div >
  );

  return (
    <div className="flex-1 flex flex-col bg-[#F8FAFC] min-h-screen -mx-[14px] sm:-mx-4 md:-m-6">
      {/* Sticky only on md+ — on mobile the 6-button action grid makes the header
          too tall, so it pins over and clips the tab nav underneath. */}
      <div className="bg-white border-b border-gray-100 md:sticky md:top-0 md:z-40 shadow-sm">
        <div className="w-full px-4 sm:px-6 md:px-8 py-4 sm:py-6">
          <div className="flex flex-col gap-4">
            <div className="flex items-start sm:items-center gap-3 sm:gap-4 min-w-0">
              <button
                onClick={() => navigate(-1)}
                className="w-10 h-10 flex-shrink-0 bg-white border border-gray-200 rounded-xl flex items-center justify-center hover:bg-gray-50 transition-colors shadow-sm"
              >
                <ArrowLeft className="w-5 h-5 text-[#374151]" />
              </button>
              <div className="flex flex-col space-y-2 min-w-0 flex-1">
                <div className="flex items-center space-x-3 flex-wrap gap-1">
                  <span className={`inline-flex items-center px-2 py-0.5 text-white text-[9px] font-black rounded uppercase tracking-[0.2em] leading-none shadow-lg flex-shrink-0 ${(property?.status?.name || property?.status || '').toLowerCase().includes('off')
                    ? 'bg-orange-500 shadow-orange-100'
                    : (property?.status?.name || property?.status || '').toLowerCase().includes('sold')
                      ? 'bg-blue-500 shadow-blue-100'
                      : (property?.status?.name || property?.status || '').toLowerCase().includes('prospect')
                        ? 'bg-yellow-500 shadow-yellow-100'
                        : 'bg-green-500 shadow-green-100'
                    }`}>
                    {property?.status?.name || property?.status || 'Active'}
                  </span>
                  <span className="text-[10px] text-[#374151] opacity-70 font-bold uppercase tracking-widest flex items-center">
                    <Building2 className="w-3 h-3 mr-1" />
                    {property?.property_type || 'Residential'}
                  </span>
                  <PublicMatchBadge status={property?.public_match_status} />
                </div>
                <h1 className="text-xl sm:text-2xl md:text-3xl font-black text-[#374151] tracking-tighter leading-tight break-words">
                  {property.address}
                </h1>
                <CampaignSwitch source="crm" id={params.id} />
              </div>
            </div>

            <div className="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-center gap-2 sm:gap-4 sm:flex-shrink-0">
              {isReadOnly ? (
                <span className="col-span-2 inline-flex items-center gap-1.5 px-3 sm:px-5 py-2.5 sm:py-3 rounded-xl text-[10px] font-black uppercase tracking-widest bg-gray-100 text-gray-500 border border-gray-200">
                  <Lock className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">View Only — Not Your Listing</span>
                </span>
              ) : (
              <>
              <button
                onClick={() => navigate(`/properties/edit/${params.id}`)}
                className="flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 bg-[#2D3139] hover:bg-black text-white rounded-xl text-[10px] font-black transition-all shadow-xl shadow-black/5 active:scale-95 uppercase tracking-widest sm:flex-none min-w-0"
              >
                <Edit className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="truncate">EDIT PROPERTY</span>
              </button>
              <button
                onClick={() => setShowDuplicateModal(true)}
                disabled={isDuplicating}
                className="flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 bg-[#E8F4FA] hover:bg-[#D6EBF5] text-[#2C5F86] border-[#C9DDEA] disabled:opacity-50 disabled:cursor-not-allowed"
                title="Duplicate property (switch sales ↔ rental)"
              >
                <Copy className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="truncate">DUPLICATE</span>
              </button>
              <button
                onClick={async (e) => {
                  const btn = e.currentTarget;
                  btn.disabled = true;
                  try {
                    await draftArticle(params.id);
                    toast.success("Draft queued. It will appear in AI-SEO for review shortly.");
                  } catch (err) {
                    toast.error(err?.response?.data?.error || "Could not queue the draft. Please try again.");
                  } finally {
                    btn.disabled = false;
                  }
                }}
                className="flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 bg-[#F3ECFB] hover:bg-[#E9DDF7] text-[#6B3FA0] border-[#DCCAEF] disabled:opacity-50 disabled:cursor-not-allowed"
                title="Draft an AI-SEO article about this listing (goes to review, not published)"
              >
                <FileText className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="truncate">DRAFT ARTICLE</span>
              </button>
              {/* Green "Listed" button — the won-but-not-yet-uploaded stage.
                  Shown on an Appraisal (click to mark Listed) and on an already
                  Listed property (filled green, as the on-page status indicator).
                  Christian Gravias, Monday 13225851756. */}
              {(isAppraisalStatus || isListedStatus) && (
                <button
                  onClick={handleMarkListed}
                  disabled={isMarkingListed || isListedStatus}
                  title={isListedStatus
                    ? "Listed — awaiting portal upload"
                    : "Mark as Listed — moves it into My Listings, awaiting portal upload"}
                  className={`flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 ${isListedStatus
                    ? "bg-green-600 text-white border-green-600 cursor-default"
                    : "bg-[#E8F5E9] hover:bg-green-100 text-green-700 border-green-100"
                    } ${isMarkingListed ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  <Tag className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">{isListedStatus ? 'LISTED' : (isMarkingListed ? 'LISTING…' : 'LISTED')}</span>
                </button>
              )}
              <PropertyWithdrawControls property={property} onWithdraw={handlePropertyWithdraw} onRelist={handlePropertyRelist}>
                {({ onClick, loading }) => (
                  <button
                    onClick={onClick}
                    disabled={loading}
                    className={`flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 ${property?.is_withdrawn
                      ? "bg-[#E0F2F1] hover:bg-teal-50 text-teal-600 border-teal-100"
                      : "bg-[#FFF8E1] hover:bg-amber-50 text-amber-600 border-amber-100"
                      } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    <PauseCircle className="w-3.5 h-3.5 flex-shrink-0" />
                    <span className="truncate">{property?.is_withdrawn ? 'RELIST' : 'WITHDRAW'}</span>
                  </button>
                )}
              </PropertyWithdrawControls>
              <button
                onClick={() => setShowUnderContractModal(true)}
                disabled={isMarkingUnderContract}
                className={`flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 ${property?.is_under_contract
                  ? "bg-[#EDE7F6] hover:bg-purple-50 text-purple-600 border-purple-100"
                  : "bg-[#FFF3E0] hover:bg-orange-50 text-orange-600 border-orange-100"
                  } ${isMarkingUnderContract ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                <FileText className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="truncate">{property?.is_under_contract
                  ? (isLease ? 'CLEAR UNDER APPLICATION' : 'CLEAR UNDER CONTRACT')
                  : (isLease ? 'UNDER APPLICATION' : 'UNDER CONTRACT')}</span>
              </button>
              <button
                onClick={() => setShowSoldModal(true)}
                disabled={isMarkingSold}
                className={`flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 ${(property?.is_sold || property?.status === 'Sold' || property?.status?.name === 'Sold')
                  ? "bg-[#E8F5E9] hover:bg-green-50 text-green-600 border-green-100"
                  : "bg-[#E3F2FD] hover:bg-blue-50 text-blue-600 border-blue-100"
                  } ${isMarkingSold ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="truncate">{(property?.is_sold || property?.status === 'Sold' || property?.status?.name === 'Sold')
                  ? (isLease ? 'MARK UNLEASED' : 'MARK UNSOLD')
                  : (isLease ? 'MARK AS LEASED' : 'MARK AS SOLD')}</span>
              </button>

              {isPropertySold && !isLease && (
                <button
                  onClick={() => setShowEditSaleModal(true)}
                  disabled={isSavingSale}
                  title="Correct the sold date, price, settlement, commission split or buyer"
                  className={`flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 bg-[#F1F8E9] hover:bg-lime-50 text-[#558B2F] border-lime-100 ${isSavingSale ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  <Edit2 className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">EDIT SALE DETAILS</span>
                </button>
              )}

              {isPropertySold && (
                <button
                  onClick={handleSendClaimInvite}
                  disabled={isSendingClaim}
                  title="Email the buyer a link to claim this property in their portal portfolio"
                  className={`flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 col-span-2 sm:col-span-1 bg-[#E0F7FA] hover:bg-cyan-50 text-[#0B7B8B] border-cyan-100 ${isSendingClaim ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  <Mail className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">{isSendingClaim ? 'SENDING…' : 'EMAIL BUYER TO CLAIM'}</span>
                </button>
              )}

              {isPropertySold && !isLease && (
                <button
                  onClick={() => setShowPublishSoldModal(true)}
                  className="flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 col-span-2 sm:col-span-1 bg-cyan-50 hover:bg-cyan-100 text-[#3E9BA4] border-cyan-100"
                >
                  <Send className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">PUBLISH AS SOLD ON PORTALS</span>
                </button>
              )}

              {isPropertySold && (
                <div className="w-full sm:w-auto sm:min-w-[280px] flex-1">
                  <PortalAttributionPicker
                    soldThroughPortal={property?.sold_through_collings_portal}
                    selectedCategory={property?.portal_attribution_category || ''}
                    onSelect={handlePortalCategorySelect}
                    onClear={handlePortalAttributionClear}
                  />
                </div>
              )}


              {/* Delete is offered to anyone with full (edit) access to this
                  listing — the listing's own agent(s) and admin/PA — mirroring
                  the backend, which already lets an agent delete a listing they
                  own (editable_listings_q). Previously admin-only, which hid it
                  from the rental agents who manage their own listings. */}
              {hasFullAccess && (
                <button
                  onClick={() => setShowDeleteModal(true)}
                  disabled={isDeleting}
                  className="flex items-center justify-center space-x-2 px-3 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[10px] font-black transition-all shadow-sm active:scale-95 uppercase tracking-widest border sm:flex-none min-w-0 bg-red-50 hover:bg-red-100 text-red-600 border-red-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <Trash2 className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">DELETE</span>
                </button>
              )}
              </>
              )}

              <ConfirmModal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteProperty}
                loading={isDeleting}
                title="Delete Property"
                description={`Are you sure you want to permanently delete "${property?.address}"? This action cannot be undone and will remove the property from the entire system.`}
                confirmText="Delete Permanently"
                variant="danger"
              />
              <ConfirmModal
                isOpen={!!reaPublishConfirm}
                onClose={() => setReaPublishConfirm(null)}
                onConfirm={() => {
                  const pending = reaPublishConfirm;
                  setReaPublishConfirm(null);
                  if (pending) {
                    toggleVisibilityFlag(pending.field, pending.nextValue, {
                      ...pending.options,
                      __reaConfirmed: true,
                    });
                  }
                }}
                title="Publish to realestate.com.au?"
                description={`This will send "${property?.address || 'this property'}" live to realestate.com.au. REA may charge for the listing — only continue if this property should be advertised on REA.`}
                confirmText="Publish to REA"
                variant="danger"
              />
              <ConfirmModal
                isOpen={showUnderContractModal}
                onClose={() => setShowUnderContractModal(false)}
                onConfirm={handleToggleUnderContract}
                loading={isMarkingUnderContract}
                title={property?.is_under_contract
                  ? (isLease ? "Clear Under Application" : "Clear Under Contract")
                  : (isLease ? "Mark Property As Under Application" : "Mark Property as Under Contract")}
                description={property?.is_under_contract
                  ? (isLease
                    ? "Are you sure you want to clear the Under Application flag on this property? The Under Application badge will be removed."
                    : "Are you sure you want to clear the Under Contract flag on this property? The Under Contract badge will be removed.")
                  : (isLease
                    ? "Are you sure you want to mark this property as Under Application? It will stay in its current listing tab and show an Under Application badge until you mark it as Leased."
                    : "Are you sure you want to mark this property as Under Contract? It will stay in its current listing tab and show an Under Contract badge until you mark it as Sold.")}
                confirmText={property?.is_under_contract
                  ? "Clear"
                  : (isLease ? "Mark Under Application" : "Mark Under Contract")}
                variant={property?.is_under_contract ? "primary" : "primary"}
              />
              {(property?.is_sold || property?.status === 'Sold' || property?.status?.name === 'Sold') ? (
                <ConfirmModal
                  isOpen={showSoldModal}
                  onClose={() => setShowSoldModal(false)}
                  onConfirm={handleToggleSold}
                  loading={isMarkingSold}
                  title={isLease ? "Mark Property as Unleased" : "Mark Property as Unsold"}
                  description={isLease
                    ? "Are you sure you want to mark this property as unleased? It will be removed from leased properties and the tenancy details will remain."
                    : "Are you sure you want to mark this property as unsold? It will be removed from sold properties and commission records will remain."}
                  confirmText={isLease ? "Mark Unleased" : "Mark Unsold"}
                  variant="primary"
                />
              ) : isLease ? (
                <MarkLeasedModal
                  isOpen={showSoldModal}
                  onClose={() => setShowSoldModal(false)}
                  onConfirm={handleToggleSold}
                  loading={isMarkingSold}
                  address={property?.address}
                  initialLeaseAmount={property?.weekly_rent}
                  initialLettingFee={
                    property?.commission_type === 'fixed'
                      ? property?.commission_amount
                      : ""
                  }
                  initialTenancyStart={property?.sold_date ?? ""}
                  initialTenancyEnd={property?.settlement_date ?? ""}
                />
              ) : (
                <MarkSoldModal
                  isOpen={showSoldModal}
                  onClose={() => setShowSoldModal(false)}
                  onConfirm={handleToggleSold}
                  loading={isMarkingSold}
                  {...saleModalProps}
                />
              )}

              {isPropertySold && !isLease && (
                <MarkSoldModal
                  mode="edit"
                  isOpen={showEditSaleModal}
                  onClose={() => setShowEditSaleModal(false)}
                  onConfirm={handleSaveSaleDetails}
                  loading={isSavingSale}
                  {...saleModalProps}
                />
              )}

              <PublishSoldToPortalsModal
                isOpen={showPublishSoldModal}
                onClose={() => setShowPublishSoldModal(false)}
                address={property?.address}
                channels={[
                  { key: "rea", label: "realestate.com.au", sublabel: property?.rea_listing_id || "" },
                  { key: "website", label: "Collings Portal" },
                  { key: "collings", label: "Collings.com.au" },
                  { key: "domain", label: "domain.com.au", disabled: true, disabledReason: "Not yet connected for this property type" },
                  { key: "agentpoint", label: "agentpoint", disabled: true, disabledReason: "Not yet connected" },
                  { key: "ratemyagent", label: "RateMyAgent", disabled: true, disabledReason: "Not yet connected" },
                ]}
                reaSoldLocked={Boolean(property?.rea_sold_locked)}
                saleSummary={{
                  soldPrice: property?.sold_price,
                  soldDate: property?.sold_date,
                  suppressSoldPrice: property?.suppress_sold_price,
                }}
                onPublish={async (selectedChannels, { confirmReaSold } = {}) => {
                  const res = await publishSoldToPortals(property.id, selectedChannels, { confirmReaSold });
                  // Pick up the REA lock (and published flags) the push just set.
                  getProperty(params.id).then((r) => setProperty(r.data)).catch(() => {});
                  return res.data;
                }}
              />

            </div>
          </div>
        </div>
      </div>

      <div className="w-full space-y-10 mt-6">
        <div className="bg-white border-b border-gray-200 px-2 sm:px-6 md:px-8 overflow-x-auto">
          <nav className="flex space-x-6 sm:space-x-12 min-w-max pb-px">
            {[
              { id: 'property', label: 'Property' },
              { id: 'owner', label: 'Owner' },
              // Rentals use lease terminology: the purchaser is the renter.
              { id: 'purchaser', label: isLease ? 'Renter' : 'Purchaser' },
              ...((canViewBuyerData || isReadOnly)
                ? [{ id: 'enquiries',
                    // Rentals: "Buyers / Offers" -> "Applications".
                    label: canViewBuyerData
                    ? `Enquiries / Attendees / ${isLease ? 'Applications' : 'Buyers / Offers'} (${enquiries.length + bidderRegistrations.length + inspectionAttendees.length + propertyBuyers.length + offers.length})`
                    : `Enquiries / Attendees / ${isLease ? 'Applications' : 'Buyers / Offers'}`,
                    // The full label is far too long for a phone; on mobile the tab
                    // bar would horizontal-scroll mid-word. Show a compact label there.
                    mobileLabel: canViewBuyerData
                    ? `${isLease ? 'Applications' : 'Buyers'} (${enquiries.length + bidderRegistrations.length + inspectionAttendees.length + propertyBuyers.length + offers.length})`
                    : (isLease ? 'Applications' : 'Buyers') }]
                : []),
              // Christian: Analytics sits between the Enquiries/Attendees tab and Notes.
              { id: 'analytics', label: 'Analytics' },
              { id: 'notes', label: 'Agent Notes' },
              { id: 'photos', label: 'Photos' },
              { id: 'open_homes', label: 'Open Homes' },
              { id: 'documents', label: 'Documents' },
              // Compliance file: sale listings only (DOMA 12954696393).
              ...(!isLease ? [{ id: 'compliance', label: 'Compliance' }] : []),
              // Only present when this property came from the Block of Units
              // vendor intake form (it carries the raw submission payload).
              ...(property?.appraisal_intake_data
                ? [{ id: 'typeform', label: 'TypeForm Answers' }]
                : []),
              // Buyer Match is a sales-only feature; hide it on rentals.
              ...(!isLease ? [{ id: 'buyer_match', label: 'Buyer Match' }] : []),
              // Renter Match is the lease-listing sibling of Buyer Match
              // (Monday 12908991007) - share this rental with renters whose
              // saved search matches it, instead of hiding it on rentals.
              ...(isLease ? [{
                id: 'renter_match',
                label: renterMatchCount?.total != null
                  ? `Renter Match (${renterMatchCount.total})`
                  : 'Renter Match',
              }] : []),
              { id: 'notifications', label: 'Notifications' },
              { id: 'activity', label: 'Activity' },
            ].map((tab) => {
              const locked = isTabLocked(tab.id);
              return (
              <button
                key={tab.id}
                onClick={() => {
                  if (locked) {
                    toast('You have view-only access to this listing.', { icon: '🔒' });
                    return;
                  }
                  setActiveTab(tab.id);
                }}
                title={locked ? 'View-only access — this tab is locked' : undefined}
                aria-disabled={locked}
                className={`group py-6 px-1 border-b-4 font-black text-xs tracking-[0.15em] transition-all flex items-center uppercase ${activeTab === tab.id
                  ? 'border-[#55C5D0] text-[#55C5D0]'
                  : 'border-transparent text-[#374151] opacity-50 hover:opacity-100'
                  } ${locked ? 'cursor-not-allowed' : ''}`}
              >
                <span className="sm:hidden">{tab.mobileLabel || tab.label}</span>
                <span className="hidden sm:inline">{tab.label}</span>
                {locked && <Lock className="w-3 h-3 ml-1.5 shrink-0" />}
              </button>
              );
            })}
          </nav>
        </div>

        <div className="pb-20 px-4 sm:px-6 md:px-8">
          {/* Price reduction buyer alert: hold, cancel, who it reaches (CG, Monday 13458776745) */}
          {canViewBuyerData && property?.id && (
            <PriceReductionAlerts propertyId={property.id} priceKey={property.price} />
          )}
          {visibleTab === 'property' && renderPropertyTab()}
          {visibleTab === 'typeform' && renderTypeformTab()}
          {visibleTab === 'owner' && (
            <div className="animate-in zoom-in-95 duration-500 space-y-8">
              <div className="bg-white border border-gray-100 p-6 flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-bold text-[#374151] mb-1">Property Owners</h3>
                  <p className="text-xs text-[#374151] opacity-60 font-medium">Manage property owners and their information</p>
                </div>
                <button
                  onClick={() => setShowOwnerModal(true)}
                  className="flex items-center gap-2 px-5 py-2.5 bg-[#55C5D0] text-white rounded-lg text-xs font-bold uppercase tracking-wide shadow-lg shadow-cyan-100 hover:bg-[#4AADB7] transition-all"
                >
                  <User className="w-4 h-4" />
                  <span>Add Owner</span>
                </button>
              </div>
              <div className="space-y-4 sm:px-8">
                {owners.map((owner, idx) => {
                  const ownerPhone = owner.contact || owner.phone;
                  const ownerEmail = owner.email?.trim() || '';
                  const isExpanded = expandedOwnerIdx === idx;
                  const isResolving = resolvingOwnerIdx === idx;
                  return (
                    <div key={owner.id || idx} className={`bg-white border border-gray-100 shadow-sm transition-all ${isExpanded ? 'rounded-t-xl' : 'rounded-xl'}`}>
                      {/* Stacked on phones (same squeeze as the enquiry cards: the
                          action icons starved the name/email column). */}
                      <div className="p-4 sm:p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 hover:border-[#55C5D0]/30 transition-all group">
                        <div className="flex items-center space-x-3 sm:space-x-5 w-full sm:w-auto min-w-0">
                          <div className="w-12 h-12 bg-[#55C5D0] rounded-full flex items-center justify-center text-white shadow-sm shrink-0">
                            <User className="w-6 h-6" />
                          </div>
                          <div className="space-y-0.5 min-w-0 flex-1">
                            <div className="flex flex-wrap items-center gap-2">
                              <button
                                onClick={() => handleToggleOwnerExpand(owner, idx)}
                                disabled={isResolving}
                                className="inline-flex items-center gap-1 text-sm font-bold text-[#374151] hover:text-[#3a99a3] hover:underline transition-colors disabled:opacity-60"
                                title={isExpanded ? 'Collapse details' : "View details without leaving this property"}
                              >
                                {owner.name}
                                {isResolving ? (
                                  <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                ) : isExpanded ? (
                                  <ChevronDown className="w-3.5 h-3.5" />
                                ) : (
                                  <ChevronRight className="w-3.5 h-3.5" />
                                )}
                              </button>
                              {owner.isPrimary && (
                                <span className="text-[9px] font-bold uppercase tracking-wide px-2 py-0.5 bg-[#55C5D0]/10 text-[#55C5D0] rounded-full">Primary</span>
                              )}
                              {isExpanded && expandedOwnerContactId && (
                                <button
                                  onClick={() => navigate(`/contacts/${expandedOwnerContactId}`, {
                                    state: {
                                      returnTo: `/properties/${params.id}?tab=owner`,
                                      returnLabel: property?.address || property?.title || 'Property',
                                    },
                                  })}
                                  className="inline-flex items-center gap-1.5 text-sm font-bold text-[#55C5D0] hover:text-[#3a99a3] hover:underline transition-colors"
                                >
                                  View Full Profile <ExternalLink className="w-4 h-4" />
                                </button>
                              )}
                            </div>
                            {owner.preferred_name && (
                              <p className="text-[11px] text-[#374151] opacity-60 font-medium italic">
                                goes by {owner.preferred_name}
                              </p>
                            )}
                            <p className="text-[11px] text-[#374151] opacity-60 font-medium break-all">{ownerEmail || 'No email'}</p>
                            <p className="text-[11px] text-[#374151] opacity-60 font-medium">{ownerPhone || 'No phone'}</p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-3 self-end sm:self-auto sm:flex-shrink-0">
                          {ownerPhone ? (
                            <a href={`tel:${ownerPhone.replace(/\s/g, '')}`} className="p-2 text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors">
                              <Phone className="w-4 h-4" />
                            </a>
                          ) : (
                            <span className="p-2 text-gray-300 cursor-not-allowed" title="No phone"><Phone className="w-4 h-4" /></span>
                          )}
                          {ownerEmail ? (
                            <a href={`mailto:${ownerEmail}`} className="p-2 text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors">
                              <Mail className="w-4 h-4" />
                            </a>
                          ) : (
                            <span className="p-2 text-gray-300 cursor-not-allowed" title="No email"><Mail className="w-4 h-4" /></span>
                          )}
                          <button
                            onClick={() => handleDeleteOwner(owner)}
                            className="p-2 text-red-400 hover:bg-red-50 rounded-full transition-colors"
                            title="Remove owner"
                          >
                            <X className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                      {isExpanded && expandedOwnerContactId && (
                        <div className="border-t border-gray-100 bg-gray-50/60 rounded-b-xl px-6 py-5">
                          <ContactGeneralInfoCard contactId={expandedOwnerContactId} />
                        </div>
                      )}
                    </div>
                  );
                })}
                {owners.length === 0 && (
                  <div className="text-center py-16 border-2 border-dashed border-gray-100 rounded-xl">
                    <p className="text-sm text-[#374151] opacity-50 font-medium">No owners added yet. Click "Add Owner" to get started.</p>
                  </div>
                )}
              </div>
            </div>
          )}
          {visibleTab === 'purchaser' && (
            <div className="animate-in zoom-in-95 duration-500 space-y-8">
              <div className="bg-white border border-gray-100 p-6 flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-bold text-[#374151] mb-1">Property Purchaser</h3>
                  <p className="text-xs text-[#374151] opacity-60 font-medium">Manage property purchaser and their information</p>
                </div>
                <button
                  onClick={() => {
                    setEditingPurchaser(null);
                    setShowPurchaserModal(true);
                  }}
                  className="flex items-center gap-2 px-5 py-2.5 bg-[#55C5D0] text-white rounded-lg text-xs font-bold uppercase tracking-wide shadow-lg shadow-cyan-100 hover:bg-[#4AADB7] transition-all"
                >
                  <User className="w-4 h-4" />
                  <span>Add Purchaser</span>
                </button>
              </div>
              <div className="space-y-4 sm:px-8">
                {purchasers.map((purchaser, idx) => {
                  const purchaserPhone = purchaser.contact || purchaser.phone;
                  const purchaserEmail = purchaser.email?.trim() || '';
                  return (
                    <div key={idx} className="bg-white border border-gray-100 rounded-xl p-4 sm:p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 hover:border-[#55C5D0]/30 transition-all group shadow-sm">
                      <div className="flex items-center space-x-3 sm:space-x-5 w-full sm:w-auto min-w-0">
                        <div className="w-12 h-12 bg-[#55C5D0] rounded-full flex items-center justify-center text-white shadow-sm shrink-0">
                          <User className="w-6 h-6" />
                        </div>
                        <div className="space-y-0.5 min-w-0 flex-1">
                          <p className="text-sm font-bold text-[#374151] break-words">{purchaser.name}</p>
                          <p className="text-[11px] text-[#374151] opacity-60 font-medium break-all">{purchaserEmail || 'No email'}</p>
                          <p className="text-[11px] text-[#374151] opacity-60 font-medium">{purchaserPhone || 'No phone'}</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3 self-end sm:self-auto sm:flex-shrink-0">
                        {purchaserPhone ? (
                          <a href={`tel:${purchaserPhone.replace(/\s/g, '')}`} className="p-2 text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors">
                            <Phone className="w-4 h-4" />
                          </a>
                        ) : (
                          <span className="p-2 text-gray-300 cursor-not-allowed" title="No phone"><Phone className="w-4 h-4" /></span>
                        )}
                        {purchaserEmail ? (
                          <a href={`mailto:${purchaserEmail}`} className="p-2 text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors">
                            <Mail className="w-4 h-4" />
                          </a>
                        ) : (
                          <span className="p-2 text-gray-300 cursor-not-allowed" title="No email"><Mail className="w-4 h-4" /></span>
                        )}
                        {isAdmin && (
                          <>
                            <button
                              onClick={() => handleEditPurchaser(purchaser, idx)}
                              disabled={isUpdating}
                              className="p-2 text-gray-400 hover:text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors disabled:opacity-50"
                              title="Edit purchaser"
                            >
                              <Edit className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDeletePurchaser(idx)}
                              disabled={isUpdating}
                              className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors disabled:opacity-50"
                              title="Delete purchaser"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
                {purchasers.length === 0 && (
                  <div className="flex flex-col items-center justify-center py-20 text-center border-2 border-dashed border-gray-100 rounded-xl bg-gray-50/50">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4">
                      <User className="w-8 h-8 text-[#55C5D0]" />
                    </div>
                    <h4 className="text-sm font-bold text-[#374151] mb-1">No Purchasers Yet</h4>
                    <p className="text-xs text-[#374151] opacity-50 font-medium mb-6 max-w-xs mx-auto">
                      Add a purchaser to track sales information and contract details for this property.
                    </p>
                    <button
                      onClick={() => {
                        setEditingPurchaser(null);
                        setShowPurchaserModal(true);
                      }}
                      className="flex items-center gap-2 px-6 py-3 bg-[#55C5D0] text-white rounded-xl text-xs font-black uppercase tracking-widest shadow-xl shadow-cyan-100 hover:bg-[#4AADB7] transition-all"
                    >
                      <Plus className="w-4 h-4" />
                      <span>Add First Purchaser</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
          {visibleTab === 'enquiries' && canViewBuyerData && (
            <div className="space-y-6">
              {/* Sub-tabs: Enquiries / Attendees / Buyers (Renters for a lease) / Offers */}
              <div className="grid grid-cols-2 sm:flex sm:items-center gap-1 border-b border-gray-100 sm:overflow-x-auto sm:overflow-y-hidden">
                {[
                  { id: 'enquiries', label: 'Enquiries', icon: Mail, count: enquiries.length + bidderRegistrations.length },
                  { id: 'attendees', label: 'Attendees', icon: Users2, count: inspectionAttendees.length },
                  { id: 'buyers', label: isLease ? 'Renters' : 'Buyers', icon: UserPlus, count: propertyBuyers.length },
                  { id: 'offers', label: 'Offers', icon: DollarSign, count: offers.length },
                ].map((st) => {
                  const Icon = st.icon;
                  const active = enquiriesSubTab === st.id;
                  return (
                    <button
                      key={st.id}
                      onClick={() => setEnquiriesSubTab(st.id)}
                      className={`shrink-0 whitespace-nowrap px-3 sm:px-5 py-3 text-sm font-semibold rounded-t-lg transition-all ${active
                        ? 'text-[#55C5D0] border-b-2 border-[#55C5D0] -mb-px bg-[#f0fafb]'
                        : 'text-gray-500 hover:text-gray-700'
                        }`}
                    >
                      <span className="flex items-center gap-2">
                        <Icon className="w-4 h-4" />
                        {st.label}
                        {st.count > 0 && (
                          <span className="ml-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold bg-[#55C5D0] text-white shadow-sm">
                            {st.count > 99 ? '99+' : st.count}
                          </span>
                        )}
                      </span>
                    </button>
                  );
                })}
              </div>

              {enquiriesSubTab === 'enquiries' && (
              <div className="space-y-6">
              {interactionsLoading ? (
                <div className="bg-white rounded-2xl border border-gray-200 p-16 flex items-center justify-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#55C5D0]"></div>
                  <span className="ml-3 text-gray-500">Loading enquiries...</span>
                </div>
              ) : (enquiries.length === 0 && bidderRegistrations.length === 0) ? (
                <div className="bg-white rounded-2xl border border-gray-200 px-6 py-16 sm:p-32 flex flex-col items-center justify-center text-center shadow-sm">
                  <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6">
                    <Users2 className="w-8 h-8 text-[#374151] opacity-20" />
                  </div>
                  <h4 className="text-xl font-black text-[#374151] mb-2 uppercase tracking-widest">No Enquiries</h4>
                  <p className="text-[#374151] opacity-50 font-bold text-xs uppercase tracking-widest max-w-[250px]">Enquiries from the Buyer Portal will appear here.</p>
                  <button
                    type="button"
                    onClick={() => setShowAddEnquiryModal(true)}
                    className="mt-6 text-xs flex items-center gap-1.5 border border-[#55C5D0] text-[#3a99a3] hover:bg-[#55C5D0]/10 font-bold uppercase tracking-wider rounded-lg px-4 py-2.5 transition-colors"
                  >
                    <Plus size={14} />
                    Add an enquiry
                  </button>
                </div>
              ) : (
                <div className="space-y-6">
                  {/* Bidder Registrations Section */}
                  {bidderRegistrations.length > 0 && (
                    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                      <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#55C5D0]/10 to-transparent">
                        <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                          <span className="w-2 h-2 bg-[#55C5D0] rounded-full"></span>
                          Bidder Registrations ({bidderRegistrations.length})
                        </h3>
                      </div>
                      <div className="divide-y divide-gray-100">
                        {bidderRegistrations.map((reg) => (
                          <div key={reg.id} className="p-4 sm:p-6 hover:bg-gray-50 transition-colors">
                            <div className="flex justify-between items-start">
                              <div className="space-y-2 min-w-0">
                                <div className="flex items-center flex-wrap gap-x-3 gap-y-1.5">
                                  <span className="text-base font-bold text-[#374151]">{reg.full_name}</span>
                                  <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${reg.status === 'APPROVED' ? 'bg-green-100 text-green-700' :
                                    reg.status === 'PENDING_REVIEW' ? 'bg-yellow-100 text-yellow-700' :
                                      reg.status === 'DECLINED' ? 'bg-red-100 text-red-700' :
                                        'bg-gray-100 text-gray-700'
                                    }`}>
                                    {reg.status_display}
                                  </span>
                                </div>
                                <div className="flex items-center flex-wrap gap-x-4 gap-y-1 text-sm text-gray-500">
                                  <span className="flex items-center gap-1 min-w-0"><Mail size={14} className="flex-shrink-0" /> <span className="break-all">{reg.email}</span></span>
                                  <span className="flex items-center gap-1"><Phone size={14} /> {reg.phone}</span>
                                </div>
                                <div className="flex items-center flex-wrap gap-x-4 gap-y-1 text-xs text-gray-400">
                                  <span>Ref: {reg.reference_number}</span>
                                  {reg.deposit_amount && <span>Deposit: ${parseFloat(reg.deposit_amount).toLocaleString()}</span>}
                                  <span>{new Date(reg.created_at).toLocaleDateString()}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* General Enquiries Section — always shown once this branch is reached
                      (bidder registrations OR enquiries exist), so "Add an enquiry" stays
                      reachable even when there are bidder registrations but zero enquiries yet. */}
                  <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                      <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-transparent flex items-center justify-between flex-wrap gap-3">
                        <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                          <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                          Enquiries ({enquiries.length})
                        </h3>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() => setShowAddEnquiryModal(true)}
                            title="Log an enquiry you took by phone or in person"
                            className="text-xs flex items-center gap-1.5 border border-[#55C5D0] text-[#3a99a3] hover:bg-[#55C5D0]/10 font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                          >
                            <Plus size={14} />
                            Add an enquiry
                          </button>
                          {enquiries.length > 0 && (
                            <>
                              <button
                                type="button"
                                onClick={() => setRichComposer({ context: 'enquiries', channel: 'email' })}
                                title="Email these enquirers"
                                className="text-xs flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] text-white font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                              >
                                <Mail size={14} />
                                Email
                              </button>
                              <button
                                type="button"
                                onClick={() => setRichComposer({ context: 'enquiries', channel: 'sms' })}
                                title="Text these enquirers"
                                className="text-xs flex items-center gap-1.5 border border-[#55C5D0] text-[#3f9ba4] hover:bg-[#e6f7f9] font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                              >
                                <MessageSquare size={14} />
                                Text
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                      {enquiries.length === 0 ? (
                        <div className="px-6 py-8 text-center text-sm text-gray-400">No enquiries logged yet.</div>
                      ) : (
                      <div className="divide-y divide-gray-100">
                        {enquiries.map((enq) => (
                          <div
                            key={enq.id}
                            onClick={() => setEditingEnquiry(enq)}
                            className="p-4 sm:p-6 hover:bg-gray-50 transition-colors cursor-pointer group"
                          >
                            {/* Stacked on phones: with the action buttons beside the
                                details, flex-shrink-0 squeezed the name/email column to
                                one character wide. Side by side again from sm up. */}
                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
                              <div className="space-y-2 w-full sm:flex-1 min-w-0">
                                <div className="flex items-center flex-wrap gap-x-3 gap-y-1.5">
                                  <ContactLink
                                    identity={{ email: enq.email, name: enq.name || enq.full_name, phone: enq.phone || enq.contact }}
                                    returnTo={contactReturnTo}
                                    returnLabel={contactReturnLabel}
                                    className="text-base font-bold text-[#374151] hover:text-[#3a99a3] hover:underline transition-colors break-words"
                                  >
                                    {enq.name || enq.full_name}
                                  </ContactLink>
                                  <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">
                                    {enq.type_display || 'Enquiry'}
                                  </span>
                                  <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${enq.status === 'RESOLVED' ? 'bg-green-100 text-green-700' :
                                    enq.status === 'IN_PROGRESS' ? 'bg-yellow-100 text-yellow-700' :
                                      'bg-gray-100 text-gray-700'
                                    }`}>
                                    {enq.status_display || enq.status}
                                  </span>
                                </div>
                                <div className="flex items-center flex-wrap gap-x-4 gap-y-1 text-sm text-gray-500">
                                  {enq.email && (
                                    <a
                                      href={`mailto:${enq.email}`}
                                      onClick={(e) => e.stopPropagation()}
                                      className="flex items-center gap-1 min-w-0 hover:text-[#55C5D0] transition-colors"
                                    >
                                      <Mail size={14} className="flex-shrink-0" /> <span className="break-all">{enq.email}</span>
                                    </a>
                                  )}
                                  {(enq.phone || enq.contact) && (
                                    <a
                                      href={`tel:${enq.phone || enq.contact}`}
                                      onClick={(e) => e.stopPropagation()}
                                      className="flex items-center gap-1 hover:text-[#55C5D0] transition-colors"
                                    >
                                      <Phone size={14} className="flex-shrink-0" /> {enq.phone || enq.contact}
                                    </a>
                                  )}
                                </div>
                              </div>
                              <div className="flex flex-wrap items-center gap-2 sm:self-center sm:flex-shrink-0">
                                {/* Same action order as the Buyers and Attendees
                                    tabs so all three stay in sync (#12973373820):
                                    Contract, Send Offer Link, Send Portal Sign up,
                                    then Notes / Preferences. Called is the first
                                    tile on the left (#13307134618). */}
                                <CalledButton
                                  size="enquiry"
                                  busy={callingId === enq.id}
                                  lastContacted={getLatestNoteFor(enq)?.last_contacted}
                                  onCalled={(opts) => markCalled(enq, { enquiryId: enq.id }, enq.id, opts)}
                                />
                                <button
                                  type="button"
                                  onClick={(e) => { e.stopPropagation(); handleSendContractToEnquiry(enq); }}
                                  disabled={!enq.email || sendingContractEnquiryId === enq.id}
                                  title={enq.email ? "Email this buyer the Contract of Sale" : "No email on file for this enquiry"}
                                  className="text-xs flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold uppercase tracking-wider rounded-lg px-2.5 sm:px-3 py-2 transition-colors"
                                >
                                  <FileText size={14} />
                                  <span className="hidden sm:inline">{sendingContractEnquiryId === enq.id ? "Sending…" : (enq.contract_sent_count > 0 ? "Resend Contract" : "Send Contract")}</span>
                                </button>
                                <button
                                  type="button"
                                  onClick={(e) => { e.stopPropagation(); sendOfferLinkTo({ name: enq.name || enq.full_name, email: enq.email }, enq.id); }}
                                  disabled={!enq.email || sendingOfferLinkId === enq.id}
                                  title={enq.email ? "Email this buyer the link to submit an offer on this property" : "No email on file for this enquiry"}
                                  className="text-xs flex items-center gap-1.5 bg-white border border-[#55C5D0] text-[#3a99a3] hover:bg-[#55C5D0] hover:text-white disabled:opacity-50 disabled:cursor-not-allowed font-bold uppercase tracking-wider rounded-lg px-2.5 sm:px-3 py-2 transition-colors"
                                >
                                  <Send size={14} />
                                  <span className="hidden sm:inline">{sendingOfferLinkId === enq.id ? "Sending…" : "Send Offer Link"}</span>
                                </button>
                                <button
                                  type="button"
                                  onClick={(e) => { e.stopPropagation(); handleSendPortalSignupToEnquiry(enq); }}
                                  disabled={!enq.email || invitingEnquiryId === enq.id}
                                  title={enq.email ? "Email this buyer a buyer-portal sign-up link" : "No email on file for this enquiry"}
                                  className="text-xs flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 disabled:opacity-50 disabled:cursor-not-allowed text-[#55C5D0] border border-[#55C5D0] font-bold uppercase tracking-wider rounded-lg px-2.5 sm:px-3 py-2 transition-colors"
                                >
                                  <UserPlus size={14} />
                                  <span className="hidden sm:inline">{invitingEnquiryId === enq.id ? "Sending…" : "Send Portal Sign up link"}</span>
                                </button>
                                <ContactNotesButton
                                  suggestPreferences={!isLease}
                                  identity={{ email: enq.email, name: enq.name || enq.full_name, phone: enq.phone || enq.contact }}
                                  label="Notes"
                                  onNoteChange={(note) => applyLatestNote(enq, note)}
                                  className="text-xs flex items-center gap-1.5 bg-white hover:bg-amber-50 text-amber-600 border border-amber-300 font-bold uppercase tracking-wider rounded-lg px-2.5 sm:px-3 py-2 transition-colors"
                                />
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setPrefsPerson({ email: enq.email, name: enq.name || enq.full_name, phone: enq.phone || enq.contact });
                                  }}
                                  title={isLease ? "Edit this renter's renting preferences" : "Edit this buyer's buying preferences"}
                                  className="text-xs flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 text-[#3a99a3] border border-[#55C5D0] font-bold uppercase tracking-wider rounded-lg px-2.5 sm:px-3 py-2 transition-colors"
                                >
                                  <SlidersHorizontal size={14} />
                                  <span className="hidden sm:inline">Preferences</span>
                                </button>
                                <div className="p-2 rounded-full bg-gray-50 text-gray-300 group-hover:bg-[#55C5D0]/10 group-hover:text-[#55C5D0] transition-all">
                                  <Eye size={18} />
                                </div>
                              </div>
                            </div>
                            {/* Full-width so the message and note read
                                left-to-right rather than squeezed into the narrow
                                info column beside the buttons (CRM-2026-00062 note;
                                CRM-2026-00065 message). */}
                            <div className="relative mt-2">
                              <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded-lg pr-10">{enq.message}</p>
                              {enq.agent_notes && (
                                <div className="mt-2 p-3 bg-amber-50 border border-amber-100 rounded-lg">
                                  <span className="text-[10px] font-bold text-amber-600 uppercase tracking-widest block mb-1">Internal agent notes:</span>
                                  <p className="text-xs text-amber-800 whitespace-pre-wrap">{enq.agent_notes}</p>
                                </div>
                              )}
                            </div>
                            {renderLastContactNote(enq)}
                          </div>
                        ))}
                      </div>
                      )}
                  </div>
                </div>
              )}
              </div>
              )}

              {enquiriesSubTab === 'attendees' && (
                <div className="space-y-6">
                  {interactionsLoading ? (
                    <div className="bg-white rounded-2xl border border-gray-200 p-16 flex items-center justify-center">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#55C5D0]"></div>
                      <span className="ml-3 text-gray-500">Loading attendees...</span>
                    </div>
                  ) : inspectionAttendees.length === 0 ? (
                    <div className="bg-white rounded-2xl border border-gray-200 px-6 py-16 sm:p-32 flex flex-col items-center justify-center text-center shadow-sm">
                      <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6">
                        <Users2 className="w-8 h-8 text-[#374151] opacity-20" />
                      </div>
                      <h4 className="text-xl font-black text-[#374151] mb-2 uppercase tracking-widest">No Attendees</h4>
                      <p className="text-[#374151] opacity-50 font-bold text-xs uppercase tracking-widest max-w-[280px]">Buyers who check-in to an Open For Inspection for this property will appear here.</p>
                    </div>
                  ) : (
                    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                      <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#55C5D0]/10 to-transparent flex items-center justify-between flex-wrap gap-3">
                        <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                          <span className="w-2 h-2 bg-[#55C5D0] rounded-full"></span>
                          Inspection Register ({inspectionAttendees.length})
                        </h3>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() => setRichComposer({ context: 'attendees', channel: 'email' })}
                            title={isLease ? "Email these renters" : "Email these buyers"}
                            className="text-xs flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] text-white font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                          >
                            <Mail size={14} />
                            Email
                          </button>
                          <button
                            type="button"
                            onClick={() => setRichComposer({ context: 'attendees', channel: 'sms' })}
                            title={isLease ? "Text these renters" : "Text these buyers"}
                            className="text-xs flex items-center gap-1.5 border border-[#55C5D0] text-[#3f9ba4] hover:bg-[#e6f7f9] font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                          >
                            <MessageSquare size={14} />
                            Text
                          </button>
                        </div>
                      </div>
                      <div>
                        {groupedInspectionAttendees.map((group) => (
                          <div key={group.key}>
                            <div className="px-6 py-2.5 bg-gray-50 border-y border-gray-100 flex items-center gap-2 flex-wrap">
                              <Calendar size={13} className="text-[#55C5D0]" />
                              <span className="text-xs font-bold text-[#374151] uppercase tracking-wider">{group.label}</span>
                              <span className="text-[11px] font-semibold text-gray-400">· {group.attendees.length} {group.attendees.length === 1 ? 'attendee' : 'attendees'}</span>
                            </div>
                            <div className="divide-y divide-gray-100">
                        {group.attendees.map((att) => {
                          const interestColor =
                            att.interest_level === 'very_high' ? 'bg-emerald-100 text-emerald-700' :
                            att.interest_level === 'high' ? 'bg-green-100 text-green-700' :
                            att.interest_level === 'medium' ? 'bg-blue-100 text-blue-700' :
                            'bg-gray-100 text-gray-700';
                          return (
                            <div key={att.id} className="p-4 sm:p-6 hover:bg-gray-50 transition-colors">
                              <div className="flex justify-between items-start gap-4">
                                <div className="space-y-2 flex-1 min-w-0">
                                  <div className="flex items-center gap-3 flex-wrap">
                                    <button
                                      type="button"
                                      onClick={() => handleViewAttendeeContact(att)}
                                      title="Open this attendee's contact profile"
                                      className="text-base font-bold text-[#374151] hover:text-[#55C5D0] hover:underline transition-colors text-left"
                                    >
                                      {att.name}
                                    </button>
                                    {att.interest_level && (
                                      <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${interestColor}`}>
                                        {(att.interest_level || '').replace('_', ' ')}
                                      </span>
                                    )}
                                    {att.is_first_time_buyer && (
                                      <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700">First-time buyer</span>
                                    )}
                                    {att.converted_to_lead && (
                                      <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-purple-100 text-purple-700">Lead created</span>
                                    )}
                                    {renderContractSentBadge(att)}
                                  </div>
                                  <div className="flex items-center gap-4 text-sm text-gray-500 flex-wrap">
                                    {att.email && (
                                      <a href={`mailto:${att.email}`} className="flex items-center gap-1 min-w-0 hover:text-[#55C5D0] transition-colors">
                                        <Mail size={14} className="flex-shrink-0" /> <span className="break-all">{att.email}</span>
                                      </a>
                                    )}
                                    {att.phone && (
                                      <a href={`tel:${att.phone}`} className="flex items-center gap-1 hover:text-[#55C5D0] transition-colors">
                                        <Phone size={14} /> {att.phone}
                                      </a>
                                    )}
                                  </div>
                                  <div className="flex items-center gap-4 text-xs text-gray-400 flex-wrap">
                                    {att.inspection_date && (
                                      <span className="flex items-center gap-1"><Calendar size={12} /> OFI {formatMelbourneDateTime(att.inspection_date)}</span>
                                    )}
                                    {att.budget_range && <span>Budget: {att.budget_range}</span>}
                                    {att.timeline && <span>Timeline: {att.timeline}</span>}
                                  </div>
                                  {/* The buyer's stated feedback on this property, read-only.
                                      Labelled so it is not mistaken for a note - notes live in the
                                      append-only thread behind the Notes button, and nothing on this
                                      row overwrites another agent's text any more. */}
                                  {att.feedback && (
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                      <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-0.5">Buyer feedback</p>
                                      <p className="text-sm text-gray-600 whitespace-pre-wrap break-words">{att.feedback}</p>
                                    </div>
                                  )}
                                  {renderLastContactNote(att)}
                                  <div className="pt-1 flex items-center gap-2 flex-wrap">
                                    {/* Called is the first tile on the left (#13307134618). */}
                                    <CalledButton
                                      size="attendee"
                                      busy={callingId === att.id}
                                      lastContacted={getLatestNoteFor(att)?.last_contacted}
                                      onCalled={(opts) => markCalled(att, { attendeeId: att.id }, att.id, opts)}
                                    />
                                    <button
                                      type="button"
                                      onClick={() => handleSendContractToAttendee(att)}
                                      disabled={!att.email || sendingContractAttendeeId === att.id}
                                      title={att.email ? "Email this buyer the Contract of Sale" : "No email on file for this buyer"}
                                      className="text-xs flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    >
                                      <FileText size={14} />
                                      {sendingContractAttendeeId === att.id
                                        ? "Sending…"
                                        : att.contract_sent_count > 0 ? "Resend Contract" : "Send Contract"}
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => sendOfferLinkTo(att, att.id)}
                                      disabled={!att.email || sendingOfferLinkId === att.id}
                                      title={att.email ? "Email this buyer the link to submit an offer on this property" : "No email on file for this buyer"}
                                      className="text-xs flex items-center gap-1.5 bg-white border border-[#55C5D0] text-[#3a99a3] hover:bg-[#55C5D0] hover:text-white disabled:opacity-50 disabled:cursor-not-allowed font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    >
                                      <Send size={14} /> {sendingOfferLinkId === att.id ? "Sending…" : "Send Offer Link"}
                                    </button>
                                    {portalInviteAlreadySent(att) ? renderPortalInviteSentBadge() : (
                                      <button
                                        type="button"
                                        onClick={() => handleSendPortalSignupToAttendee(att)}
                                        disabled={!att.email || invitingAttendeeId === att.id}
                                        title={att.email ? "Email this buyer a buyer-portal sign-up link" : "No email on file for this buyer"}
                                        className="text-xs flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 disabled:opacity-50 disabled:cursor-not-allowed text-[#55C5D0] border border-[#55C5D0] font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                      >
                                        <UserPlus size={14} />
                                        {invitingAttendeeId === att.id ? "Sending…" : "Send Portal Sign up link"}
                                      </button>
                                    )}
                                    <ContactNotesButton
                                      suggestPreferences={!isLease}
                                      /* attendeeId routes this through the
                                         attendee notes endpoint — the same
                                         thread the Open Home tab writes to, and
                                         the only path that links a contact for a
                                         walk-in who checked in without an email. */
                                      identity={{ attendeeId: att.id, contactId: att.contact, email: att.email, name: att.name, phone: att.phone }}
                                      label="Notes"
                                      onNoteChange={(note) => applyLatestNote(att, note)}
                                      className="text-xs flex items-center gap-1.5 bg-white hover:bg-amber-50 text-amber-600 border border-amber-300 font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    />
                                    <button
                                      type="button"
                                      onClick={() => setPrefsPerson({ contactId: att.contact, email: att.email, name: att.name, phone: att.phone })}
                                      title={isLease ? "Edit this renter's renting preferences" : "Edit this buyer's buying preferences"}
                                      className="text-xs flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 text-[#3a99a3] border border-[#55C5D0] font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    >
                                      <SlidersHorizontal size={14} /> Preferences
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => setEditingAttendee(att)}
                                      title="Edit this attendee's details"
                                      className="text-xs flex items-center gap-1.5 bg-white hover:bg-gray-50 text-gray-600 border border-gray-300 font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    >
                                      <Edit size={14} /> Edit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                </div>
              )}

              {enquiriesSubTab === 'buyers' && (
                <div className="space-y-6">
                  <div className="flex items-center justify-between flex-wrap gap-3">
                    <p className="text-sm text-gray-500 max-w-xl">
                      {isLease
                        ? `Manually add renters you know would be interested in this property — for
                      example, people you're calling from your database. Each renter opens their
                      contact profile where you can log notes and set reminders.`
                        : `Manually add buyers you know would be interested in this property — for
                      example, people you're calling from your database. Each buyer opens their
                      contact profile where you can log notes and set reminders.`}
                    </p>
                    <button
                      type="button"
                      onClick={() => setShowAddBuyerModal(true)}
                      className="shrink-0 inline-flex items-center gap-2 bg-[#55C5D0] hover:bg-[#47b1bb] text-white font-bold uppercase tracking-wider text-xs rounded-lg px-4 py-2.5 transition-colors shadow-sm"
                    >
                      <UserPlus size={16} /> {isLease ? 'Add Renter' : 'Add Buyer'}
                    </button>
                  </div>

                  {interactionsLoading ? (
                    <div className="bg-white rounded-2xl border border-gray-200 p-16 flex items-center justify-center">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#55C5D0]"></div>
                      <span className="ml-3 text-gray-500">Loading {isLease ? 'renters' : 'buyers'}...</span>
                    </div>
                  ) : propertyBuyers.length === 0 ? (
                    <div className="bg-white rounded-2xl border border-gray-200 px-6 py-16 sm:p-32 flex flex-col items-center justify-center text-center shadow-sm">
                      <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6">
                        <UserPlus className="w-8 h-8 text-[#374151] opacity-20" />
                      </div>
                      <h4 className="text-xl font-black text-[#374151] mb-2 uppercase tracking-widest">No {isLease ? 'Renters' : 'Buyers'} Yet</h4>
                      <p className="text-[#374151] opacity-50 font-bold text-xs uppercase tracking-widest max-w-[280px]">Use "{isLease ? 'Add Renter' : 'Add Buyer'}" to attach interested {isLease ? 'renters' : 'buyers'} from your database to this property.</p>
                    </div>
                  ) : (
                    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                      <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#55C5D0]/10 to-transparent flex items-center justify-between flex-wrap gap-3">
                        <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                          <span className="w-2 h-2 bg-[#55C5D0] rounded-full"></span>
                          {isLease ? 'Renters' : 'Buyers'} ({propertyBuyers.length})
                        </h3>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() => setRichComposer({ context: 'buyers', channel: 'email' })}
                            title={isLease ? "Email these renters" : "Email these buyers"}
                            className="text-xs flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] text-white font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                          >
                            <Mail size={14} />
                            Email
                          </button>
                          <button
                            type="button"
                            onClick={() => setRichComposer({ context: 'buyers', channel: 'sms' })}
                            title={isLease ? "Text these renters" : "Text these buyers"}
                            className="text-xs flex items-center gap-1.5 border border-[#55C5D0] text-[#3f9ba4] hover:bg-[#e6f7f9] font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                          >
                            <MessageSquare size={14} />
                            Text
                          </button>
                        </div>
                      </div>
                      <div className="divide-y divide-gray-100">
                        {propertyBuyers.map((buyer) => (
                          <div key={buyer.link_id} className="p-4 sm:p-6 hover:bg-gray-50 transition-colors">
                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
                              <div className="space-y-2 flex-1 min-w-0">
                                <div className="flex items-center gap-3 flex-wrap">
                                  <ContactLink
                                    identity={{ contactId: buyer.contact_id, email: buyer.email, name: buyer.name, phone: buyer.phone }}
                                    returnTo={contactReturnTo}
                                    returnLabel={contactReturnLabel}
                                    className="text-base font-bold text-[#374151] hover:text-[#3a99a3] hover:underline transition-colors"
                                  >
                                    {buyer.name}
                                  </ContactLink>
                                  {buyer.contact_type && (
                                    <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-[#55C5D0]/10 text-[#3a99a3] capitalize">
                                      {buyer.contact_type}
                                    </span>
                                  )}
                                  {renderContractSentBadge(buyer)}
                                </div>
                                <div className="flex items-center gap-4 text-sm text-gray-500 flex-wrap">
                                  {buyer.email && (
                                    <a href={`mailto:${buyer.email}`} className="flex items-center gap-1 min-w-0 hover:text-[#55C5D0] transition-colors">
                                      <Mail size={14} className="flex-shrink-0" /> <span className="break-all">{buyer.email}</span>
                                    </a>
                                  )}
                                  {buyer.phone && (
                                    <a href={`tel:${buyer.phone}`} className="flex items-center gap-1 hover:text-[#55C5D0] transition-colors">
                                      <Phone size={14} /> {buyer.phone}
                                    </a>
                                  )}
                                </div>
                              </div>
                              <div className="flex items-center gap-2 flex-wrap sm:shrink-0 sm:justify-end">
                                {/* Called is the first tile on the left (#13307134618). */}
                                <CalledButton
                                  size="buyer"
                                  busy={callingId === buyer.link_id}
                                  lastContacted={getLatestNoteFor(buyer)?.last_contacted}
                                  onCalled={(opts) => markCalled(buyer, { buyerLinkId: buyer.link_id }, buyer.link_id, opts)}
                                />
                                <button
                                  type="button"
                                  onClick={() => handleSendContractToBuyer(buyer)}
                                  disabled={!buyer.email || sendingContractBuyerLinkId === buyer.link_id}
                                  title={buyer.email ? "Email this buyer the Contract of Sale" : "No email on file for this buyer"}
                                  className="inline-flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold uppercase tracking-wider text-[11px] rounded-lg px-3 py-2 transition-colors"
                                >
                                  <FileText size={14} />
                                  {sendingContractBuyerLinkId === buyer.link_id
                                    ? "Sending…"
                                    : buyer.contract_sent_count > 0 ? "Resend Contract" : "Send Contract"}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleSendOfferLinkToBuyer(buyer)}
                                  disabled={!buyer.email || sendingOfferLinkId === buyer.link_id}
                                  title={buyer.email ? `Email ${buyer.name || 'this buyer'} the link to submit an offer on this property` : "No email on file for this buyer"}
                                  className="inline-flex items-center gap-1.5 bg-white border border-[#55C5D0] text-[#3a99a3] hover:bg-[#55C5D0] hover:text-white disabled:opacity-50 disabled:cursor-not-allowed font-bold uppercase tracking-wider text-[11px] rounded-lg px-3 py-2 transition-colors"
                                >
                                  <Send size={14} /> {sendingOfferLinkId === buyer.link_id ? "Sending…" : "Send Offer Link"}
                                </button>
                                {portalInviteAlreadySent(buyer) ? renderPortalInviteSentBadge(buyer) : (
                                  <button
                                    type="button"
                                    onClick={() => handleSendPortalSignupToBuyer(buyer)}
                                    disabled={!buyer.email || invitingBuyerLinkId === buyer.link_id}
                                    title={buyer.email ? `Email ${buyer.name || 'this buyer'} a buyer-portal sign-up link` : "No email on file for this buyer"}
                                    className="inline-flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 disabled:opacity-50 disabled:cursor-not-allowed text-[#55C5D0] border border-[#55C5D0] font-bold uppercase tracking-wider text-[11px] rounded-lg px-3 py-2 transition-colors"
                                  >
                                    <UserPlus size={14} />
                                    {invitingBuyerLinkId === buyer.link_id ? "Sending…" : "Send Portal Sign up link"}
                                  </button>
                                )}
                                <ContactNotesButton
                                  suggestPreferences={!isLease}
                                  identity={{ contactId: buyer.contact_id, email: buyer.email, name: buyer.name, phone: buyer.phone }}
                                  label="Notes"
                                  onNoteChange={(note) => applyLatestNote(buyer, note)}
                                  className="inline-flex items-center gap-1.5 bg-white hover:bg-amber-50 text-amber-600 border border-amber-300 font-bold uppercase tracking-wider text-[11px] rounded-lg px-3 py-2 transition-colors"
                                />
                                <button
                                  type="button"
                                  onClick={() => setPrefsPerson({ contactId: buyer.contact_id, email: buyer.email, name: buyer.name, phone: buyer.phone })}
                                  title={isLease ? "Edit this renter's renting preferences" : "Edit this buyer's buying preferences"}
                                  className="inline-flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 text-[#3a99a3] border border-[#55C5D0] font-bold uppercase tracking-wider text-[11px] rounded-lg px-3 py-2 transition-colors"
                                >
                                  <SlidersHorizontal size={14} /> Preferences
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setEditingBuyer(buyer)}
                                  title="Edit this buyer's details"
                                  className="inline-flex items-center gap-1.5 bg-white hover:bg-gray-50 text-gray-600 border border-gray-300 font-bold uppercase tracking-wider text-[11px] rounded-lg px-3 py-2 transition-colors"
                                >
                                  <Edit size={14} /> Edit
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleRemoveBuyer(buyer)}
                                  disabled={removingBuyerLinkId === buyer.link_id}
                                  title="Remove buyer from this property"
                                  className="p-2 rounded-lg text-gray-300 hover:text-red-500 hover:bg-red-50 transition-colors disabled:opacity-50"
                                >
                                  {removingBuyerLinkId === buyer.link_id
                                    ? <Loader2 size={16} className="animate-spin" />
                                    : <Trash2 size={16} />}
                                </button>
                              </div>
                            </div>
                            {/* Notes and last note span the full card width so they
                                read left-to-right, not squeezed into the narrow info
                                column beside the buttons (CRM-2026-00062 note;
                                CRM-2026-00065 notes). */}
                            {buyer.notes && (
                              <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded-lg mt-2 break-words">{buyer.notes}</p>
                            )}
                            {renderLastContactNote(buyer)}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {visibleTab === 'enquiries' && enquiriesSubTab === 'offers' && canViewBuyerData && (
            <div className="space-y-6">
              {interactionsLoading ? (
                <div className="bg-white rounded-2xl border border-gray-200 p-16 flex items-center justify-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#55C5D0]"></div>
                  <span className="ml-3 text-gray-500">Loading offers...</span>
                </div>
              ) : offers.length === 0 ? (
                <div className="bg-white rounded-2xl border border-gray-200 px-6 py-16 sm:p-32 flex flex-col items-center justify-center text-center shadow-sm">
                  <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6">
                    <DollarSign className="w-8 h-8 text-[#374151] opacity-20" />
                  </div>
                  <h4 className="text-xl font-black text-[#374151] mb-2 uppercase tracking-widest">No Offers</h4>
                  <p className="text-[#374151] opacity-50 font-bold text-xs uppercase tracking-widest max-w-[250px]">Offers from the Buyer Portal will appear here.</p>
                </div>
              ) : (
                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                  <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-emerald-50 to-transparent flex items-center justify-between flex-wrap gap-3">
                    <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                      <span className="w-2 h-2 bg-emerald-500 rounded-full"></span>
                      Offers ({offers.length})
                    </h3>
                    {vendorStatus && (
                      <div className="flex flex-wrap items-center gap-2 min-w-0 text-[11px] font-bold uppercase tracking-wider">
                        <span className="text-gray-400">Vendor portal:</span>
                        {vendorStatus.state === 'active' && (
                          <span className="px-2 py-1 rounded-md bg-emerald-50 text-emerald-700 border border-emerald-100 break-all">
                            Active · {vendorStatus.vendor?.email}
                          </span>
                        )}
                        {vendorStatus.state === 'pending' && (
                          <>
                            <span className="px-2 py-1 rounded-md bg-amber-50 text-amber-700 border border-amber-100 break-all">
                              Pending invite · {vendorStatus.vendor?.email}
                            </span>
                            <button
                              type="button"
                              disabled={resendingVendorInvite}
                              onClick={async () => {
                                setResendingVendorInvite(true);
                                try {
                                  const res = await resendPropertyVendorInvite(params.id);
                                  toast.success('Invite re-sent');
                                  setVendorStatus((prev) => ({
                                    ...(prev || {}),
                                    state: res?.data?.vendor?.is_pending_activation ? 'pending' : 'active',
                                    vendor: res?.data?.vendor || prev?.vendor,
                                  }));
                                } catch (err) {
                                  toast.error(err?.response?.data?.detail || 'Failed to resend invite');
                                } finally {
                                  setResendingVendorInvite(false);
                                }
                              }}
                              className="px-2 py-1 rounded-md border border-amber-200 text-amber-700 hover:bg-amber-100 transition-colors disabled:opacity-50"
                            >
                              {resendingVendorInvite ? 'Sending...' : 'Resend'}
                            </button>
                          </>
                        )}
                        {vendorStatus.state === 'not_invited' && (
                          <>
                            <span className="px-2 py-1 rounded-md bg-gray-50 text-gray-500 border border-gray-100">
                              Not invited
                            </span>
                            {vendorStatus.owner_email && (
                              <button
                                type="button"
                                disabled={resendingVendorInvite}
                                onClick={async () => {
                                  setResendingVendorInvite(true);
                                  try {
                                    const res = await resendPropertyVendorInvite(params.id);
                                    toast.success('Invite sent');
                                    setVendorStatus((prev) => ({
                                      ...(prev || {}),
                                      state: 'pending',
                                      vendor: res?.data?.vendor || null,
                                    }));
                                  } catch (err) {
                                    toast.error(err?.response?.data?.detail || 'Failed to send invite');
                                  } finally {
                                    setResendingVendorInvite(false);
                                  }
                                }}
                                className="px-2 py-1 rounded-md border border-[#55C5D0]/40 text-[#55C5D0] hover:bg-[#55C5D0]/10 transition-colors disabled:opacity-50"
                              >
                                {resendingVendorInvite ? 'Sending...' : 'Send invite'}
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="divide-y divide-gray-100">
                    {offers.map((offer) => (
                      <div
                        key={offer.id}
                        className="p-4 sm:p-8 hover:bg-[#f0fafb]/40 transition-colors cursor-pointer group"
                        onClick={() => setViewingOffer(offer)}
                      >
                        <div className="flex justify-between items-start">
                          <div className="space-y-4 flex-1 min-w-0">
                            {/* Header: Name & Amount. Stacked on phones - beside a
                                text-2xl price the buyer's name was squeezed to one word per line. */}
                            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                              <div className="flex items-center gap-4 min-w-0">
                                <div className="w-12 h-12 rounded-full bg-[#55C5D0] flex items-center justify-center text-white font-black text-lg shadow-sm">
                                  {offer.buyer_name ? offer.buyer_name[0].toUpperCase() : '?'}
                                </div>
                                <div className="min-w-0">
                                  <h4 className="text-lg font-black text-[#374151] break-words">{offer.buyer_name}</h4>
                                  <p className="text-xs font-bold text-[#55C5D0] uppercase tracking-widest">{offer.reference_number}</p>
                                </div>
                              </div>
                              <div className="sm:text-right">
                                <div className="text-2xl font-black text-[#55C5D0]">
                                  {offer.offer_amount ? `$${Number(offer.offer_amount).toLocaleString()}` :
                                    offer.offer_amount_min ? `$${Number(offer.offer_amount_min).toLocaleString()}` : 'N/A'}
                                </div>
                                <span className={`text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded-md border ${offerStatusPillClasses(offer.status)}`}>
                                  {offerStatusLabel(offer.status, offer.status_display)}
                                </span>
                              </div>
                            </div>

                            {/* Contact & Settlement */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 p-4 rounded-xl border border-gray-100 group-hover:bg-white transition-colors">
                              <div className="space-y-2">
                                <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Contact Information</span>
                                <div className="flex items-center gap-2 min-w-0 text-xs font-bold text-[#374151]">
                                  <Mail size={14} className="text-[#55C5D0] flex-shrink-0" /> <span className="break-all">{offer.buyer_email}</span>
                                </div>
                                {offer.buyer_phone && (
                                  <div className="flex items-center gap-2 text-xs font-bold text-[#374151]">
                                    <Phone size={14} className="text-[#55C5D0]" /> {offer.buyer_phone}
                                  </div>
                                )}
                              </div>
                              <div className="space-y-2">
                                <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Settlement & Deposit</span>
                                <div className="flex items-center gap-2 text-xs font-bold text-[#374151]">
                                  <Calendar size={14} className="text-[#55C5D0]" /> {offer.custom_settlement_date ? moment(offer.custom_settlement_date).format('D MMM YYYY') : `${offer.settlement_days || 30} Days`}
                                  {offer.custom_settlement_date && <span className="opacity-50 ml-1">({offer.settlement_days} Days)</span>}
                                  {!offer.custom_settlement_date && !offer.settlement_days && <span className="opacity-50 ml-1">({offer.preferred_settlement_period || 'Standard'})</span>}
                                </div>
                                <div className="flex items-center gap-2 text-xs font-bold text-[#374151]">
                                  <div className="w-3.5 h-3.5 flex items-center justify-center text-[10px] font-black text-[#55C5D0] border border-[#55C5D0] rounded-full">$</div>
                                  Deposit: ${Number(offer.deposit_amount || 0).toLocaleString()}
                                </div>
                              </div>
                            </div>

                            {/* Conditions */}
                            {offer.conditions && offer.conditions.length > 0 && (
                              <div className="space-y-2">
                                <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Conditions</span>
                                <div className="flex flex-wrap gap-2">
                                  {offer.conditions.map((cond, i) => (
                                    <span key={i} className="px-3 py-1 bg-white border border-gray-200 rounded-lg text-xs font-bold text-[#374151] shadow-sm">
                                      {typeof cond === 'string' ? cond : (cond.type?.replace(/_/g, ' ') || 'Condition')}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* Message */}
                            {offer.message && (
                              <div className="bg-amber-50/50 p-4 rounded-xl border border-amber-100/50">
                                <span className="text-[10px] font-black text-amber-600 uppercase tracking-widest mb-1 block">Buyer Message:</span>
                                <p className="text-sm text-gray-700 italic break-words">"{offer.message}"</p>
                              </div>
                            )}

                            {/* Agent Notes */}
                            {offer.agent_notes && (
                              <div className="bg-[#55C5D0]/5 p-4 rounded-xl border border-[#55C5D0]/10">
                                <span className="text-[10px] font-black text-[#55C5D0] uppercase tracking-widest mb-1 block">Internal Response / Notes:</span>
                                <p className="text-sm text-gray-700 whitespace-pre-wrap break-words">{offer.agent_notes}</p>
                              </div>
                            )}

                            <div className="flex flex-wrap gap-2 text-[10px] font-bold uppercase tracking-widest">
                              {offer.sent_to_vendor_at ? (
                                <span className="px-2 py-1 rounded-md border bg-amber-50 text-amber-700 border-amber-100">
                                  ✓ Sent to vendor {moment(offer.sent_to_vendor_at).fromNow()}
                                </span>
                              ) : (
                                <span className="px-2 py-1 rounded-md border bg-gray-50 text-gray-500 border-gray-100">
                                  Not yet sent to vendor
                                </span>
                              )}
                              {offer.sent_to_buyer_at ? (
                                <span className="px-2 py-1 rounded-md border bg-emerald-50 text-emerald-700 border-emerald-100">
                                  ✓ Sent to buyer {moment(offer.sent_to_buyer_at).fromNow()}
                                </span>
                              ) : (
                                <span className="px-2 py-1 rounded-md border bg-gray-50 text-gray-500 border-gray-100">
                                  Not yet sent to buyer
                                </span>
                              )}
                            </div>

                            {['ACCEPTED', 'REJECTED', 'EXPIRED', 'WITHDRAWN', 'BUYER_WITHDRAWN'].includes(offer.status) && (
                              <div
                                className={`mt-1 p-3 rounded-xl border-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wider ${
                                  offer.status === 'ACCEPTED'
                                    ? 'bg-emerald-50 border-emerald-200 text-emerald-800'
                                    : 'bg-gray-100 border-gray-200 text-gray-600'
                                }`}
                              >
                                {offer.status === 'ACCEPTED' ? (
                                  <>
                                    <CheckCircle2 size={16} />
                                    <span>Locked — offer accepted, property is Under Contract.</span>
                                  </>
                                ) : (
                                  <>
                                    <XCircle size={16} />
                                    <span>
                                      Locked — {offer.status_display || offer.status}. No further negotiation possible.
                                    </span>
                                  </>
                                )}
                              </div>
                            )}

                            <div
                              className="flex flex-wrap gap-2 pt-2"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {['SUBMITTED', 'UNDER_REVIEW', 'BUYER_COUNTERED'].includes(offer.status) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSendingToVendor(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-[#55C5D0] text-white text-xs font-bold uppercase tracking-wider hover:bg-[#4AADB7] transition-colors shadow-sm"
                                >
                                  Send to Vendor
                                </button>
                              )}
                              {['VENDOR_COUNTERED', 'VENDOR_ACCEPTED', 'VENDOR_DECLINED', 'COUNTER_OFFER'].includes(offer.status) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSendingToBuyer(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-emerald-700 transition-colors shadow-sm"
                                >
                                  Send to Buyer
                                </button>
                              )}
                              {!['ACCEPTED', 'REJECTED', 'EXPIRED', 'WITHDRAWN', 'BUYER_WITHDRAWN'].includes(offer.status) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCounteringToBuyer(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-orange-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-orange-700 transition-colors shadow-sm"
                                >
                                  Send Counter Offer
                                </button>
                              )}
                              {['VENDOR_ACCEPTED', 'BUYER_ACCEPTED_COUNTER'].includes(offer.status) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setFinalizingOffer(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-emerald-700 text-white text-xs font-bold uppercase tracking-wider hover:bg-emerald-800 transition-colors shadow-sm flex items-center gap-1"
                                >
                                  <CheckCircle2 size={14} />
                                  Confirm Acceptance
                                </button>
                              )}
                              {!['ACCEPTED', 'REJECTED', 'EXPIRED', 'WITHDRAWN', 'BUYER_WITHDRAWN'].includes(offer.status) && (
                                <button
                                  type="button"
                                  disabled={decliningOfferId === offer.id}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeclineOffer(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-red-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-red-700 transition-colors shadow-sm flex items-center gap-1 disabled:opacity-50"
                                >
                                  <XCircle size={14} />
                                  {decliningOfferId === offer.id ? 'Declining...' : 'Decline Offer'}
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setViewingOffer(offer);
                                }}
                                className="px-4 py-2 rounded-lg border-2 border-gray-200 text-gray-700 text-xs font-bold uppercase tracking-wider hover:bg-gray-50 transition-colors"
                              >
                                Update Status / Note
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTimelineOffer(offer);
                                }}
                                className="px-4 py-2 rounded-lg border-2 border-gray-200 text-gray-700 text-xs font-bold uppercase tracking-wider hover:bg-gray-50 transition-colors"
                              >
                                View History
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openContractForOffer(offer);
                                }}
                                className="px-4 py-2 rounded-lg bg-green-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-green-700 transition-colors shadow-sm"
                              >
                                Fill Out Contract
                              </button>
                            </div>
                          </div>
                          <div className="hidden sm:block self-center ml-4 p-2 rounded-full bg-gray-50 text-gray-300 group-hover:bg-[#55C5D0]/10 group-hover:text-[#55C5D0] transition-all">
                            <Eye size={20} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {visibleTab === 'notes' && (
            <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Left: Add Note Form */}
                <div className="space-y-4">
                  <h3 className="text-xl font-black text-[#374151] tracking-tight">Add New Note</h3>
                  <textarea
                    value={newNote}
                    onChange={(e) => setNewNote(e.target.value)}
                    className="w-full border-2 border-gray-100 rounded-xl p-4 bg-gray-50 min-h-[200px] text-[#374151] font-medium text-sm focus:bg-white focus:border-[#55C5D0] transition-all outline-none resize-none"
                    placeholder="Type your note here..."
                  />

                  {/* The call-back series sits directly under the note box
                      (Simon Abbott, Monday 13036305197, 14 Sep 2026). A note
                      like "touch base next week" is only half the job - the
                      other half is next week's call, and it is booked here with
                      the same button rather than on another screen. Hidden for
                      read-only viewers, who cannot book anything. */}
                  {!isReadOnly && (
                    <AppraisalReminderSeries
                      key={noteReminderKey}
                      propertyId={params.id}
                      value={noteReminders}
                      onChange={setNoteReminders}
                    />
                  )}

                  <div className="flex justify-end">
                    <button
                      onClick={handleSaveNote}
                      disabled={isUpdating || (!newNote.trim() && noteReminders.length === 0)}
                      className="px-6 py-2.5 bg-[#2D3139] hover:bg-black text-white rounded-lg text-xs font-bold uppercase tracking-wide transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isUpdating
                        ? "Saving..."
                        : !newNote.trim() && noteReminders.length > 0
                        ? "Save Reminders"
                        : "Add Note"}
                    </button>
                  </div>
                </div>

                {/* Right: Notes + owner comms history */}
                <AgentNotesPanel
                  notes={propertyNotes}
                  comms={ownerComms}
                  loading={notesLoading}
                  subject={property?.address}
                  onDelete={handleDeleteNote}
                  propertyId={property?.id}
                />
              </div>
            </div>
          )}
          {visibleTab === 'photos' && (
            <div className="space-y-6 animate-in fade-in duration-500">
              <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
                <div className="flex items-center justify-between mb-8">
                  <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151]">Property Photos</h3>
                  {!isReadOnly && (
                    <>
                      <button
                        onClick={() => uploadPhotosRef.current?.click()}
                        className="px-5 py-2 bg-[#ECECEC] hover:bg-gray-200 text-[#374151] rounded-md text-[11px] font-bold transition-all flex items-center gap-2"
                      >
                        <Plus className="w-4 h-4" />
                        Upload Photos
                      </button>
                      <input
                        type="file"
                        ref={uploadPhotosRef}
                        className="hidden"
                        multiple
                        accept={SUPPORTED_UPLOAD_ACCEPT}
                        onChange={handleAddImages}
                      />
                      <input
                        type="file"
                        ref={fileInputRef}
                        className="hidden"
                        accept={SUPPORTED_UPLOAD_ACCEPT}
                        onChange={handleFileChange}
                      />
                    </>
                  )}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  {property?.images && property.images.length > 0 ? (
                    property.images.map((img, idx) => (
                      <div
                        key={idx}
                        className="group relative aspect-square bg-gray-100 rounded-xl overflow-hidden cursor-pointer border-2 border-transparent hover:border-[#55C5D0] transition-all duration-300"
                      >
                        <LazyImage
                          src={img?.file || img}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        {/* Hover Overlay - click to replace (opens file dialog) */}
                        {!isReadOnly && (
                          <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleReplaceImage(img);
                              }}
                              className="w-10 h-10 bg-white/90 rounded-full flex items-center justify-center shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 hover:bg-white hover:text-[#55C5D0]"
                            >
                              <Edit className="w-5 h-5 text-[#55C5D0]" />
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="col-span-full aspect-[3/1] flex flex-col items-center justify-center bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
                      <Eye className="w-12 h-12 text-[#374151] opacity-20 mb-2" />
                      <p className="text-[#374151] opacity-50 font-medium">No images available for this property</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {visibleTab === 'open_homes' && (
            <OpenHomesTab propertyId={property?.id} propertyTitle={property?.address || property?.title} />
          )}
          {visibleTab === 'documents' && <PropertyDocumentsPage />}
          {visibleTab === 'compliance' && !isLease && <ComplianceTab propertyId={property?.id || params.id} />}
          {priceReasonModal}
          {visibleTab === 'activity' && <PropertyActivityLog propertyId={property?.id} />}
          {visibleTab === 'buyer_match' && (
            <div className="animate-in zoom-in-95 duration-500">
              <FindBuyersForProperty
                initialProperty={{
                  id: property.id,
                  address: property.address || property.full_address || '',
                  suburb: property.suburb || '',
                  state: property.state || '',
                  price: property.price ?? null,
                  price_to: property.price_to ?? null,
                  beds: property.beds ?? property.bedrooms ?? null,
                  baths: property.baths ?? property.bathrooms ?? null,
                  cars: property.parkings ?? property.car_ports ?? null,
                  property_type: property.property_type || '',
                  portal_category: property.portal_category || '',
                  latitude: property.latitude ?? null,
                  longitude: property.longitude ?? null,
                }}
              />
            </div>
          )}
          {visibleTab === 'renter_match' && (
            <div className="animate-in zoom-in-95 duration-500">
              {renterMatchCount && renterMatchCount.total > 0 && (
                <div className="mb-4 flex flex-wrap gap-3">
                  <div className="px-4 py-3 rounded-xl bg-blue-50 border border-blue-100 min-w-[120px]">
                    <p className="text-2xl font-bold text-blue-700">{renterMatchCount.total}</p>
                    <p className="text-xs font-medium text-blue-600">matching renters</p>
                  </div>
                  <div className="px-4 py-3 rounded-xl bg-green-50 border border-green-100 min-w-[120px]">
                    <p className="text-2xl font-bold text-green-700">{renterMatchCount.strong}</p>
                    <p className="text-xs font-medium text-green-600">strong matches</p>
                  </div>
                  <div className="px-4 py-3 rounded-xl bg-amber-50 border border-amber-100 min-w-[120px]">
                    <p className="text-2xl font-bold text-amber-700">{renterMatchCount.within_30_days}</p>
                    <p className="text-xs font-medium text-amber-600">moving within 30 days</p>
                  </div>
                </div>
              )}
              <FindRentersForProperty
                initialProperty={{
                  id: property.id,
                  address: property.address || property.full_address || '',
                  suburb: property.suburb || '',
                  state: property.state || '',
                  // A lease listing's price/price_to columns hold the WEEKLY
                  // RENT, not a sale price (same convention property_management
                  // .services.open_home uses).
                  rent_min: property.price ?? null,
                  rent_max: property.price_to ?? null,
                  beds: property.beds ?? property.bedrooms ?? null,
                  baths: property.baths ?? property.bathrooms ?? null,
                  property_type: property.property_type || '',
                  portal_category: property.portal_category || '',
                  latitude: property.latitude ?? null,
                  longitude: property.longitude ?? null,
                }}
              />
            </div>
          )}

          {/* Notifications Tab — Buyer Portal email log + suppress toggle */}
          {visibleTab === 'notifications' && (
            <PropertyNotificationsTab propertyId={params.id} />
          )}

          {/* Analytics Tab */}
          {visibleTab === 'analytics' && (
            <div className="animate-in zoom-in-95 duration-500 space-y-4">
              {/* Campaign intelligence: metrics, funnel, buyer intent, health, alerts */}
              <PropertyCampaignDashboard
                propertyId={params.id}
                reaListingId={property?.rea_portal_listing_id || property?.rea_listing_id || ''}
                ownerEmail={property?.owner_email || ''}
                ownerName={property?.owner_preferred_name || property?.owner_name || ''}
              />

              {/* The raw event feed stays underneath for the detail behind the numbers */}
              <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                <div className="mb-6">
                  <h3 className="text-lg font-bold text-[#374151] mb-1 flex items-center gap-2">
                    Activity feed
                  </h3>
                  <p className="text-xs text-[#374151] opacity-60 font-medium">
                    Every buyer interaction as it happened: views, enquiries, saves, and more.
                  </p>
                </div>
                <PropertyAnalyticsTimeline propertyId={params.id} />
              </div>
            </div>
          )}
        </div>
      </div>
      <AddOwnerModal
        isOpen={showOwnerModal}
        onClose={() => setShowOwnerModal(false)}
        onSave={handleSaveOwner}
        loading={isUpdating}
      />
      <AddPurchaserModal
        isOpen={showPurchaserModal}
        onClose={() => {
          setShowPurchaserModal(false);
          setEditingPurchaser(null);
        }}
        onSave={handleSavePurchaser}
        loading={isUpdating}
        initialData={editingPurchaser}
      />

      <AddBuyerModal
        isOpen={showAddBuyerModal}
        onClose={() => setShowAddBuyerModal(false)}
        propertyId={params.id}
        existingContactIds={propertyBuyers.map((b) => b.contact_id)}
        onAdded={refreshPropertyBuyers}
        isLease={isLease}
      />

      {/* Enquiries, Buyers & Attendees all use the same rich server-side composer
          as Find Buyers / Communications (branded email from the agent's Collings
          address, SMS from the COLLINGS sender, templates + merge tags). */}
      {richComposer && (
        <MessageMatchesModal
          channel={richComposer.channel}
          recipients={richComposerRecipients}
          recipientNoun={richComposerNoun}
          // Show the "update preferences" invite here too, to match Communications
          // and Find Buyers (Monday 12975097413). Enquirers have no saved search,
          // but the link now falls back to their contact preferences, so it
          // resolves for them.
          showPreferences={true}
          propertyId={property?.id}
          propertyLabel={property?.display_address || property?.address || ''}
          // Which tab fired this, so the send is filed under THIS listing in
          // the Communications Hub and shows up in its Communications panel
          // instead of disappearing into the Find Buyers pile
          // (Paul Jimoulis, CRM-2026-00072).
          sendContext={richComposer.context}
          currentUser={user}
          onClose={() => setRichComposer(null)}
          onSent={() => setRichComposer(null)}
        />
      )}

      {editingAttendee && (
        <EditAttendeeModal
          attendee={editingAttendee}
          onClose={() => setEditingAttendee(null)}
          onSaved={(updated) =>
            setInspectionAttendees((prev) =>
              prev.map((a) => (a.id === updated.id ? { ...a, ...updated } : a)),
            )
          }
        />
      )}

      {editingBuyer && (
        <EditBuyerModal
          propertyId={params.id}
          buyer={editingBuyer}
          isLease={isLease}
          onClose={() => setEditingBuyer(null)}
          onSaved={(updated) =>
            setPropertyBuyers((prev) =>
              prev.map((b) => (b.link_id === updated.link_id ? { ...b, ...updated } : b)),
            )
          }
        />
      )}

      {/* Buying/renting-preferences editor — opened from any Enquiries /
          Attendees / Buyers row; writes through to the portal preferences +
          stats. A lease property's enquirers are renters, so their
          preferences belong in RentingPreference, not BuyingPreference
          (Christian Gravias, 2026-08-27 - "create Renter Preferences to be
          its own situation, dont mix it with buyers"). */}
      {prefsPerson && (
        isLease ? (
          <RentingPreferencesModal
            identity={prefsPerson}
            title={prefsPerson.name}
            onClose={() => setPrefsPerson(null)}
          />
        ) : (
          <BuyerPreferencesModal
            identity={prefsPerson}
            title={prefsPerson.name}
            onClose={() => setPrefsPerson(null)}
          />
        )
      )}

      <DuplicatePropertyModal
        isOpen={showDuplicateModal}
        onClose={() => !isDuplicating && setShowDuplicateModal(false)}
        property={property}
        loading={isDuplicating}
        onSubmit={handleDuplicateProperty}
      />

      <AddEnquiryModal
        isOpen={showAddEnquiryModal}
        onClose={() => setShowAddEnquiryModal(false)}
        onSubmit={handleAddEnquiry}
      />

      <LeadPreviewModal
        isOpen={!!editingEnquiry}
        onClose={() => setEditingEnquiry(null)}
        enquiry={editingEnquiry}
        mode="view_enquiry"
        loading={isUpdatingEnquiry}
        onSaveEnquiry={handleUpdateEnquiry}
        onAddNote={async (finalNotes) => {
          if (!editingEnquiry?.id) return;
          try {
            await updateEnquiry(editingEnquiry.id, { agent_notes: finalNotes });
            setEnquiries(prev => prev.map(e => e.id === editingEnquiry.id ? { ...e, agent_notes: finalNotes } : e));
            setEditingEnquiry(prev => prev ? { ...prev, agent_notes: finalNotes } : null);
            toast.success("Note added!");
          } catch (err) {
            toast.error("Failed to add note");
          }
        }}
      />

      <LeadPreviewModal
        isOpen={!!viewingOffer}
        onClose={() => setViewingOffer(null)}
        offer={viewingOffer}
        mode="view_offer"
        loading={isUpdatingOffer}
        onSaveOffer={async (formData) => {
          if (!viewingOffer) return;
          setIsUpdatingOffer(true);
          try {
            const { updateOffer } = await import('../../api/propertyManagement');
            const updatePayload = {
              status: formData.status,
              agent_notes: formData.agent_notes,
              offer_amount: formData.offer_amount,
              settlement_days: formData.settlement_days,
              custom_settlement_date: formData.custom_settlement_date || null,
              deposit_amount: formData.deposit_amount,
              counter_amount: formData.counter_amount || null,
            };
            const response = await updateOffer(viewingOffer.id, updatePayload);
            const updatedData = response?.data || updatePayload;
            setOffers((prev) =>
              prev.map((o) => o.id === viewingOffer.id
                ? { ...o, ...updatedData }
                : o
              )
            );
            toast.success('Offer updated!');
            setViewingOffer(null);
          } catch (err) {
            console.error('Failed to update offer:', err);
            toast.error('Failed to update offer.');
          } finally {
            setIsUpdatingOffer(false);
          }
        }}
        onAddNote={async (finalNotes) => {
          if (!viewingOffer?.id) return;
          try {
            const { updateOffer } = await import('../../api/propertyManagement');
            await updateOffer(viewingOffer.id, { agent_notes: finalNotes });
            setOffers(prev => prev.map(o => o.id === viewingOffer.id ? { ...o, agent_notes: finalNotes } : o));
            setViewingOffer(prev => prev ? { ...prev, agent_notes: finalNotes } : null);
            toast.success("Note added!");
          } catch (err) {
            toast.error("Failed to add note");
          }
        }}
        onWorkflowOfferUpdated={(o) => {
          if (!o?.id) return;
          setViewingOffer((prev) => (prev?.id === o.id ? { ...prev, ...o } : prev));
          setOffers((prev) => prev.map((x) => (x.id === o.id ? { ...x, ...o } : x)));
        }}
      />

      <SendToVendorModal
        isOpen={!!sendingToVendor}
        offer={sendingToVendor}
        vendorEmail={vendorStatus?.vendor?.email || vendorStatus?.owner_email}
        vendorName={vendorStatus?.vendor?.name}
        vendorPendingActivation={vendorStatus?.state === 'pending'}
        onClose={() => setSendingToVendor(null)}
        onSent={(data) => {
          setOffers((prev) =>
            prev.map((o) =>
              o.id === data.id
                ? {
                    ...o,
                    status: data.status,
                    status_display: data.status_display,
                    agent_message_to_vendor: data.agent_message_to_vendor,
                    sent_to_vendor_at: data.sent_to_vendor_at,
                  }
                : o,
            ),
          );
          if (vendorStatus?.state === 'not_invited') {
            getPropertyVendorStatus(params.id)
              .then((r) => setVendorStatus(r?.data || null))
              .catch(() => {});
          }
        }}
      />

      <SendToBuyerModal
        isOpen={!!sendingToBuyer}
        offer={sendingToBuyer}
        onClose={() => setSendingToBuyer(null)}
        onSent={(data) => {
          setOffers((prev) =>
            prev.map((o) =>
              o.id === data.id
                ? {
                    ...o,
                    status: data.status,
                    status_display: data.status_display,
                    agent_message_to_buyer: data.agent_message_to_buyer,
                    sent_to_buyer_at: data.sent_to_buyer_at,
                  }
                : o,
            ),
          );
        }}
      />

      <CounterToBuyerModal
        isOpen={!!counteringToBuyer}
        offer={counteringToBuyer}
        onClose={() => setCounteringToBuyer(null)}
        onSent={(data) => {
          setOffers((prev) =>
            prev.map((o) =>
              o.id === data.id
                ? {
                    ...o,
                    status: data.status,
                    status_display: data.status_display,
                    counter_amount: data.counter_amount,
                    deposit_amount: data.deposit_amount,
                    settlement_days: data.settlement_days,
                    custom_settlement_date: data.custom_settlement_date,
                    agent_message_to_buyer: data.agent_message_to_buyer,
                    sent_to_buyer_at: data.sent_to_buyer_at,
                  }
                : o,
            ),
          );
        }}
      />

      <OfferTimelineModal
        isOpen={!!timelineOffer}
        offer={timelineOffer}
        onClose={() => setTimelineOffer(null)}
      />

      <Dialog open={!!finalizingOffer} onOpenChange={(open) => !open && setFinalizingOffer(null)}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Confirm Mutual Acceptance</DialogTitle>
            <DialogDescription>
              {finalizingOffer && (
                <>
                  Move offer <strong>{finalizingOffer.reference_number}</strong> to <strong>Accepted</strong> and mark the
                  property as <strong>Under Contract</strong>. This will automatically expire any other open offers on
                  this listing and notify the buyer and vendor by email.
                </>
              )}
            </DialogDescription>
          </DialogHeader>
          <div className="py-2">
            <label className="text-xs font-bold uppercase tracking-wider text-gray-600 mb-1 block">
              Optional note (visible to buyer + vendor)
            </label>
            <textarea
              id="finalize-note-property-detail"
              className="w-full border-2 border-gray-100 rounded-xl p-3 bg-gray-50 min-h-[80px] text-sm focus:bg-white focus:border-emerald-500 transition-all outline-none resize-none"
              placeholder="e.g. Contracts will be issued today."
            />
          </div>
          <DialogFooter className="gap-2">
            <DialogClose asChild>
              <button
                type="button"
                disabled={finalizing}
                className="px-4 py-2 rounded-lg border-2 border-gray-200 text-gray-700 text-xs font-bold uppercase tracking-wider hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
            </DialogClose>
            <button
              type="button"
              disabled={finalizing}
              onClick={async () => {
                if (!finalizingOffer) return;
                setFinalizing(true);
                try {
                  const note = document.getElementById('finalize-note-property-detail')?.value || '';
                  const res = await confirmMutualAcceptance(finalizingOffer.id, { note });
                  const data = res?.data || {};
                  try {
                    const refresh = await getPropertyOffers(params.id);
                    setOffers(refresh.data?.results || []);
                  } catch (_) {
                    setOffers((prev) =>
                      prev.map((o) =>
                        o.id === finalizingOffer.id
                          ? { ...o, status: data.status || 'ACCEPTED', status_display: data.status_display || 'Accepted' }
                          : o,
                      ),
                    );
                  }
                  toast.success(
                    `Offer accepted. Property is now Under Contract${
                      data.expired_other_offers ? `. ${data.expired_other_offers} other offer(s) expired.` : '.'
                    }`,
                  );
                  setFinalizingOffer(null);
                } catch (err) {
                  toast.error(err?.response?.data?.detail || 'Failed to confirm mutual acceptance.');
                } finally {
                  setFinalizing(false);
                }
              }}
              className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-emerald-700 transition-colors disabled:opacity-50"
            >
              {finalizing ? 'Confirming…' : 'Confirm & Move to Under Contract'}
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}